export default {
  staffBot: {
    title: "Бот для сотрудников",
    subtitle: "Загрузка документов через Telegram и уведомления о задачах",
    connected: "Бот подключён",
    error: "Ошибка",
    disconnect: "Отключить",
    disconnectConfirm: "Отключить бота? Сотрудникам придётся подключаться заново.",
    youLinked: "Ваш Telegram подключён",
    howToLink: "Откройте бота, нажмите /start и отправьте свой номер — подключение по номеру в системе.",
    featureDocs: "Фото или PDF + в подписи номер клиента (#123) — файл попадает в нужное поле-документ сделки",
    featureCard: "Номер клиента в сообщении — его сделки, этап и долг",
    featureTasks: "Новые задачи приходят с кнопкой «Выполнено», /tasks — задачи на сегодня",
    connectHint: "Создайте бота в @BotFather (/newbot) и вставьте токен сюда. Этот бот не для клиентов — только для сотрудников.",
    connect: "Подключить",
    notConnected: "Бот ещё не подключён. Обратитесь к администратору.",
  },
  dealFinance: {
    tab: "Взаиморасчёты",
    title: "Оплаты",
    agreed: "Договорная сумма",
    extra: "Доп. продажи",
    paid: "Оплачено",
    debt: "Долг",
    addPayment: "Добавить платёж",
    addCharge: "Доп. продажа",
    extraSale: "доп. продажа",
    delete: "Удалить",
    deleteConfirm: "Удалить? Долг будет пересчитан",
    error: "Ошибка",
    paymentAdded: "Платёж добавлен",
    chargeAdded: "Доп. продажа добавлена",
    cancel: "Отмена",
    save: "Сохранить",
    amount: "Сумма",
    date: "Дата",
    methodLabel: "Способ оплаты",
    method: {
      cash: "Наличные",
      transfer: "Перевод",
      card: "Карта",
    },
    note: "Комментарий",
    chargeHint: "Договорная сумма не меняется — сумма доп. услуги добавляется к долгу.",
    chargeTitle: "Название услуги",
    valueLocked: "Договорную сумму может менять только администратор",
    payments: "Поступления",
    debts: "Должники",
    from: "С",
    to: "По",
    allMethods: "Все способы",
    allFunnels: "Все воронки",
    received: "Всего поступило",
    noPayments: "За период платежей нет",
    export: "Excel (CSV)",
    totalDebt: "Общий долг",
    debtors: "Должников",
    noDebts: "Должников нет",
    lastPayment: "последний платёж",
    client: "Клиент",
    deal: "Сделка",
    stage: "Этап",
    acceptedBy: "Принял",
    phone: "Телефон",
  },
  stageRules: {
    title: "Правила этапа",
    requiredCount: "обязательных полей: {n}",
    autoTaskOn: "автозадача",
    requiredFields: "Обязательные поля для перехода",
    requiredHint: "Сделка перейдёт на этот этап только после заполнения этих полей. Для полей-файлов нужно загрузить документ.",
    noFields: "Поля сделки ещё не созданы",
    valueField: "Сумма",
    autoTask: "Создавать задачу при входе на этап",
    taskTitle: "Текст задачи, например: Снять видео-отзыв",
    toDealOwner: "Ответственному по сделке",
    dueIn: "Срок: через",
    days: "дн.",
    modalTitle: "Сначала заполните",
    modalHint: "Для перевода на этот этап обязательно:",
    chooseFile: "Выбрать файл",
    removeFile: "Убрать файл",
    uploadFailed: "Файл не загрузился",
    yes: "Да",
    select: "Выберите",
    cancel: "Отмена",
    saveAndMove: "Сохранить и перевести",
    bulkBlocked: "Не перенесено сделок: {n} — не заполнены обязательные поля",
    fromEnterDay: "от дня входа на этап",
    fromField: "от даты «{name}»",
    leadStage: "Первый этап — лиды",
    leadStageHint: "Сюда попадают новые обращения, на карточках виден ярлык «Лид». Выключите для воронок услуг, куда сделки передаются из другой воронки.",
    renewalTitle: "Автосделка по сроку",
    renewalHint: "Когда дата в выигранной сделке подходит к концу (например, окончание ВНЖ), для клиента открывается сделка в выбранной воронке и ответственному ставится задача. Один раз на каждую дату.",
    renewalEnabled: "Включено",
    renewalDateField: "Поле с датой",
    renewalDays: "За сколько дней",
    renewalFunnel: "В какую воронку",
    renewalStage: "На какой этап",
    renewalTask: "Текст задачи",
    renewalTaskPlaceholder: "Например: Предложить продление",
    save: "Сохранить",
  },
  notif: { title: "Уведомления", subtitle: "Кто, когда и что сделал", markAll: "Прочитать все", empty: "Уведомлений нет", seeAll: "Показать все", loadError: "Ошибка загрузки" },
  common: { selectPlaceholder: "Выберите...", searchPlaceholder: "Поиск...", noResults: "Ничего не найдено" },
  proc: {
    title: "Мои процессы", subtitle: "Процессы, которые нужно выполнить",
    countSuffix: "процессов", logout: "Выйти", refresh: "Обновить",
    saved: "Сохранено", loadError: "Ошибка загрузки",
    problemTitle: "В чём проблема?", problemPlaceholder: "Кратко опишите проблему…", problemSubmit: "Отправить", problemRequired: "Опишите проблему", cancel: "Отмена",
  
    empty: "Нет процессов",
  
    emptyHint: "Назначенные вам процессы появятся здесь",
  
    filesTitle: "Эскиз / файлы",
  
    archiveTitle: "Архив",
  
    backToWork: "Вернуться к работам",
  
    archiveEmpty: "Архив пуст",
  
    archiveEmptyHint: "Завершённые работы хранятся здесь",
  
    proposalTag: "Предложение",
  
    tabWork: "Мои работы",
  
    tabRequests: "Запрос денег",
  
    tabArchive: "Архив",
  },

  snab: {
    title: "Мои заявки", subtitle: "Документы, которые нужно привезти",
    createReceipt: "Создать приход", tabProducts: "Товары", tabSuppliers: "Поставщики", suppliersEmpty: "Поставщиков нет", needQty: "Нужно", buy: "Купить", zoom: "Увеличить", tabRequests: "Заявка на деньги", needBy: "Срок:", noItems: "Нет позиций",
    logout: "Выйти", refresh: "Обновить", loadError: "Ошибка загрузки",
  
    empty: "Нет заявок",
  
    emptyHint: "Назначенные вам открытые заявки появятся здесь",
  },

  roles: {
    title: "Роли", subtitle: "Кастомные роли — управление видимостью модулей, действиями и данными",
    addRole: "Добавить роль", editRole: "Редактировать роль", name: "Название роли", namePlaceholder: "Например: Продавец, Кладовщик...", nameRequired: "Название роли обязательно",
    modulesSection: "Модули и действия", module: "Модуль", actionView: "Прос", actionCreate: "Доб", actionEdit: "Ред", actionDelete: "Уд",
    dataFlagsSection: "Скрываемые данные", dataFlagsHint: "Отмеченные данные скрываются для этой роли (телефон, email, сумма сделки...)",
    ownSection: "Показывать только свои", ownHint: "В отмеченных разделах пользователь видит только созданные им документы (не чужие).",
    save: "Сохранить", cancel: "Отмена", delete: "Удалить", deleteTitle: "Удалить роль", deleteText: "роль будет удалена. Пользователи этой роли вернутся к полному доступу.",
    added: "Роль добавлена", updated: "Роль обновлена", deleted: "Роль удалена", loadError: "Ошибка загрузки", genericError: "Произошла ошибка",
    empty: "Ролей нет", modulesCount: "модулей", hiddenCount: "скрыто",
    restricted: "Эти данные вам недоступны",
    prodSubActionsLabel: "Производство: отдельные права ввода",
    prodEditOutputs: "Ввод партий готовой продукции",
    prodEditComponents: "Ввод расхода сырья",
    flags: {
      contacts_phone: "Телефон контакта", contacts_email: "Email контакта", deals_value: "Сумма сделки",
      products_costPrice: "Себестоимость (цена закупки)", products_avgCost: "Средняя себестоимость", products_margin: "Маржа / наценка", inventory_stockValue: "Стоимость остатка",
      sklad_valuation: "Стоимость склада (общая себест.)", sklad_unitCost: "Себестоимость единицы",
      finance_pnl: "Прибыль и убыток (P&L)", finance_companyBalance: "Баланс предприятия", finance_cashboxBalance: "Балансы касс", finance_netProfit: "Чистая прибыль", finance_cogs: "Себестоимость (COGS)", finance_debtsTotals: "Суммы задолженности",
      cashbox_balance: "Баланс кассы", cashbox_turnover: "Оборот кассы",
      jobOrder_summary: "Суммы заказа (статистика + согласовано/оплачено/долг)", jobOrder_profit: "Прибыль заказа", jobOrder_totalCost: "Себестоимость заказа", jobOrder_laborCost: "Затраты на оплату труда", jobOrder_materialCost: "Затраты на материалы",
      jobOrder_lockBasic: "Запретить изменение основных данных", jobOrder_lockProcesses: "Запретить изменение процессов", jobOrder_lockMaterials: "Запретить изменение расходов", jobOrder_lockFiles: "Запретить изменение файлов", jobOrder_lockDelete: "Запретить удаление заказа",
      jobOrder_otherExpenses: "Скрыть раздел прочих расходов", jobOrder_otherExpensesEdit: "Запретить добавление прочих расходов", jobOrder_otherExpensesDelete: "Запретить удаление прочих расходов",
      jobOrder_lockConfirm: "Запретить подтверждение заказа", jobOrder_lockStart: "Запретить перевод в работу", jobOrder_lockComplete: "Запретить завершение заказа",
      proposal_cost: "Себестоимость предложения", proposal_margin: "Маржа предложения",
      reports_inventoryValue: "Отчёт: стоимость склада", reports_profitColumns: "Отчёт: столбцы прибыли",
    },
  },

  dtp: { now: "Сейчас", done: "Готово" },
  picker: { placeholder: "Товар...", search: "Поиск...", notFound: "Не найдено" },
  catPicker: { all: "Все", back: "Назад", empty: "Пусто", count: "{n} шт" },
  update: { title: "Доступна новая версия", subtitle: "Обновите страницу", action: "Обновить", dismiss: "Закрыть" },


  production: {
    loadError: "Ошибка загрузки", error: "Ошибка", cancel: "Отмена", save: "Сохранить", saved: "Обновлено", added: "Добавлено", deleted: "Удалено", movedToTrash: "Перемещено в корзину", toTrash: "В корзину", delete: "Удалить", back: "Назад", selectPlaceholder: "Выберите...", row: "Строка", addRow: "Добавить строку", print: "Печать", printTitle: "Печать", unitSuffix: "шт",
    prodLabel: "Производство", prodSubtitle: "Из сырья — готовая продукция", pkgLabel: "Упаковка", pkgSubtitle: "Упаковка готовой продукции",
    searchPlaceholder: "Номер или товар...", new: "Новый", notFound: "Документ не найден", notFoundHint: "Создайте новый документ", newBlank: "Создать пустой", newFromRecipe: "По рецепту", recipe: "Рецепт", norma: "Норма (сколько раз)", normaHint: "Рецепт умножается на это число (1 норма = 1 рецепт) — сырьё и выход записываются соответственно.", noRecipes: "Нет рецептов. Сначала добавьте в разделе Рецепты (BOM).", recipePickFirst: "Выберите рецепт",
    thNumber: "Номер", thDate: "Дата", thOutput: "Готовая продукция", thOut: "Выход", thCost: "Себестоимость", thUnit: "Единица", thStatus: "Статус", thActions: "Действия", outLabel: "Выход:",
    trashTitle: "Перемещение в корзину", trashText1: "документ будет перемещён в корзину. Остаток сырья и готовой продукции вернётся (можно восстановить в течение 30 дней).",
    docLoadError: "Документ не загружен", bomSelectProductFirst: "Сначала выберите готовую продукцию", bomQtyFirst: "Введите количество выхода", bomNotFound: "Для этого товара рецепт не найден", bomLoaded: "Рецепт загружен", whRequired: "Нужно выбрать склады", outProductRequired: "Нужно выбрать готовую продукцию", outQtyInvalid: "Неверное количество выхода", minOneComponent: "Введите хотя бы одно сырьё", costShare: "Доля стоимости", costShareAuto: "авто", costShareHint: "Если доля не указана — общая стоимость распределяется автоматически по количеству выхода. Если указать доли — пропорционально этим весам.", outAllocCost: "Стоимость", outputsCount: "продукта", removeRow: "Удалить строку", lotLabel: "Партия:", lotCol: "Партия", lotAuto: "Авто (самая старая)", lotNoLabel: "Без партии", lotLeft: "остаток", uomRequired: "Выберите единицу измерения", compProductRequired: "Выберите сырьё", compQtyRequired: "Введите количество сырья", colCashbox: "Касса (нал.)", overheadNoCash: "— (только в себестоимость)", overheadCashHint: "Если выбрана касса — расход списывается наличными из неё и виден в карточке кассы. В себестоимость входит всё равно; в Платежи/P&L отдельно не пишется (без двойного счёта).", addGroup: "Группа", newGroup: "Новая группа", groupNamePlaceholder: "Название группы", removeGroup: "Удалить группу", moveTo: "Переместить", moveToUngrouped: "Без группы", addBatch: "Добавить партию", batchTime: "Время", batchTotal: "Итого", grandTotalLabel: "Всего готовой продукции:", normaTitle: "Норма", normaPerUnit: "сырья на", normaAdd: "Добавить сырьё",
    componentsTitle: "Сырьё (расход)", noComponents: "Нет строк сырья", colProduct: "Товар", colQty: "Количество", colUom: "Единица", colEstCost: "Прибл. себест.", uomPlaceholder2: "единица", costInline: "Себест.:", stockInStock: "Склад:",
    costTitle: "Себестоимость (примерно)", costMaterials: "Сырьё", costOverhead: "Доп. расходы", costTotal: "Итого себестоимость", costUnit: "Себест. единицы", costNote: "При сохранении фактическая себестоимость определяется методом FIFO/средней, и avgCost готовой продукции обновляется на этой основе.", note: "Комментарий", optional: "Необязательно...",
    trashText2: "Документ будет перемещён в корзину. Остаток сырья и готовой продукции вернётся (можно восстановить в течение 30 дней).",
    bomMahsulotRequired: "Нужно выбрать товар", bomMinOneComponent: "Хотя бы одна строка состава", bomOutQtyInvalid: "Неверное количество выхода", bomEditTitle: "Редактировать рецепт", bomNewTitle: "Новый рецепт (BOM)", bomKind: "Тип", bomOutProduct: "Готовая продукция", bomOutQty: "Количество выхода", bomOutQtyHint: "Этот рецепт на указанное количество готовой продукции", bomUom: "Единица", bomComponents: "Сырьё", bomNoRows: "Нет строк", bomColUom: "Единица", bomColNote: "Комментарий", bomColCategory: "Категория", bomOverheadHint: "Если выбрать категорию, привяжется к категории расхода в Платежах (в отчётах отображается объединённо).",
    bomTitle: "Рецепты (BOM)", bomNavShort: "Рецепты", recipeSaveBtn: "Сохранить рецепт", recipeSaveTitle: "Сохранить текущую форму как рецепт", recipeSaveHint: "Текущие готовая продукция, сырьё и расходы сохранятся как рецепт. Потом 'По рецепту' + норма автоматически заполнит эти данные.", recipeName: "Название рецепта", recipeNamePlaceholder: "Например: Хлеб (стандарт)", recipeNameRequired: "Введите название рецепта", recipeSaved: "Рецепт сохранён", bomSubtitle: "Рецепты сырья для готовой продукции", all: "Все", bomSearchPlaceholder: "Товар...", bomNewBtn: "Рецепт", bomEmpty: "Нет рецептов", bomThProduct: "Товар", bomThKind: "Тип", bomThOut: "Выход", bomThComposition: "Состав", bomThOverhead: "Доп.рас.", componentsCount: "видов сырья", overheadShort: "Доп.рас.:", bomDeleteTitle: "Удалить рецепт", bomDeleteText: "рецепт будет полностью удалён.",
  
    fromWh: "Склад сырья (откуда)",
  
    toWh: "Склад готовой продукции (куда)",
  
    outputCard: "Готовая продукция",
  
    applyBomTitle: "Загрузить сырьё из рецепта выбранного товара",
  
    applyBom: "Загрузить из рецепта",
  
    product: "Товар",
  
    outProductPlaceholder: "Готовая продукция...",
  
    qty: "Количество",
  
    uom: "Единица",
  
    uomPlaceholder: "шт, кг...",
  
    batchNo: "Партия №",
  
    batchPlaceholder: "(необязательно)",
  
    expiry: "Срок годности",
  
    overheadTitle: "Дополнительные расходы (необязательно)",
  
    noOverhead: "Строк нет (зарплата, электричество, амортизация и т.д.)",
  
    colCategory: "Категория (из кассы)",
  
    colName: "Название",
  
    colAmount: "Сумма",
  
    catManual: "— (вручную)",
  
    overheadNamePlaceholder: "Зарплата, Электричество...",
  
    amountPlaceholder: "Сумма",
  
    overheadHint: "Если выбрать категорию, расход привяжется к категории расходов в Платежах (в отчётах отображается объединённо). Категорию можно создать в Финансы → Платежи.",
  
    ppProdTitle: "ПРОИЗВОДСТВЕННЫЙ ДОКУМЕНТ",
  
    ppPkgTitle: "ДОКУМЕНТ УПАКОВКИ",
  
    ppDate: "Дата:",
  
    ppRawWh: "Склад сырья:",
  
    ppFinishedWh: "Склад готовой продукции:",
  
    ppFinished: "Готовая продукция:",
  
    ppBatch: "Партия №:",
  
    ppExpiry: "Срок годности:",
  
    ppComponents: "Сырьё",
  
    ppColNum: "№",
  
    ppColName: "Название",
  
    ppColQty: "Количество",
  
    ppColUom: "Ед. изм.",
  
    ppColUnitCost: "Себестоимость ед.",
  
    ppColSum: "Сумма",
  
    ppMaterialsTotal: "Итого сырья:",
  
    ppOverhead: "Дополнительные расходы",
  
    ppOverheadTotal: "Итого допрасходов:",
  
    ppTotalCost: "Общая себестоимость:",
  
    ppUnitCost: "Себестоимость единицы:",
  
    ppNote: "Примечание:",
  
    ppSignMaker: "Изготовитель (подпись)",
  
    ppSignReceiver: "Принял (подпись)",
  },

  scheduled: {
    title: "Обязательные платежи", subtitle: "Шаблоны платежей, которые нужно оплачивать каждый месяц.",
    new: "Новый платёж", add: "Добавить", edit: "Изменить", delete: "Удалить",
    name: "Название", namePlaceholder: "Аренда офиса, Электричество...",
    amount: "Сумма", dayOfMonth: "Число месяца", dayHint: "(1–28)",
    cashbox: "Касса", category: "Категория", counterparty: "Контрагент", note: "Примечание",
    optional: "необязательно",
    statusPaid: "Оплачено", statusPending: "Ожидает", statusOverdue: "Просрочено",
    lastPaid: "Последняя оплата",
    payBtn: "Создать расход", payTitle: "Создать платёж", payDate: "Дата", payConfirm: "Создать платёж",
    paySuccess: "Платёж создан", payError: "Произошла ошибка",
    deleteConfirm: "Удалить шаблон?", deleted: "Удалено",
    saved: "Сохранено", loadError: "Ошибка загрузки",
    empty: "Нет обязательных платежей", emptyHint: "Добавьте ежемесячные расходы",
    active: "Активен", inactive: "Неактивен", toggleActive: "Изменить статус",
    every: "Каждого", dayLabel: "-го числа",
    totalMonth: "Всего обязательных платежей", totalPaid: "Оплачено", totalRemain: "Остаток",
    itemsCount: "шт",
  },
  payReq: {
    title: "Заявки", subtitle: "Денежные заявки сотрудников.", new: "Заявка", newTitle: "Новая заявка",
    send: "Отправить", sent: "Заявка отправлена", cancel: "Отмена", amount: "Сумма", amountInvalid: "Неверная сумма",
    note: "Примечание", notePlaceholder: "Для чего нужно...", paymentMethod: "Форма оплаты", paymentMethodPlaceholder: "Наличные / Карта / Перечисление...", pmCash: "Наличные", pmCard: "Карта", pmTransfer: "Перечисление", jobOrder: "Заказ", optional: "необязательно", searchPlaceholder: "Номер или клиент...", notFound: "Не найдено", noteRequired: "Примечание обязательно",
    loadError: "Ошибка загрузки", error: "Ошибка", empty: "Заявок нет", emptyHint: "Добавьте новую заявку",
    byFinance: "Финансы:", reason: "Причина:", approve: "Подтвердить", approved: "Подтверждено", markPaid: "Оплачено", approveTitle: "Подтвердить заявку", approveHint: "Укажите разрешённую сумму. Это ещё не оплата.", approvedAmount: "Утверждённая сумма", requested: "Запрошено", statTotal: "Всего заявок", statApproved: "Утверждено", statPaid: "Выдано", statRejected: "Отклонено", reject: "Отклонить",
    rejectTitle: "Отклонить заявку", rejectReasonLabel: "Причина отклонения (необязательно):", rejectReasonPlaceholder: "Причина...",
    rejected: "Отклонено", delete: "Удалить", deleteConfirm: "Удалить заявку?", deleted: "Удалено",
    tabs: { pending: "В ожидании", approved: "Подтверждено", paid: "Оплачено", rejected: "Отклонено", all: "Все" },
    status: { pending: "В ожидании", approved: "Подтверждено", paid: "Оплачено", rejected: "Отклонено" },
  },
  integrations: { back: "Назад",
    title: "Интеграции", subtitle: "Подключайте интеграции с другими сервисами.",
    saved: "Сохранено", error: "Ошибка", on: "Включено", enable: "Включить", disable: "Выключить", activeSuffix: "активно", off: "Выключено", soon: "Скоро", configure: "Настроить", eskizConn: "Подключение", eskizOk: "Подключено", eskizEmail: "Email", eskizPassword: "Пароль", eskizPassKeep: "Оставьте пустым, чтобы не менять", eskizFrom: "Отправитель (nick)", eskizFromHint: "Для теста 4546. Реальный ник подтверждается в Eskiz.", eskizSave: "Сохранить и подключить", eskizTest: "Тест SMS", eskizPhone: "Телефон", eskizMessage: "Сообщение", eskizSendTest: "Отправить тест", eskizTestHint: "Стандартный текст «Это тест от Eskiz» одобрен. Свой текст добавьте на модерацию: my.eskiz.uz → СМС → Мои тексты.", eskizEmailReq: "Введите email", eskizPhoneReq: "Введите номер телефона", eskizConnected: "Eskiz подключён", eskizSent: "SMS отправлено", smsRulesTitle: "SMS-уведомления", smsRulesHint: "При событии клиенту автоматически отправляется SMS (текст должен быть одобрен в Eskiz).", smsPlaceholders: "Подстановки", smsTplPlaceholder: "Например: Уважаемый {customer}, заказ {number} принят.", smsRulesSave: "Сохранить уведомления", tabSettings: "Настройки", tabHistory: "История", balTitle: "Баланс SMS", balTotal: "Общий баланс", balPrice: "Цена 1 SMS", balSave: "Сохранить баланс", balLow: "Мало баланса!", balLowHint: "Баланс меньше цены одного SMS. Пополните.", histEmpty: "SMS ещё не отправлялись", evtJoCreated: "При создании заказа (job order)", evtJoDelivered: "При завершении заказа (job order)", evtSaleCreated: "При создании продажи (накладная)", evtPayIncoming: "При получении оплаты",
    cat: { sms: "SMS", hr: "HR" },
    svc: { "hr-line": "Управление персоналом (HR Line)", "sms-eskiz": "Отправка SMS (eskiz.uz)", "sms-playmobile": "SMS-шлюз (Play Mobile)", "hr-attendance": "Учёт посещаемости", "hr-payroll": "Расчёт зарплаты" },
  },
  finance: { total: "Итого", debtsTitle: "Долги", debtsSubtitle: "Дебиторы и кредиторы (баланс контрагентов)", none: "Нет", debtors: "Дебиторы", debtorsHint: "Должны нам", creditors: "Кредиторы", creditorsHint: "Мы должны", pfDocLoadError: "Документ не загружен", pfCpRequired: "Нужно выбрать контрагента", pfCashboxRequired: "Нужно выбрать кассу", pfAmountInvalid: "Неверная сумма", pfDateInvalid: "Неверная дата (DD/MM/YYYY HH:MM)", pfHeaderTitle: "Платежи", pfFromRequest: "Этот расход создаётся на основе заявки:", pfPrint: "Печать", pfPrintTitle: "Печать", pfAddAnother: "Добавить ещё приход", pfAddAnotherTitle: "Добавить ещё приход для этого заказа (из другой кассы)", pfJoRemainTitle: "По заказу есть остаток долга", pfJoRemainHint: "Платёж сохранён. Если клиент хочет оплатить и в другую кассу, нажмите «Добавить ещё приход».", pfDateLabel: "Дата:", pfStatusless: "Без статуса", pfCpLabel: "Контрагент *", pfNewCpTitle: "Добавить контрагента", pfCashboxLabel: "Касса *", pfCashboxSelect: "Выберите кассу...", pfBalance: "Баланс:", pfAmountLabel: "Сумма *", pfCategoryLabel: "Категория", pfManage: "Управление", pfCategoryless: "Без категории", pfJobOrder: "Заказ", pfJobOrderHint: "Если выбрать, платёж привяжется к балансу этого заказа. Пусто — обычный приход.", pfProcess: "Процесс (труд)", pfProcessHint: "Сумма платежа запишется в труд этого процесса.", pfProcessRequired: "Нужно выбрать процесс", pfProcessCurrencyMismatch: "Валюта платежа должна совпадать с валютой заказа", pfOptional: "необязательно", pfNote: "Примечание", pfNotePlaceholder: "Примечание (необязательно)...", pfJoTotal: "Сумма заказа", pfJoPaid: "Оплачено", pfJoRemaining: "Остаток", pfJoHistory: "История платежей", pfJoNoPayments: "Платежей пока нет", pfJoLoading: "Загрузка...", pfDeleteText: "Платёж будет удалён, баланс контрагента восстановлен.", pfNameLabel: "Название *", pfNamePlaceholder: "Название", pfCommissionAdd: "Добавить комиссию", pfCommission: "Комиссия (2-й расход)", pfCommissionPct: "Процент", pfSecondAdd: "Разделить на 2-ю кассу", pfSecondTitle: "Приход во 2-ю кассу (наличные + карта)", pfSecondCashboxLabel: "2-я касса", pfSecondAmountLabel: "Сумма 2-й кассы", pfSecondRemove: "Отмена", pfSecondCashboxRequired: "Нужно выбрать 2-ю кассу", pfSecondSameCashbox: "2-я касса должна отличаться", pfSecondInvalid: "Неверная сумма 2-й кассы", pfCommissionInvalid: "Неверная сумма комиссии", pfCommissionEmpty: "Категории комиссии не заданы — выберите через «Управление».", pfCommissionMgrTitle: "Категории комиссии", pfCommissionMgrHint: "Отмеченные категории расхода доступны для выбора в комиссии.",
    loadError: "Ошибка загрузки", cancel: "Отмена", save: "Сохранить", add: "Добавить", saved: "Обновлено", added: "Добавлено", deleted: "Удалено", error: "Ошибка", delete: "Удалить", deleteTitle: "Подтвердите удаление", nameRequired: "Название обязательно", search: "Поиск...", notFound: "Не найдено", selectCp: "Выберите контрагента...", loadMore: "Загрузить ещё", clearSelection: "Очистить выбор", edit: "Редактирование", back: "Назад", kirim: "Приход", chiqim: "Расход", insufficient: "Недостаточно средств в кассе",
    thName: "Название", thCurrency: "Валюта", thBranch: "Филиал", thBalance: "Баланс", thActions: "Действия", thNumber: "Номер", thDate: "Дата", thType: "Тип", thCp: "Контрагент", thCashbox: "Касса", thCategory: "Категория", thAmount: "Сумма", thStatus: "Статус", thDesc: "Описание", thDirection: "Направление",
    cbReportLoadError: "Ошибка загрузки отчёта", cbBase: "Основная", cbTitle: "Баланс предприятия", cbSubtitle: "Чистая стоимость по каждой валюте (net worth)", noData: "Нет данных", cbGrandTotal: "Общая чистая стоимость (в пересчёте на {base})", cbConvertedNote: "Другие валюты рассчитаны по курсам организации", cbRatesLabel: "Курс", cbInventory: "Складские остатки (себестоимость)", cbInventoryHint: "Сырьё и готовая продукция", cbReceivables: "Дебиторская задолженность", cbReceivablesHint: "Деньги, которые заплатят контрагенты", cbCash: "Деньги в кассах", cbCashHint: "Кассы в этой валюте", cbPayables: "Долг перед контрагентами", cbPayablesHint: "Долг, который нужно выплатить контрагентам", cbFormula: "Формула: Себестоимость склада + Дебиторская задолженность + Деньги в кассах − Долг перед контрагентами. Себестоимость склада хранится только в основной валюте ({base}).",
    pnlTitle: "P&L (Прибыль и убыток)", pnlSubtitle: "Выручка → Себестоимость → Валовая прибыль → Расходы → Чистая прибыль (в основной валюте)", pnlReport: "P&L отчёт", pnlRevenue: "Выручка (продажи)", pnlCogs: "− Себестоимость", pnlGross: "= Валовая прибыль", pnlOpex: "− Операционные расходы", pnlOperating: "= Операционная прибыль", pnlFinancial: "− Финансовые расходы (проценты/банк)", pnlSecLabel: "Раздел P&L", pnlSecHint: "Операционные — обычные расходы; Финансовые — проценты/кредиты; Исключено — оплата поставщику/долг.", pnlSec_operating: "Операционные", pnlSec_financial: "Финансовые", pnlSec_excluded: "Исключено", pnlNet: "≡ Чистая прибыль", pnlNote: "Примечание: Себестоимость на основе текущей себестоимости (примерно). Налоги и кредиты не учитываются.", pnlExpenseDetail: "Детализация операционных расходов", pnlNoExpense: "Нет расходных платежей", pnlCashFlow: "Денежный поток (дополнительно)", pnlCashFlowHint: "Движение по кассе, не влияет на P&L", pnlNetFlow: "Чистый поток",
    cbxCurrencyRequired: "Нужно выбрать валюту", cbxEditTitle: "Редактировать кассу", cbxNewTitle: "Новая касса", cbxNameLabel: "Название *", cbxNamePlaceholder: "Название кассы", cbxCurrencyLabel: "Валюта *", cbxBranchLabel: "Филиал", cbxBranchNone: "— Не выбрано —", cbxBranchHint: "Филиалы добавляются в разделе Настройки → Предприятие.", cbxTitle: "Кассы", cbxSubtitle: "Список касс", cbxAdd: "Добавить кассу", cbxNotFound: "Касса не найдена", cbxNotFoundHint: "Добавьте новую кассу", cbxDeleteText: "касса будет удалена.",
    ccTitle: "Карточка кассы", ccNotFound: "Касса не найдена", ccBackToList: "Назад к списку", ccConversion: "Конвертация", ccReceipt: "Наличный приход (закупка)", ccOverhead: "Производственный расход", ccConvOut: "(расход)", ccConvIn: "(приход)", ccCurrentBalance: "Текущий баланс", ccJournal: "Журнал движений", ccNoMovements: "Нет движений",
    convCashboxesRequired: "Нужно выбрать кассы", convSameCashbox: "Нельзя выбрать одну и ту же кассу", convSameCurrency: "Нельзя конвертировать в ту же валюту", convTransferMode: "Перемещение (без курса, 1:1)", convTransferTitle: "Перемещение между кассами", convTransferBtn: "Переместить", convTransferTag: "Перемещение", convFromAmountInvalid: "Неверная сумма к выдаче", convRateRequired: "Введите курс", convDone: "Конвертация выполнена", convEditTitle: "Редактировать конвертацию", convNewTitle: "Новая конвертация", convFrom: "Из кассы", convSelect: "Выберите...", convBalance: "Баланс:", convGive: "Выдаётся (сумма)", convTo: "В кассу", convRate: "Курс", convReverse: "Обратный", convReceive: "Получается", convAuto: "(автоматически)", convDoBtn: "Выполнить", convTitle: "Конвертация", convSubtitle: "Перевод валюты из кассы в кассу", convNewBtn: "Конвертация", convNotFound: "Конвертация не найдена", convNotFoundHint: "Создайте новую конвертацию", convThGive: "Выдаётся", convThReceive: "Получается", convDeleteText: "конвертация будет удалена. Балансы касс восстановятся.",
    payTitle: "Платежи", paySubtitle: "Приход и расход денег", paySearch: "Номер или контрагент...", payFilterCp: "Контрагент", payFilterCashbox: "Все кассы", payFilterCategory: "Все категории", payIncoming: "Приход денег", payOutgoing: "Расход денег", payNotFound: "Платёж не найден", payNotFoundHint: "Создайте приход или расход денег", payDeleteText: "платёж будет удалён. Баланс контрагента восстановится.",
    pfIncomingTitle: "Приходный платёж", pfOutgoingTitle: "Расходный платёж", pfJoSelect: "Выберите заказ...", pfClearSelection: "— Очистить выбор —", pfJoSearch: "Номер или клиент...", pfNewCp: "Новый контрагент", cpAdded: "Контрагент добавлен", pfPhone: "Телефон", pfPhonePlaceholder: "+998 ...", smTitle: "Управление статусами", smNew: "Новый статус", smNamePlaceholder: "Название статуса...", catIncomingTitle: "Категории прихода", catOutgoingTitle: "Категории расхода", catNew: "Новая категория", catNamePlaceholder: "Название категории...",
    ppIncomingTitle: "ПРИХОДНЫЙ ОРДЕР", ppOutgoingTitle: "РАСХОДНЫЙ ОРДЕР", ppDate: "Дата:", ppReceivedFrom: "Принято (от кого)", ppGivenTo: "Выдано (кому)", ppCashbox: "Касса:", ppCategory: "Категория:", ppAmount: "Сумма:", ppNote: "Комментарий:", ppSignedIncomingLeft: "Сдал (подпись)", ppSignedOutgoingLeft: "Выдал (подпись)", ppSignedIncomingRight: "Принял (подпись)", ppSignedOutgoingRight: "Получил (подпись)",
  
    convVerifyBtn: "Подтвердить",
  
    convVerified: "Конвертация подтверждена",
  
    convVerifiedBadge: "Подтверждено",
  
    convDraftBadge: "Не подтверждено",
  
    convVerifiedAt: "Подтверждено",
  
    convLockedHint: "Подтверждённый документ не редактируется",
  },

  contracts: { optional: "необязательно", legalNamePlaceholder: "Юридическое название", managerLabel: "Ответственный (кто ведёт)", managerNone: "Не выбран",
    selectCp: "Выберите контрагента...", search: "Поиск...", notFound: "Не найдено",
    editTitle: "Редактировать договор", newTitle: "Новый договор",
    number: "Номер", date: "Дата", cpLabel: "Контрагент *", legalName: "Юр. название", inn: "ИНН", legalMissing: "В карточке контрагента не заполнены юр. название/ИНН.", amount: "Сумма *", currency: "Валюта",
    description: "Описание", descPlaceholder: "Тема договора...", note: "Комментарий", notePlaceholder: "Необязательно...",
    filesLabel: "Файлы (PDF, сканы)", cancel: "Отмена", save: "Сохранить", add: "Добавить",
    cpRequired: "Нужно выбрать контрагента", amountInvalid: "Неверная сумма",
    saved: "Обновлено", added: "Добавлено", error: "Ошибка", loadError: "Ошибка загрузки", deleted: "Удалено",
    title: "Договоры", subtitle: "Реестр договоров — каждому договору присваивается номер автоматически",
    searchPlaceholder: "Номер, контрагент...", newBtn: "Договор", empty: "Нет договоров", emptyHint: "Добавьте новый договор",
    thCp: "Контрагент", thAmount: "Сумма", thCreatedBy: "Создал", thActions: "Действия",
    deleteTitle: "Подтвердите удаление", deleteText: "договор будет удалён.", delete: "Удалить",
  },

  aktSverka: { tabCustomer: "С клиентом", tabSupplier: "С поставщиком",
    selectCp: "Выберите контрагента...", search: "Поиск...", notFound: "Не найдено",
    cpRequired: "Нужно выбрать контрагента", error: "Ошибка", copied: "Скопировано",
    regenConfirm: "Старая ссылка будет аннулирована и создана новая. Продолжить?", urlUpdated: "Ссылка обновлена",
    title: "Акт сверки", subtitle: "Документ взаиморасчётов с контрагентом", cpLabel: "Контрагент",
    fromDate: "Дата начала", toDate: "Дата окончания", generate: "Сформировать", print: "Печать / PDF",
    permUrlTitle: "Постоянный URL для контрагента", permUrlHint: "Этот URL постоянный — контрагент может сохранить его и в любое время посмотреть свои взаиморасчёты. Периоды выбираются на публичной странице.",
    copyTitle: "Копировать", copy: "Копия", regenTitle: "Новый URL (старый аннулируется)", regen: "Обновить",
    loadError: "Ошибка загрузки", linkError: "Не удалось открыть ссылку", printShort: "Печать / PDF",
    docTitle: "АКТ СВЕРКИ", docSubtitle: "Взаиморасчёты между контрагентами", ourOrg: "Наша организация", tel: "Тел", period: "Период",
    noTx: "В этом периоде нет транзакций", currencyLabel: "Валюта", thDate: "Дата", thDoc: "Документ", thDebit: "Дебет", thCredit: "Кредит", thBalance: "Сальдо",
    openingBalance: "Начальное сальдо", totalRow: "Итого",
    theyOweA: " должен нам ", theyOweB: ".", weOwePre: "Мы должны ", weOweMid: " ", weOweSuf: ".",
    signOur: "Со стороны нашей организации:", signCp: "Со стороны контрагента:", signLine: "(ФИО, должность, подпись, дата)",
  
    noDebtPre: "За этот период ",
  
    noDebt: "задолженности нет (сальдо 0)",
  },

  sklad: { allCategories: "Все категории", lowOnly: "Мало на складе", totalValue: "Общая стоимость остатка", thCategory: "Категория", thValue: "Стоимость",
    loadError: "Ошибка загрузки", cancel: "Отмена", save: "Сохранить", add: "Добавить", saved: "Обновлено", added: "Добавлено", deleted: "Удалено", error: "Ошибка", delete: "Удалить", deleteTitle: "Подтвердите удаление", nameRequired: "Название обязательно", total: "Итого", thName: "Название", thProduct: "Товар", thUom: "Ед.", sku: "SKU",
    sbTitle: "Остатки", sbSubtitle: "Остатки товаров по складам", sbSearch: "Поиск товара...", sbNotFound: "Товар не найден", sbNotFoundHint: "Остатки формируются через приходные документы",
    rTitle: "Общая себестоимость", rSubtitle: "Стоимость склада на основе остатков и себестоимости", rKpi: "Общая стоимость склада (себестоимость)", rEmpty: "Нет остатков", rStock: "Остаток", rCost: "Себестоимость", rValue: "Стоимость",
    tTitle: "Перемещения", tSubtitle: "Перемещение товаров между складами", tNew: "Перемещение", tSearch: "Поиск по номеру...", tNotFound: "Перемещения не найдены", tNotFoundHint: "Создайте новый документ перемещения", tNumber: "Номер", tDate: "Дата", tDirection: "Направление", tProducts: "Товары", itemCountSuffix: "товаров",
    whEditTitle: "Редактировать склад", whNewTitle: "Новый склад", whNameLabel: "Название *", whNamePlaceholder: "Название склада", whTitle: "Склады", whSubtitle: "Список складов", whAdd: "Добавить склад", whNotFound: "Склад не найден", whNotFoundHint: "Добавьте новый склад", thActions: "Действия", whDeleteText: "склад будет удалён.",
    lsTitle: "Товары на исходе", lsSubtitleSearch: "Найдите товар и задайте минимальный остаток", lsSubtitle: "Товары с остатком ниже заданного минимума", lsAlerts: "Оповещения", lsEmpty: "Нет товаров на исходе", lsEmptyHint: "Найдите товар, чтобы задать минимальный остаток", lsLow: "Мало", lsEnough: "Достаточно", lsCurrentStock: "Текущий остаток", lsMinStock: "Минимальный остаток", lsStatus: "Статус",
    tfNotFound: "Не найдено", tfCatalogEmpty: "Каталог пуст", tfTypeProduct: "Введите название товара...", tfDocLoadError: "Документ не загружен", tfFromRequired: "Нужно выбрать склад-источник", tfToRequired: "Нужно выбрать склад-получатель", tfSameWarehouse: "Нельзя выбрать один и тот же склад", tfDateInvalid: "Неверная дата (DD/MM/YYYY HH:MM)", tfMinOneProduct: "Введите хотя бы один товар", tfMoved: "Перемещено", back: "Назад", tfHeaderTitle: "Перемещение между складами", tfDocTitle: "Документ перемещения", tfFrom: "Откуда *", tfTo: "Куда *", tfSelectWarehouse: "Выберите склад...", tfThAvailFrom: "Доступно (откуда)", tfQty: "Количество", tfAvailable: "Доступно", tfNote: "Комментарий", tfNotePlaceholder: "Комментарий...", tfDeleteText: "документ перемещения будет удалён. Остатки вернутся.",
  },

  cpCard: { kind: { purchaseOrder: "Заказ на закупку", purchaseReceipt: "Приход", purchaseReturn: "Возврат закупки", salesOrder: "Заказ на продажу", salesInvoice: "Продажа", salesReturn: "Возврат продажи" }, loadError: "Ошибка загрузки", cardTitle: "Карточка контрагента", back: "Назад", notFound: "Контрагент не найден", backToList: "Вернуться к списку", debtTitle: "Задолженность",
    payIn: "Оплата (приход)", payOut: "Оплата (расход)", weOwe: "Мы должны", theyOwe: "Нам должны",
    tabs: { documents: "Документы", payments: "Оплаты", ledger: "История баланса", products: "Товары", prices: "Цены" },
    thKind: "Тип", thNumber: "Номер", thDate: "Дата", thStatus: "Статус", thSum: "Сумма", thCashbox: "Касса", thCategory: "Категория", thDoc: "Документ", thChange: "Изменение", thBalance: "Баланс",
    noDocuments: "Документов нет", noPayments: "Оплат нет", ledgerEmpty: "История баланса пуста",
  },

  counterparties: { thName: "Название", thPhone: "Телефон", thContacts: "Контакты", thDebt: "Задолженность", thActions: "Действия", contactsSuffix: "контакт", addBtn: "Добавить", statTotal: "Всего", statCustomers: "Клиенты", statSuppliers: "Поставщики",
    folderNamePlaceholder: "Название папки...", cancel: "Отмена", error: "Ошибка", subFolderTitle: "Добавить подпапку",
    folders: "Папки", statusMgrTitle: "Управление статусами", editLabel: "Редактирование", newStatus: "Новый статус",
    statusNamePlaceholder: "Название статуса...", save: "Сохранить", add: "Добавить",
    all: "Все", statusless: "Без статуса", status: "Статус",
    loadError: "Ошибка загрузки", saved: "Обновлено", added: "Добавлено", deleted: "Удалено",
    title: "Контрагенты", subtitle: "Клиенты и поставщики", allFolders: "Все папки", searchPlaceholder: "Поиск...",
    notFound: "Контрагенты не найдены", createHint: "Добавьте нового контрагента",
    weOwe: "Мы должны", theyOwe: "Нам должны",
    editTitle: "Редактирование", newTitle: "Добавить контрагента", nameLabel: "Название", namePlaceholder: "Название компании или ФИО",
    folderLabel: "Папка", noFolder: "Без папки", configure: "Настроить",
    phone: "Телефон", phonePlaceholder: "+998 90 000 00 00", email: "Email", emailPlaceholder: "example@mail.com", comment: "Комментарий", commentPlaceholder: "Примечание...",
    contactsTitle: "Контактные лица", addContact: "Добавить", noContacts: "Контакты не добавлены",
    cName: "Имя", cNamePlaceholder: "Имя Фамилия", cRole: "Должность", cRolePlaceholder: "Директор, Менеджер...", cPhone: "Номер",
    requisitesTitle: "Реквизиты", inn: "ИНН", innPlaceholder: "123456789",
    legalName: "Юр. название", legalNamePlaceholder: "ООО \"Компания\"", legalAddr: "Юр. адрес", legalAddrPlaceholder: "г. Ташкент, Чиланзарский р-н, ...",
    bankAccount: "Банковский счёт", bankPlaceholder: "2020 8000 0000 0000 0000", update: "Обновить",
    location: "Адрес / Местоположение", locationPlaceholder: "Город, улица, дом...",
    deleteTitle: "Подтвердите удаление", deleteText: "будет удалён.", delete: "Удалить",
  },

  uomNames: {
    pcs: "штука", kg: "килограмм", g: "грамм", t: "тонна", l: "литр", ml: "миллилитр",
    m: "метр", cm: "сантиметр", mm: "миллиметр", "m²": "квадратный метр", "m³": "кубометр", km: "километр",
    pair: "пара", roll: "рулон", box: "коробка", pack: "пачка", bag: "мешок", set: "комплект",
    bottle: "бутылка", can: "банка", cyl: "баллон", coil: "бухта", spool: "катушка", sheet: "лист", bunch: "связка",
    hr: "час", min: "минута", day: "день", week: "неделя", month: "месяц", year: "год",
    visit: "визит", session: "сеанс", project: "проект", page: "страница", word: "слово", trip: "рейс",
  },
  productForm: { images: "Изображения", imagesHint: "шт • первое — обложка", setCover: "Сделать обложкой", uploading: "Загрузка...", imageDrop: "Выберите изображение или перетащите сюда", imageError: "Ошибка загрузки изображения",
    variantsTitle: "Варианты", variantsHint: "Варианты по атрибутам: цвет, размер",
    attributesTitle: "Атрибуты", attrNamePlaceholder: "Название атрибута (напр. Цвет)", attrValuePlaceholder: "Добавить значение + Enter",
    addAttribute: "Добавить атрибут", generateVariants: "Создать варианты",
    variantsListTitle: "Варианты", totalStock: "Всего остаток", variantCol: "Вариант", imageCol: "Фото", skuCol: "Артикул", priceCol: "Цена", costCol: "Себест.", stockCol: "Остаток",
    stockHint: "Укажите начальный остаток по каждому варианту; остаток товара = сумма вариантов",
    ptTitle: "Типы цен продажи", ptHint: "Добавляйте, редактируйте или удаляйте", ptPlaceholder: "Например: Оптовая, Розничная...", ptAdd: "Добавить тип цены",
    added: "Добавлено", deleted: "Удалено", error: "Ошибка",
    dimsTitle: "Размеры", dimsHint: "— на одну штуку", length: "Длина", width: "Ширина", height: "Высота",
    pkgTitle: "Единицы упаковки", pkgBase: "Основная:", pkgNoBase: "Сначала выберите основную единицу измерения (UOM) в разделе \"Информация\"",
    pkgUnit: "Единица упаковки", pkgQty: "Количество", pkgUomSelect: "Ед. изм...", pkgAdd: "Добавить упаковку",
    editTitle: "Редактирование", newProduct: "Новый товар", newService: "Новая услуга",
    saved: "Обновлено", saveError: "Произошла ошибка", saving: "Сохранение...", update: "Обновить", save: "Сохранить", cancel: "Отмена",
    nameLabel: "Название", productNamePlaceholder: "Название товара", serviceNamePlaceholder: "Название услуги",
    infoTitle: "Информация", descLabel: "Описание", descPlaceholder: "Кратко о товаре...",
    folderLabel: "Папка", noFolder: "Без папки", select: "Выберите...", skuLabel: "SKU", skuPlaceholder: "Например: PRD-001",
    pricesTitle: "Цены", buyPrice: "Цена закупки", salePricesTitle: "Цены продажи", statusTitle: "Статус", back: "Назад", uomLabel: "Единица измерения", minStockLabel: "Мин. остаток", minStockHint: "Если остаток меньше или равен этому значению — попадёт в \"Низкий остаток\" (0 = без контроля)", configure: "Настроить", active: "Активен", activeBadge: "Актив", isManufacturedLabel: "Производится", prodNormaTitle: "Норма производства", prodNormaHint: "Сырьё, расходуемое при производстве 1 единицы продукта", prodNormaAdd: "Добавить", prodNormaProduct: "Сырьё", prodNormaQty: "Количество", prodNormaUom: "Единица", prodNormaFooter: "При выборе этого продукта в производстве норма подтянется автоматически", manufacturingUomLabel: "Единица изм. производства", manufacturingUomHint: "Автоматически подставляется в форму производства и не может быть изменена.", manufacturingUomNone: "Не указана (любая)",
    mkixCodeLabel: "Код МКИX", mkixCodePlaceholder: "Например: 3926909709",
    nameRequired: "Название товара обязательно", uomRequired: "Единица измерения обязательна",
  },

  products: {
    variantTag: "вар.",
    typeAll: "Все", product: "Товар", service: "Услуга",
    cols: { category: "Папка", uom: "Ед", sku: "SKU", costPrice: "Себестоимость", avgCost: "Ср. себест.", salePrice: "Цена продажи", stock: "Остаток", description: "Описание", createdAt: "Создан", updatedAt: "Обновлён", isActive: "Статус" },
    active: "Активен", inactive: "Неактивен",
    searchPlaceholder: "Поиск...", colsMenuTitle: "Настроить столбцы", colsMenu: "Столбцы", colsAll: "Все", colsDefault: "По умолчанию",
    folders: "Папки", newFolder: "Новая папка", allFolders: "Все", noFolders: "Нет папок", mobileAllFolders: "Все (папка)",
    resizeHint: "Потяните, чтобы изменить ширину (двойной клик — сброс)",
    thName: "Название", notFound: "Товары не найдены", createHint: "Добавьте первый товар или услугу", inactiveBadge: "Неактивен", stockLabel: "Остаток",
    uomRequired: "Выберите единицу измерения", editTitle: "Редактирование —", newProductTitle: "+ Новый товар", newServiceTitle: "+ Новая услуга",
    nameLabel: "Название", productNamePlaceholder: "Название товара", serviceNamePlaceholder: "Название услуги",
    skuLabel: "SKU / Код", uomLabel: "Единица измерения", select: "Выберите...",
    folderLabel: "Папка", noFolder: "Без папки", salePrice: "Цена продажи", costPriceLabel: "Себестоимость", descLabel: "Описание", optional: "Необязательно...",
    activeCheck: "Активен", cancel: "Отмена", save: "Сохранить", add: "Добавить", saving: "Сохранение...",
    folderEditTitle: "Редактировать папку", folderNamePlaceholder: "Название папки", parentFolder: "Родительская папка", rootFolder: "Корневая папка",
    deleteTitle: "Подтвердите удаление", deleteText: " — удалить? Это действие нельзя отменить.", delete: "Удалить", deleting: "Удаление...",
    saved: "Обновлено", added: "Добавлено", folderSaved: "Папка обновлена", folderAdded: "Папка добавлена", deleted: "Удалено", folderDeleted: "Папка удалена", error: "Произошла ошибка",
  },

  files: {
    empty: "Файл ещё не загружен", fileName: "Файл", uploading: "Загрузка...", upload: "Загрузить файл", hint: "PDF, изображение, Word, Excel — максимум 15 МБ", uploaded: "Загружено", uploadError: "Ошибка загрузки",
  },

  smeta: {
    title: "Смета", save: "Сохранить",
    companyName: "Название компании", companyNamePh: "Введите название компании",
    directorName: "Ф.И.О. директора", directorNamePh: "Фамилия Имя Отчество",
    colName: "Наименование работы", colCountry: "Страна", colUom: "Ед.изм",
    colQty: "Кол.в", colPrice: "Цена", colDeliveryCost: "Стоимость поставки",
    colVat: "НДС %", colTotal: "Общая стоимость с НДС",
    total: "Итого", addRow: "Добавить строку",
    comment: "Примечание", commentPh: "Дополнительные примечания...",
    validUntil: "Срок действия коммерческого предложения", validUntilLabel: "Действует до:",
    positions: "Товары и услуги", preview: "Просмотр", close: "Закрыть",
    download: "Скачать PDF", printPdf: "Печать / PDF", orderNum: "Заказ №",
    delivery: "Стоимость поставки", vat: "НДС", grandTotal: "Итого с НДС",
    shareLink: "Поделиться", linkCopied: "Скопировано!", linkError: "Ссылка недействительна",
  },

  jobOrderForm: { dimW: "Ширина", dimL: "Длина", back: "Назад", title: "Заказ", procStatus: { waiting: "Не начат", "in-progress": "В процессе", paused: "На паузе", done: "Завершён", problem: "Проблема" }, fSketch: "Эскиз (изображение/PDF)", sketchUpload: "Загрузить эскиз", toTrash: "В корзину", print: "Печать", printTitle: "Печать", deliver: "Завершён", revertDelivery: "Отменить завершение", confirmAction: "Подтвердить", startAction: "В работу", completeAction: "Завершить", statusChanged: "Статус изменён", startNeedProcess: "Сначала добавьте процесс (этап)", startNeedResponsible: "Назначьте ответственного на каждый процесс", save: "Сохранить", trackStart: "Начать", trackPause: "Пауза", trackDone: "Завершить", trackProblem: "Проблема", trackResume: "Продолжить", deleteTitle: "Переместить в корзину", deleteText: "Заказ будет перемещён в корзину. Остаток сырья вернётся.",
    durMin: "мин", durHour: "ч", distFromInstall: "Расстояние от точки установки",
    select: "Выберите...", search: "Поиск...", clearSelection: "— Очистить выбор —", notFound: "Не найдено",
    nameRequired: "Название обязательно", customerAdded: "Клиент добавлен", error: "Ошибка",
    newCustomer: "Новый клиент", nameLabel: "Название", customerNamePlaceholder: "Имя клиента", phone: "Телефон", cancel: "Отмена", add: "Добавить",
    docLoadError: "Документ не загружен", cashboxRequired: "Нужно выбрать кассу", amountInvalid: "Неверная сумма",
    paymentReceived: "Оплата принята", movedToTrash: "Перемещено в корзину", customerRequired: "Нужно выбрать клиента",
    warehouseRequired: "Нужно выбрать склад", agreedInvalid: "Неверная согласованная сумма",
    deadlineRequired: "Укажите срок сдачи", managerRequired: "Выберите менеджера проекта", agreedRequired: "Укажите согласованную сумму", descriptionRequired: "Введите описание",
    savedToast: "Сохранено", createdToast: "Создано", saveFirst: "Сначала сохраните заказ", delivered: "Доставлено", reverted: "Отменено",
    modalTitle: "Новый заказ", modalCreate: "Создать и продолжить", modalHint: "После сохранения добавите процессы, расходы и расчёт.",
    fManager: "Менеджер проекта", managerNone: "— Не выбрано —",
    basicInfo: "Основные данные", moveLeft: "Сдвинуть влево", moveRight: "Сдвинуть вправо",
    deliveredLockTitle: "Чтобы редактировать доставленный заказ, сначала отмените доставку",
    deliveredBanner: "Доставлено. Чтобы редактировать, сначала отмените доставку.",
    invoiceTitle: "Нужно отправить счёт-фактуру",
    invoiceText1: "Работа по этому заказу завершена. Контрагенту ", invoiceText2: " по ", invoiceText3: " договору нужно отправить счёт-фактуру.",
    contractAmount: "Сумма договора:",
    fNumber: "Номер", fDate: "Дата", fCustomer: "Клиент", customerPlaceholder: "Клиент...", newCustomerTitle: "Добавить нового клиента",
    fContract: "Договор", noContract: "— Без договора —", fAgreedPrice: "Согласованная сумма", fCurrency: "Валюта", fDeadline: "Срок сдачи",
    fWarehouse: "Склад (сырьё)", fFolder: "Папка", noFolder: "— Без папки —",
    fDescription: "Описание (что делается)", fShortName: "Краткое название", shortNamePlaceholder: "Например: Кухонная мебель", shortNameRequired: "Краткое название обязательно", sketchRequired: "Загрузка эскиза обязательна", descPlaceholder: "Стол, кухонная мебель...",
    fLocation: "Локация установки", fLocationHint: "— ссылка у клиента (Google Maps, Yandex)", openLink: "Открыть ссылку", copyLink: "Копировать", copied: "Скопировано",
    createdBy: "Создал:", priceLabel: "Цена:", paidLabel: "Оплата:", debtLabel: "Долг:", workedLabel: "Отработано:", receivePayment: "Принять оплату",
    processes: "Процессы", addProcess: "Процесс", noProcesses: "Процессов нет. Нажмите \"+ Процесс\".",
    addProcessTitle: "Новый процесс", editProcessTitle: "Редактировать процесс", addProcessHint: "Выберите отдел и ответственного", deptRequired: "Нужно выбрать отдел",
    pDept: "Отдел", pResponsible: "Ответственный", pStatus: "Статус", pLabor: "Труд", pAllocated: "Выделенная сумма", pNote: "Примечание", pNotePlaceholder: "Примечание / особое указание...", workedShort: "Отработано:", historyTitle: "История времени", calLoad: "заказ(ов)", calBusy: "загружено", historyEmpty: "Пока нет действий", fromProposal: "Этот заказ создан из предложения:", viewProposal: "Открыть предложение", proposalTitle: "Предложение", prDate: "Дата", prCustomer: "Клиент", prAssignee: "Назначенный сотрудник", prCreatedBy: "Создал", prDescription: "Описание", prNote: "Примечание", prFiles: "Файлы",
    materials: "Расходы (сырьё)", addRow: "Строка", noMaterials: "Расходов нет. Нажмите \"Строка\".",
    mProduct: "Товар", mQty: "Кол-во", mUom: "Ед", mCost: "Себестоимость", mSum: "Сумма", mProcess: "Процесс",
    stockLeft: "Остаток",
    selectVariant: "Выберите вариант",
    uomPlaceholder: "шт", costFromProductTitle: "Себестоимость из карточки товара", costOwnTitle: "Себестоимость для этого заказа", totalExpense: "Итого расход",
    files: "Файлы и проекты",
    totalsTitle: "Итоговый расчёт", tAgreed: "Согласованная сумма", tMaterials: "Сырьё", tLabor: "Труд", tTotalCost: "Итого себестоимость", tOtherExpenses: "Прочие расходы", otherExpenses: "Прочие расходы", addExpense: "Добавить расход", noExpenses: "Расходов нет", expCashbox: "Касса", expCashboxHint: "Только кассы в валюте заказа ({cur})", expCashboxRequired: "Выберите кассу", expAmount: "Сумма", expAmountRequired: "Введите сумму", expNote: "Комментарий", expNotePlaceholder: "Описание расхода…", expAdded: "Расход добавлен", expDeleted: "Расход удалён", tProfit: "Прибыль",
    totalsHint: "После сохранения записывается фактическая себестоимость (FIFO/средняя) и прибыль уточняется.",
    freezeAction: "Заморозить", unfreezeAction: "Продолжить",
    freezeTitle: "Заморозить заказ (пауза)", freezeHint: "При заморозке срок сдвигается вперёд. После разморозки прошедшее время не возвращается.",
    freezeUntilLabel: "Дата возобновления",
    freezeExtendInfo: "Срок будет продлён на {days} дн.",
    freezeConfirm: "Заморозить", freezeDateRequired: "Укажите дату возобновления",
    freezeSuccess: "Заказ заморожен", unfreezeSuccess: "Заказ возобновлён",
    frozenBanner: "Заморожен (на паузе)", frozenFrom: "с:", frozenUntil: "до:",
    deleteTextInvoice: " Автоматическая фактура также удаляется и баланс клиента возвращается.",
    payTitle: "Принять оплату", remainingDebt: "Остаток долга:", cashbox: "Касса", noCashbox: "касса в этой валюте не найдена",
    amount: "Сумма", payNote: "Примечание", optional: "Необязательно...", receive: "Принять",
  },

  proposals: {
    title: "Коммерческое предложение", countSuffix: "шт.", new: "Предложение", newTitle: "Новое предложение", editTitle: "Редактировать предложение", colNumber: "Номер", colDate: "Дата", colCustomer: "Клиент", colDescription: "Описание", colAmount: "Сумма", colAssignee: "Сотрудник", colCreatedBy: "Создал",
    searchPlaceholder: "Номер, клиент, описание...", notFound: "Предложения не найдены", loadError: "Ошибка загрузки",
    resizeHint: "Потяните, чтобы изменить ширину", backToList: "Назад к списку",
    emptyTitle: "Предложение не выбрано", emptyHint: "Выберите слева или создайте новое",
    tabs: { open: "Открытые", won: "Выиграно", lost: "Отказ" },
    statWon: "выиграно", statLost: "отказ", statOpen: "открыто",
    status: { new: "Новое", "in-discussion": "В обсуждении", won: "Выиграно (заказ)", lost: "Отклонено" },
    docLoadError: "Документ не загружен", customerRequired: "Нужно выбрать клиента",
    savedToast: "Сохранено", createdToast: "Создано", error: "Ошибка",
    markedLost: "Отмечено как отклонённое", deleteConfirm: "Удалить это предложение?", deletedToast: "Удалено",
    wonBannerText2: ".", openOrder: "Открыть заказ",
    lostBannerTitle: "Отклонённое предложение", reasonLabel: "Причина:",
    delete: "Удалить", rejected: "Отклонено", convertToOrder: "Преобразовать в заказ", cancel: "Отмена", save: "Сохранить",
    fNumber: "Номер", fDate: "Дата", fStatus: "Статус", fCurrency: "Валюта", fCustomer: "Клиент",
    fAgreedPrice: "Согласованная сумма", fWarehouse: "Склад (для заказа)", notSelected: "— Не выбрано —",
    fDescription: "Описание (что делается)", descPlaceholder: "Описание дизайна / проекта клиента...",
    fAdvance: "Сумма аванса (бронь)", advancePaid: "Аванс оплачен", fNote: "Примечание", optional: "Необязательно...", fFiles: "Файлы (эскиз/фото/документ)", createdBy: "Создал:",
    lostModalTitle: "Отклонить предложение", lostReasonLabel: "Причина (необязательно):", lostReasonPlaceholder: "Клиент принял решение...",
    winModalTitle: "Преобразовать в заказ",
    winModalText: "Будет создан новый заказ (JobOrder) и привязан к этому предложению. Процессы и материалы добавляются внутри заказа.",
    warehouseRequiredLabel: "Склад *", selectPlaceholder: "Выберите...", createOrder: "Создать заказ",
  
    wonToast: "Заказ создан! Его можно посмотреть в разделе «Заказы».",
  
    customerSelect: "Выберите клиента...",
  
    search: "Поиск...",
  
    searchEmpty: "Не найдено",
  
    clearSelection: "Сбросить выбор",
  
    fAssignee: "Назначенный сотрудник",
  
    assigneePlaceholder: "Выберите сотрудника...",
  
    assigneeHint: "Назначенный сотрудник нажимает «начал/закончил» на своей странице (Мои работы)",
  
    fManager: "Ответственный (договор)",
  
    managerPlaceholder: "Админ или руководитель проекта...",
  
    managerHint: "Договор будет привязан к этому пользователю",
  
    workStatus: { waiting: "Не начато", 
    "in-progress": "В работе",
  
    done: "Завершено",
  },
  
    warehouseRequired: "Сначала выберите склад",
  
    orderCreated: "Заказ создан!",
  
    wonBannerTitle: "Заказ создан",
  
    wonBannerText1: "Это предложение отмечено как выигранное и преобразовано в заказ №",
  },

  jobOrders: { title: "Заказы", subtitle: "Заказ клиента: производство → доставка", newOrder: "Заказ", notFound: "Заказ не найден", folderDeleteText: "папка будет удалена. Заказы внутри сохранятся (удалится только привязка к папке).", colsReorderHint: "Перетащите, чтобы изменить порядок",
    searchPlaceholder: "Номер, клиент, описание...",
    createHint: "Создайте новый заказ",
    loadError: "Ошибка загрузки",
    thNumber: "Номер",
    thActions: "Действия",
    filterAll: "Все",
    tabAll: "Все", tabFrozen: "Заморожены", overdue: "Срок истёк", costOverrun: "Себестоимость превышена",
    status: { new: "Новый", confirmed: "Подтверждён", "in-progress": "В процессе", delivered: "Завершён", cancelled: "Отменён" },
    cols: { sketch: "Эскиз", shortName: "Краткое название",
      date: "Дата", customer: "Клиент", description: "Описание", folder: "Папка", processes: "Процессы",
      manager: "Менеджер проекта", agreedPrice: "Согласовано", paid: "Оплачено", debt: "Долг",
      totalCost: "Себестоимость", materialsCost: "Сырьё", laborCost: "Труд",
      profit: "Прибыль", status: "Статус", createdBy: "Создал", expectedDeliveryDate: "Срок сдачи",
      deliveryDate: "Дата доставки", currency: "Валюта",
    },
    colsMenu: "Столбцы", colsMenuTitle: "Настроить столбцы", colsAll: "Все", colsDefault: "По умолчанию",
    statAgreed: "Общая сумма", filterCustomer: "Клиент", filterAllCustomers: "Все клиенты", filterAllManagers: "Все менеджеры", filterYear: "Год", filterPeriod: "Период", filterWholeYear: "Весь год", filterAllMonths: "Все месяцы", filterClear: "Сбросить", statPaid: "Оплачено", statDebt: "Долг", statCount: "Кол-во заказов",
    folders: "Папки", newFolder: "Новая папка", allFolders: "Все", noFolder: "Без папки",
    noFolders: "Нет папок", mobileAllFolders: "Все (папка)",
    folderEdit: "Редактировать папку", folderNameLabel: "Название", folderNamePlaceholder: "Название папки",
    parentFolder: "Родительская папка", rootFolder: "Корневая папка",
    folderDeleteTitle: "Удалить папку",
    trashTitle: "Переместить в корзину",
    trashText: "заказ будет перемещён в корзину. Остатки сырья вернутся.",
    cancel: "Отмена", save: "Сохранить", add: "Добавить", delete: "Удалить", toTrash: "В корзину",
    saved: "Обновлено", addedToast: "Добавлено", deletedToast: "Удалено", movedToTrash: "Перемещено в корзину", error: "Ошибка",
    resizeHint: "Потяните, чтобы изменить ширину (двойной клик — сброс)",
  },

  // Auth
  login: "Войти",
  register: "Регистрация",
  logout: "Выйти",
  email: "Email",
  phone: "Телефон",
  password: "Пароль",
  confirmPassword: "Подтвердите пароль",

  // Register
  createOrganization: "Создать организацию",
  organizationName: "Название организации",
  organizationType: "Тип организации",
  yourName: "Ваше имя",
  yourEmail: "Ваш email",
  yourPassword: "Пароль",
  alreadyHaveAccount: "Уже есть аккаунт?",
  dontHaveAccount: "Нет аккаунта?",

  // Org types
  retail: "Розничная торговля",
  wholesale: "Оптовая торговля",
  manufacturing: "Производство",
  service: "Услуги",
  other: "Другое",

  // Dashboard
  dashboard: "Главная",
  welcome: "Добро пожаловать",

  // Common
  save: "Сохранить",
  cancel: "Отмена",
  delete: "Удалить",
  edit: "Редактировать",
  add: "Добавить",
  search: "Поиск",
  error: "Ошибка",
  success: "Успешно",

  // Errors
  required: "Это поле обязательно для заполнения",
  invalidEmail: "Неверный email адрес",
  passwordMin: "Пароль должен содержать минимум 4 символов",
  passwordMatch: "Пароли не совпадают",

  // Login page
  login_page: {
    server: "Код компании",
    serverPlaceholder: "например, miko",
    checking: "проверяется...",
    serverNotFound: "Сервер не найден",
    serverNotFoundHint: "Сервер «{slug}» не существует. Проверьте адрес.",
    phonePlaceholder: "90 123 45 67",
    passwordPlaceholder: "••••••",
    submitting: "Вход...",
    rights: "© 2025 CRM Line. Все права защищены.",
  
    forgotPassword: "Забыли пароль?",
  },

  // Sales module
  sales: {
    dateLocale: "ru-RU",
    types: {
      invoices: { label: "Продажи",   subtitle: "Счёт-фактуры продаж", docLabel: "Счёт-фактура" },
      returns:  { label: "Возвраты",  subtitle: "Возврат товара от клиента", docLabel: "Возврат продажи" },
    
    orders: { label: "Заказы", 
    subtitle: "Заказы клиентов",
  
    docLabel: "Заказ на продажу",
  },
  },
    statusDraft: "Черновик",
    statusConfirmed: "Подтверждён",
    searchPlaceholder: "Номер или клиент...",
    notFound: "Документ не найден",
    createHint: "Создайте новый документ",
    thNumber: "Номер",
    thDate: "Дата",
    thCustomer: "Клиент",
    thLines: "Строки",
    thSum: "Сумма",
    thStatus: "Статус",
    thVerified: "Проверен",
    thState: "Состояние",
    thCurrency: "Валюта", thNote: "Примечание",
    thActions: "Действия",
    linesSuffix: "шт.",
    view: "Просмотр",
    edit: "Редактировать",
    deleteConfirmTitle: "Подтвердите удаление",
    deleteConfirmText: "будет удалён.",
    deleteInvoiceExtra: " Остаток и долг клиента будут возвращены.",
    cancel: "Отмена",
    deleteBtn: "Удалить",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    error: "Ошибка",
  },

  // Purchases module
  purchases: {
    dateLocale: "ru-RU",
    types: {
      receipts: { label: "Приходы",  subtitle: "Счёт-фактуры поставщиков (приходы)", docLabel: "Приходный документ" },
      returns:  { label: "Возвраты", subtitle: "Возврат товара поставщику", docLabel: "Возврат закупки" },
    
    orders: { label: "Заявки", 
    subtitle: "Документы заказов поставщикам",
  
    docLabel: "Заказ на закупку",
  },
  },
    statusDraft: "Черновик",
    statusConfirmed: "Подтверждён",
    searchPlaceholder: "Номер или поставщик...",
    notFound: "Документ не найден",
    createHint: "Создайте новый документ",
    thNumber: "Номер",
    thDate: "Дата",
    thSupplier: "Поставщик",
    thLines: "Строки",
    thSum: "Сумма",
    thStatus: "Статус",
    thVerified: "Проверен",
    thState: "Состояние",
   thCurrency: "Валюта", thWarehouse: "Склад", thNote: "Примечание", thPayment: "Оплата", payCash: "Наличные", payCredit: "Долг",
    thActions: "Действия",
    linesSuffix: "шт.",
    view: "Просмотр",
    edit: "Редактировать",
    deleteConfirmTitle: "Подтвердите удаление",
    deleteConfirmText: "будет удалён.",
    cancel: "Отмена",
    deleteBtn: "Удалить",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    error: "Ошибка",
  },

  // Sales form page
  salesForm: {
    docTypes: {
      invoices: "Счёт-фактура",
      returns: "Возврат продажи",
    
    orders: "Заказ на продажу",
  },
    back: "Назад",
    delete: "Удалить",
    print: "Печать",
    copy: "Копия",
    cancel: "Отмена",
    save: "Сохранить",
    add: "Добавить",
    error: "Ошибка",
    statusManage: "Управление статусами",
    statusEdit: "Редактировать",
    statusNew: "Новый статус",
    statusNamePlaceholder: "Название статуса...",
    statusAdd: "Добавить",
    productSearchPlaceholder: "Поиск товара...",
    productNotFoundCreate: "Не найдено. Создайте новый товар через",
    productNotFoundCreate2: ".",
    catalogEmpty: "Каталог пуст — добавьте товар через +",
    productTypeName: "Введите название товара...",
    notFound: "Не найдено",
    searchPlaceholder: "Поиск...",
    customerSelect: "Выберите клиента...",
    customerAdded: "Клиент добавлен",
    newCustomer: "Новый клиент",
    nameRequired: "Название *",
    customerNamePlaceholder: "Имя клиента",
    phone: "Телефон",
    nameRequiredToast: "Название обязательно",
    warehouseSelect: "Выберите склад...",
    warehouseUpdated: "Обновлено",
    warehouseAdded: "Склад добавлен",
    editWarehouse: "Редактировать склад",
    newWarehouse: "Новый склад",
    warehouseNamePlaceholder: "Название склада",
    currency: "Валюта",
    baseLabel: "основная",
    uploadError: "Ошибка загрузки",
    file: "Файл",
    noFiles: "Файлы ещё не загружены",
    fileHint: "PDF, изображение, Word, Excel — максимум 15MB",
    productAdded: "Товар добавлен",
    newProduct: "Новый товар",
    productNamePlaceholder: "Название товара",
    costPrice: "Себестоимость",
    docLoadError: "Документ не загружен",
    customerRequired: "Нужно выбрать клиента",
    warehouseRequired: "Нужно выбрать склад",
    deadlineRequired: "Укажите срок сдачи",
    managerRequired: "Выберите менеджера проекта",
    agreedRequired: "Укажите согласованную сумму",
    descriptionRequired: "Введите описание",
    currencyRequired: "Нужно выбрать валюту",
    cashboxRequired: "Нужно выбрать кассу",
    dateInvalid: "Неверная дата (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Неверная дата поставки (DD/MM/YYYY)",
    needQty: "Укажите количество хотя бы для одной позиции",
    saved: "Сохранено",
    created: "Добавлено",
    copyNeedRow: "Для копирования нужна хотя бы одна строка",
    copyCreated: "Копия создана",
    deleted: "Удалено",
    productAlready: "Этот товар уже добавлен",
    dateLabel: "Дата:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    statusless: "Без статуса",
    verified: "Подтверждён",
    counterparty: "Контрагент *",
    newCounterpartyTitle: "Добавить контрагента",
    warehouse: "Склад",
    editWarehouseTitle: "Редактировать склад",
    newWarehouseTitle: "Добавить склад",
    currencyReq: "Валюта *",
    payment: "Оплата",
    payCredit: "В долг (клиент должен)",
    payCash: "Наличная оплата (в кассу)",
    payCashHint: "Сумма сразу поступает в кассу, на баланс клиента не влияет.",
    cashbox: "Касса",
    selectPlaceholder: "Выберите...",
    notSelected: "— Не выбрано —",
    arrivalDate: "Дата прихода",
    createInvoice: "Создать продажу",
    customerReq: "Клиент *",
    invoiceCreated: "Продажа создана (списано со склада)",
    newCustomerTitle: "Добавить клиента",
    priceType: "Тип цены",
    priceTypeDefault: "Стандарт (1-я цена)",
    cashboxBalance: "остаток",
    noCashbox: "Касса в валюте \"{currency}\" не найдена (или вам не привязана)",
    tabItems: "Позиции",
    tabFiles: "Файлы",
    thName: "Название",
    thSells: "Продаётся",
    thUom: "Ед.изм.",
    uomSelect: "Ед.изм.",
    uomRequired: "Выберите единицу измерения для каждого товара",
    overStock: "\"{name}\" — недостаточно на складе (доступно: {qty} {uom})",
    thAvailable: "Доступно",
    thPrice: "Цена",
    thDiscount: "Скидка %",
    thSum: "Сумма",
    thVatRate: "Ставка НДС",
    thVatAmount: "Сумма НДС",
    thTotal: "Итого",
    newProductTitle: "Создать новый товар",
    total: "Сумма",
    totalVat: "НДС",
    grandTotal: "Итого (с НДС)",
    note: "Примечание",
    notePlaceholder: "Примечание или доп. информация...",
    saleConfirmed: "Продажа подтверждена",
    saleConfirmedHint: "Остаток товара уменьшился, долг клиента вырос (+{amount}).",
    deleteConfirmTitle: "Подтвердите удаление",
    deleteConfirmText: "будет удалён навсегда.",
    partyLabel: "Клиент",
  
    uploaded: "Загружено",
  
    uploading: "Загрузка...",
  
    uploadFile: "Загрузить файл",
  
    payCreditHint: "Записывается на баланс клиента — затем оплачивается через приход денег.",
  },

  // Purchase form page
  purchaseForm: {
    docTypes: {
      receipts: "Приходный документ",
      returns: "Возврат закупки",
    
    orders: "Заказ на закупку",
  },
    back: "Назад",
    delete: "Удалить",
    save: "Сохранить",
    createReceipt: "Создать приход",
    cancel: "Отмена",
    error: "Ошибка",
    statusManage: "Управление статусами",
    statusEdit: "Редактировать",
    statusNew: "Новый статус",
    statusNamePlaceholder: "Название статуса...",
    statusAdd: "Добавить",
    productSearchPlaceholder: "Поиск товара...",
    productNotFoundCreate: "Не найдено. Создайте новый товар через",
    productNotFoundCreate2: ".",
    catalogEmpty: "Каталог пуст — добавьте товар через +",
    productTypeName: "Введите название товара...",
    notFound: "Не найдено",
    supplierSelect: "Выберите поставщика...",
    supplierAdded: "Поставщик добавлен",
    newSupplier: "Новый поставщик",
    nameRequired: "Название *",
    supplierNamePlaceholder: "Название поставщика",
    phone: "Телефон",
    warehouseSelect: "Выберите склад...",
    warehouseUpdated: "Обновлено",
    warehouseAdded: "Склад добавлен",
    editWarehouse: "Редактировать склад",
    newWarehouse: "Новый склад",
    warehouseNamePlaceholder: "Название склада",
    nameRequiredToast: "Название обязательно",
    add: "Добавить",
    currency: "Валюта",
    uploadError: "Ошибка загрузки",
    file: "Файл",
    noFiles: "Файлы ещё не загружены",
    fileHint: "PDF, изображение, Word, Excel — максимум 15MB",
    productAdded: "Товар добавлен",
    newProduct: "Новый товар",
    productNamePlaceholder: "Название товара",
    costPrice: "Себестоимость",
    docLoadError: "Документ не загружен",
    productAlready: "Этот товар уже добавлен",
    selectVariant: "Выберите вариант",
    variantRequired: "Выберите вариант для товара с вариантами",
    supplierRequired: "Нужно выбрать поставщика",
    warehouseRequired: "Нужно выбрать склад",
    currencyRequired: "Нужно выбрать валюту",
    cashboxRequired: "Нужно выбрать кассу",
    dateInvalid: "Неверная дата (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Неверная дата поставки (DD/MM/YYYY)",
    needQty: "Укажите количество хотя бы для одной позиции",
    saved: "Сохранено",
    created: "Добавлено",
    copyNeedRow: "Для копирования нужна хотя бы одна строка",
    copyCreated: "Копия создана",
    receiptCreated: "Приход создан и оприходован на склад",
    deleted: "Удалено",
    statusless: "Без статуса",
    dateLabel: "Дата:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    verified: "Подтверждён",
    verifiedLockTitle: "Подтверждённый документ может отменить только администратор",
    counterparty: "Контрагент *",
    newCounterpartyTitle: "Добавить контрагента",
    editWarehouseTitle: "Редактировать склад",
    newWarehouseTitle: "Добавить склад",
    arrivalDate: "Дата прихода",
    dateOnlyPlaceholder: "DD/MM/YYYY",
    currencyReq: "Валюта *",
    paymentMode: "Способ оплаты",
    payDebt: "Долг (поставщику должны)",
    payDebtHint: "Баланс поставщика вырастет — затем оплачивается через Расход.",
    payCash: "Наличные (из кассы)",
    payCashHint: "Сумма сразу выходит из кассы, на баланс поставщика не влияет.",
    cashbox: "Касса",
    selectPlaceholder: "Выберите...",
    noCashbox: "Касса в валюте \"{currency}\" не найдена (или вам не привязана)",
      convRate: "Курс конвертации", convEdit: "Изменить курс", convDeducted: "Спишется с кассы",
    thName: "Название",
    thNeed: "Нужно",
    thReceived: "Получено", uploading: "Загрузка...", uploadFile: "Загрузить файл", uploaded: "Загружено", procLoadError: "Не удалось загрузить заявку снабжения", thOrdered: "Заказ",
    thAvailable: "Доступно",
    thPrice: "Цена",
    thDiscount: "Скидка %",
    thSum: "Сумма",
    newProductTitle: "Создать новый товар",
    overReceiveError: "Нельзя получить больше нужного количества",
    excludeFromReceipt: "Не включать в этот Приход",
    total: "Итого",
    note: "Примечание",
    notePlaceholder: "Примечание или доп. информация...",
    receiptConfirmed: "Приход подтверждён",
    receiptConfirmedHint: "Остаток товара обновлён, баланс поставщика увеличился (+{amount}).",
    deleteConfirmTitle: "Подтвердите удаление",
    deleteConfirmText: "будет удалён навсегда.",
    partyLabel: "Поставщик",
    warehouse: "Склад",
    warehouseNone: "— Не выбрано —",
    baseLabel: "основная",
    print: "Печать",
    copy: "Копия",
    tabItems: "Позиции",
    tabFiles: "Файлы",
    searchPlaceholder: "Поиск...",
    docNumberDash: "—",
    addRow: "Добавить строку",
  
    linkedProductsHint: "Показаны только товары этого поставщика",
  },

  // Procurement editor + form-page chrome
  procEditor: {
    back: "Назад",
    lockedTitle: "Документ не редактируется",
    lockedText: "Эта заявка относится к прошедшему дню ({date}). Документы за прошлые дни доступны только для просмотра.",
    toTrash: "В корзину",
    createReceipt: "Создать приход",
    cancel: "Отмена",
    save: "Сохранить",
    number: "Номер",
    date: "Дата",
    needBy: "Срок поставки",
    assignee: "Снабженец (ответственный)",
    statusPrefix: "Состояние:",
    receiptsLinked: "· привязано приходов: {n}",
    overdue: "Срок истёк",
    neededProducts: "Нужные товары",
    rowsCount: "строк: {n}",
    thProduct: "Товар",
    thImage: "Фото",
    thNeed: "Нужно",
    thUom: "Ед.",
    thReceived: "Получено",
    thRemaining: "Остаток",
    thNote: "Примечание",
    uomPlaceholder: "шт",
    optional: "Необязательно",
    addRow: "Добавить строку",
    note: "Примечание",
    notePlaceholder: "Необязательно...",
    attachments: "Вложение (фото/файл)",
    trashModalTitle: "Переместить в корзину",
    needRow: "Введите хотя бы одну строку", assigneeRequired: "Необходимо выбрать снабженца",
    saved: "Сохранено",
    created: "Создано",
    movedToTrash: "Перемещено в корзину",
    loadDocError: "Документ не загружен",
    error: "Ошибка",
  
    pageTitle: "Заявка на снабжение",
  
    close: "Закрыть",
  
    trashModalText: "Заявка будет перемещена в корзину. Связанные приходные документы сохранятся.",
  },

  // Procurement (Снабжение) list
  procurement: {
    dateLocale: "ru-RU",
    title: "Снабжение",
    countSuffix: "заявок",
    newRequestTitle: "Новая заявка",
    searchPlaceholder: "Номер, примечание...",
    unassigned: "— не назначен",
    positionsSuffix: "позиций", boughtOf: "{bought} из {total} куплено", uploadError: "Ошибка загрузки", imgZoom: "Увеличить", selectVariant: "Выберите вариант",  thDate: "Дата", thProduct: "Товар", thNeed: "Нужно", thUom: "Ед.", thNote: "Примечание", optional: "Необязательно...", thBuy: "Купить", addRow: "Добавить строку", flatHint: "Добавьте товар нижней строкой — он попадёт в сегодняшнюю заявку. Просроченные строки красные.", error: "Ошибка",
    resizeHint: "Потяните, чтобы изменить ширину (двойной клик — сброс)",
    backToList: "Назад к списку",
    newDocTitle: "Новая заявка на снабжение",
    emptyHint: "Выберите из списка слева или создайте новую заявку",
    loadError: "Ошибка загрузки",
    tabs: {
      overdue: "Просроченные",
      new: "Новые",
      partial: "Частично",
      fulfilled: "Выполнено",
    },
    status: {
      new: "Новый",
      partial: "Частично",
      fulfilled: "Выполнено",
      cancelled: "Отменён",
    },
  
    newRequestShort: "Заявка",
  
    notFound: "Заявка не найдена",
  
    emptyTitle: "Заявка не выбрана",
  },

  // Dashboard home (Главная)
  dashboardHome: {
    dateLocale: "ru-RU",
    greeting: "Добро пожаловать, {name}!",
    today: "Сегодня {date}",
    noAccess: "Нет доступа к показателям или данные не загружены.",
    noWidgets: "Для вашей роли на главной нет показателей. Выберите раздел в меню слева.",
    kpiTodaySales: "Продажи сегодня",
    kpiMonthSales: "Продажи за месяц",
    kpiMonthProfit: "Прибыль за месяц",
    kpiInventory: "Стоимость склада",
    trendTitle: "Динамика продаж",
    trendPeriod: "14 дней",
    debtTheyOwe: "Нам должны",
    debtWeOwe: "Мы должны",
    debtNet: "Итого",
    counterparties: "Контрагенты",
    cashTitle: "Остатки в кассах",
    cashEmpty: "Касс нет",
    topDebtorsTitle: "Крупнейшие должники",
    noDebtors: "Должников нет",
    viewAll: "Все",
    recentTitle: "Последние операции",
    recentEmpty: "Операций пока нет",
    recent: {
      salesInvoice: "Продажа",
      purchaseReceipt: "Приход",
      paymentIn: "Приход платежа",
      paymentOut: "Расход платежа",
    },
  },

  // Sidebar navigation (keyed by NAV_ITEMS key)
  nav: { education: "Обучение", "education-groups": "Обучение: группы и настройки", purchases: "Закупки", "purchases-orders": "Заявки", "sales-orders": "Заказы", "job-orders": "Заказы", "job-orders-orders": "Заказы", integrations: "Интеграции",
    dashboard: "Главная",
    contacts: "Контакты",
    tasks: "Задачи",
    inbox: "Входящие",
    calls: "Звонки",
    reviews: "Отзывы",
    funnels: "Воронки",
    "purchases-procurement": "Снабжение",
    "purchases-receipts": "Приходы",
    "purchases-returns": "Возвраты",
    sales: "Продажи",
    "sales-invoices": "Продажи",
    "sales-returns": "Возвраты",
    "job-orders-proposals": "Коммерческое предложение",
    inventory: "Товары",
    counterparties: "Контрагенты",
    "counterparties-list": "Контрагенты",
    "counterparties-contracts": "Договоры",
    "counterparties-aktsverka": "Акт-сверка",
    sklad: "Склад",
    "sklad-balances": "Остатки",
    "sklad-valuation": "Себестоимость",
    "sklad-transfers": "Перемещения",
    "sklad-warehouses": "Склады",
    "sklad-lowstock": "Низкий остаток",
    finance: "Финансы",
    "finance-balance": "Баланс компании",
    "finance-pnl": "Прибыль и убытки",
    "finance-analysis": "Анализ",
    "finance-payments": "Платежи", "finance-requests": "Заявки",
    "finance-debts": "Долги",
    "finance-conversions": "Конвертация",
    "finance-cashboxes": "Кассы",
    "finance-scheduled": "Обязательные платежи",
    "finance-assets": "Активы",
    production: "Производство",
    "production-orders": "Производство",
    "production-packaging": "Упаковка",
    "production-bom": "Рецепты (BOM)",
  
    analytics: "Аналитика",
  },

  analysis: {
    title: "Анализ",
    subtitle: "Распределение поступивших средств по нормам расходов помесячно",
    income: "Поступило",
    allocated: "Выделено",
    spent: "Потрачено",
    available: "Доступно",
    carryIn: "С прошлого месяца",
    normSum: "Сумма норм",
    normHint: "Рекомендуется, чтобы сумма норм составляла 100%.",
    empty: "Нет категорий расходов.",
    remain: "Остаток",
    over: "Превышено",
    toNextMonth: "Переходит на след. месяц",
    loadError: "Ошибка загрузки данных",
    error: "Произошла ошибка",
    date: "Дата",
    total: "Итого",
    noSpend: "В этом месяце расходов не было.",
    spentTotal: "Всего потрачено",
    allocatedRow: "Доступно (норма)",
    carryShort: "(пр. месяц)",
    diffRow: "Разница → на след. месяц",
    diffHint: "Разница положительная — остаток переходит на следующий месяц; отрицательная — бюджет превышен.",
    readonly: "Только для чтения",
    noCounterparty: "Без контрагента",
    unitK: "тыс", unitM: "млн", unitB: "млрд",
    configNorms: "Настроить проценты",
    normsTitle: "Проценты категорий (норма)",
    normsHint: "Укажите, какой процент от месячного дохода выделяется каждой категории.",
    normsSaved: "Проценты сохранены",
    byCategoryTitle: "По категориям (за месяц)",
    colName: "Название",
    colSumma: "Сумма",
    colNorma: "Норма",
    colReal: "Реал %",
    colResult: "Результат",
    resultHint: "Результат = Норма − Реал. Плюс (зелёный) — потрачено меньше нормы; минус (красный) — превышение.",
    save: "Сохранить",
    cancel: "Отмена",
  },

  // Account settings page
  account: {
    title: "Настройки аккаунта",
    subtitle: "Редактирование личных данных",
    personalInfo: "Личные данные",
    name: "Имя",
    email: "Email",
    emailHint: "(для восстановления пароля)",
    emailPlaceholder: "example@mail.com",
    phone: "Телефон",
    phoneHint: "Номер телефона изменить нельзя",
    save: "Сохранить",
    saving: "Сохранение...",
    profileUpdated: "Профиль обновлён",
    genericError: "Произошла ошибка",
    changePassword: "Изменить пароль",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите новый пароль",
    passwordMismatch: "Новые пароли не совпадают",
    passwordTooShort: "Пароль должен содержать минимум 4 символов",
    passwordChanged: "Пароль успешно изменён",
    changePasswordBtn: "Изменить пароль",
    namePlaceholder: "Полное имя",
    role: "Роль",
    hide: "Скрыть",
    show: "Показать",
  },

  // Settings page
  settings: {
    title: "Настройки",
    back: "Назад",
    tabs: {
      general: "Общие настройки",
      branding: "Брендинг",
      modules: "Меню",
      users: "Пользователи",
      workers: "Рабочие",
      roles: "Роли",
      currencies: "Валюты",
      uom: "Единицы измерения",
      company: "Компания",
      assets: "Активы",
      trash: "Корзина",
      funnels: "Воронки",
      tasks: "Задачи",
      "deal-sources": "Источники сделок",
      "close-reasons": "Причины закрытия",
      "lead-forms": "Формы",
      goals: "Цели",
      integrations: "Интеграции",
      inbox: "Входящие",
      atc: "Телефония (АТС)",
      "ai-calls": "AI-анализ звонков",
      "api-keys": "API-ключи",
      "google-sheets": "Google Таблицы",
      "owner-bot": "Бот руководителя",
      education: "Обучение",
      "lead-fields": "Поля лидов",
      audit: "Журнал аудита",
    },
    groups: {
      team: "Сотрудники",
      general: "Общее", crm: "CRM", channels: "Интеграции", system: "Система",
    },
    atc: {
      title: "Интеграция АТС / IP-телефонии",
      subtitle: "Настройки webhook для АТС Mediateka (Sarkor Telekom), Sipuni или Utel",
      connected: "Подключено",
      notConnected: "Не подключено",
      provider: "Провайдер АТС",
      callBtn: "Кнопка «Позвонить»",
      modeAtc: "Только через АТС",
      modePersonal: "Только с личного телефона",
      modeBoth: "Оба варианта — сотрудник выбирает",
      callBtnHint: "Относится ко всем кнопкам «Позвонить» на страницах «Контакты», «Лиды» и «Звонки». Если АТС не подключена, независимо от этой настройки всегда используется личный телефон.",
      popupTitle: "Кому показывать уведомление о входящем звонке (в правом верхнем углу)",
      popupHint: "Если никто не выбран — показывается всем (по умолчанию). Владелец/админ видит всегда.",
      popupNoRoles: "Пользовательские роли не созданы — пока эта настройка действует для всех",
      crmToken: "CRM Token",
      tokenPlaceholder: "Введите секретный токен...",
      tokenHint: "Добавляется в webhook URL для АТС. Может быть любым значением.",
      webhookTitle: "Webhook URL для указания в АТС:",
      copied: "Скопировано!",
      copy: "Копировать",
      sipuniWebhookHint: "В кабинете Sipuni: Настройки → API → раздел «Событие звонка» (PBX Events).",
      utelDomain: "Домен Utel",
      utelDomainHint: "Поддомен вашей АТС, например cc999 (адрес cc999.utel.uz).",
      utelEmail: "Email в Utel",
      utelPassword: "Пароль в Utel",
      utelPasswordHint: "Пароль нужен один раз, чтобы получить токен; в CRM он не сохраняется.",
      utelConnect: "Подключить Utel",
      utelReconnect: "Подключить заново",
      utelConnecting: "Подключаем…",
      utelConnectedTo: "Подключено: {domain}",
      utelConnectedOk: "Utel подключён",
      utelNeedConnect: "Сначала подключите Utel (логин и пароль от кабинета).",
      utelCheck: "Проверить подключение",
      utelTokenOk: "Доступ к API Utel работает",
      utelTokenBad: "Токен не принят Utel: подключите заново",
      utelWebhookFound: "Webhook прописан в Utel",
      utelWebhookMissing: "Webhook с нашим адресом в Utel не найден: добавьте его (см. ниже)",
      utelEventsOn: "Включены события",
      utelEventsOff: "Выключены",
      utelExtensions: "Внутренние номера в Utel",
      utelNoExtensions: "Список номеров не получен",
      utelSync: "Догрузить звонки за 3 дня",
      utelSynced: "Загружено звонков: {n}",
      utelSyncFailed: "Не удалось загрузить историю",
      utelWebhookHint: "В панели Utel: Интеграция → Webhook вставьте этот адрес и включите события call_started, dial_answered, call_ended, call_saved (можно также dial_started).",
      utelNoClickToCall: "Кнопка «Позвонить» работает через метод Utel (services/originate). Поля запроса в документации не описаны, поэтому при первом звонке CRM подбирает формат сама: сделайте тестовый звонок и проверьте.",
      unknownTitle: "Звонки с неизвестных номеров",
      unknownHint: "Если подходящий контакт не найден — контакт создаётся автоматически. Если хотите, чтобы автоматически создавался и лид, выберите, куда он попадёт (необязательно).",
      noLead: "— Не создавать лид —",
      noStage: "— Этап не выбран —",
      apiToken: "API Token (для Click-to-call)",
      apiTokenHint: "Токен management API АТС Mediateka (ibrat.sip.uz) (для исходящих звонков originate)",
      sipDomainHint: "Только имя домена. Для Click-to-call:",
      sipuniUser: "Номер аккаунта Sipuni (user)",
      sipuniUserHint: "Номер аккаунта в личном кабинете Sipuni",
      sipuniSecret: "Sipuni Secret Key",
      sipuniSecretHint: "Секретный ключ из раздела Sipuni → Настройки → API (для click-to-call)",
      save: "Сохранить",
      saved: "Сохранено",
      error: "Ошибка",
    },
    branding: {
      title: "Брендинг",
      subtitle: "Название организации, логотип и фирменный цвет — приложение откроется в этом виде",
      orgName: "Название организации",
      orgNamePlaceholder: "Название компании",
      logo: "Логотип",
      removeLogo: "Удалить",
      brandColor: "Фирменный цвет",
      defaultGreen: "Стандартный (зелёный)",
      customColor: "Свой цвет", solidTitle: "Боковая/верхняя панель в исходном цвете", solidHint: "Если включено — боковое меню и верхняя панель показываются точно в выбранном цвете (без затемнения). Выключено — как сейчас, тёмный оттенок.",
      preview: "Предпросмотр",
      primaryBtn: "Основная кнопка",
      badge: "Метка",
      linkText: "Текст ссылки",
      save: "Сохранить",
      imageOnly: "Только файл изображения",
      uploadError: "Ошибка загрузки",
      nameRequired: "Название организации обязательно",
      saved: "Брендинг сохранён",
      error: "Ошибка",
    
    upload: "Загрузить",
  },
    users: {
      countPrefix: "Всего",
      countSuffix: "пользователей", searchPlaceholder: "Имя или телефон...", noResults: "Ничего не найдено",
      seats: "Мест по тарифу: {used} из {total}",
      add: "Добавить",
      thUser: "Пользователь",
      thPhone: "Телефон",
      thRole: "Роль",
      thDept: "Отдел", noDept: "Без отдела",
      thStatus: "Статус",
      you: "Вы",
      userType: "Тип сотрудника", userTypeNone: "Обычный сотрудник", userTypeHint: "Выберите роль: снабженец / сотрудник процесса / менеджер проекта (необязательно)",
      snabjenist: "Снабженец",
      active: "Активен",
      inactive: "Неактивен",
      editTitle: "Редактировать",
      changePasswordTitle: "Изменить пароль",
      deleteTitle: "Удалить",
      newUser: "Новый пользователь",
      editUser: "Редактировать пользователя",
      name: "Имя",
      namePlaceholder: "Полное имя",
      role: "Роль", position: "Должность",
      dept: "Отдел",
      deptNone: "— Не выбрано —", deptMulti: "Отделы (несколько)", noDeptsYet: "Отделов пока нет", cpFolders: "Папки контрагентов (доступ)", cpFoldersHint: "Снабженец видит контрагентов только из отмеченных папок. Если не отмечено — все.", noFoldersYet: "Папок пока нет",
      snabjenistHint: "Если включено, отображается в списке \"Ответственный\" в форме Снабжения",
      customRole: "Роль (RBAC)",
      customRoleNone: "— Без ограничений (полный) —",
      customRoleHint: "При назначении роли пользователь ограничивается её правами. owner/admin всегда полный доступ.", roleHint: "Администратор - полные права (RBAC игнорируется). User - ограниченный; ниже можно выбрать кастомную роль.", adminFullHint: "Администратор имеет доступ ко всем модулям - кастомная роль (RBAC) не нужна.",
      processWorker: "Сотрудник процесса",
      processWorkerHint: "Назначается на процессы заказа и может начинать/завершать/ставить на паузу",
      projectManager: "Менеджер проекта", cashier: "Кассир",
      projectManagerHint: "Может быть выбран ответственным менеджером в заказе (отображается в списке при создании заказа)",
      permissions: "Права доступа",
      cashboxes: "Привязанные кассы (для снабженца)",
      cashboxesHint: "При наличном Приходе пользователь сможет выбирать только эти кассы. Если оставить пустым, пользователь не сможет делать наличный Приход.",
      phone: "Телефон",
      phonePlaceholder: "90 123 45 67",
      email: "Email",
      emailHint: "(для восстановления пароля)",
      emailPlaceholder: "example@mail.com",
      password: "Пароль",
      passwordPlaceholder: "Минимум 6 символов",
      newPassword: "Новый пароль",
      passwordModalTitle: "Пароль —",
      cancel: "Отмена",
      save: "Сохранить",
      saving: "Сохранение...",
      change: "Изменить",
      deleteUser: "Удалить пользователя",
      deleteConfirmPrefix: "Подтвердите удаление ",
      deleteConfirmSuffix: "? Это действие нельзя отменить.",
      deleteBtn: "Удалить",
      deleting: "Удаление...",
      accountOwner: "Владелец аккаунта",
      loadError: "Не удалось загрузить пользователей",
      updated: "Пользователь обновлён",
      passwordChanged: "Пароль изменён",
      deleted: "Пользователь удалён",
      added: "Пользователь добавлен",
      genericError: "Произошла ошибка",
      passwordTooShort: "Пароль должен содержать минимум 4 символов",
      roles: { owner: "Владелец", admin: "Администратор", user: "Пользователь", cashier: "Кассир" },
    
    perms: { products: "Товары", 
    clients: "Клиенты",
  
    suppliers: "Поставщики",
  
    sales: "Продажи",
  
    purchases: "Закупки",
  
    reports: "Отчёты",
  },
  },
    currencies: {
      baseTitle: "Основная валюта",
      baseSubtitle: "Все цены отображаются в этой валюте",
      change: "Изменить",
      baseTag: "Основная",
      basePickTitle: "Выберите основную валюту",
      basePickHint: "Первая выбранная валюта станет основной",
      addTitle: "Дополнительные валюты",
      addSubtitle: "Курс показывается относительно основной валюты",
      add: "Добавить",
      empty: "Дополнительные валюты ещё не добавлены",
      pickBaseModal: "Выберите основную валюту",
      pickAddModal: "Выберите валюту",
      searchPlaceholder: "Поиск (USD, доллар...)",
      notFound: "Не найдено",
      rateModalTitle: "Курс —",
      editRateModalTitle: "Изменить курс —",
      editRateTooltip: "Изменить курс", bankRate: "Курс банка:", useBankRate: "Курс банка", bankRateHint: "Если включено, курс берётся из Центробанка (CBU) и обновляется при сохранении.", bankRateOn: "Берётся из курса банка", bankSource: "Курс Центробанка, дата:", bankError: "Не удалось получить курс банка (можно ввести вручную).",
      ratePlaceholder: "Например: 12700",
      rateHint: "Введите, скольким {base} равен 1 {code}",
      cancel: "Отмена",
      save: "Сохранить",
      saving: "Сохранение...",
      addBtn: "Добавить",
      rateInvalid: "Введите корректный курс",
      baseFirst: "Сначала выберите основную валюту",
      saved: "Настройки валют сохранены",
      error: "Произошла ошибка",
      names: {
        UZS: "Узбекский сум", USD: "Доллар США", EUR: "Евро", RUB: "Российский рубль",
        KZT: "Казахский тенге", GBP: "Фунт стерлингов", JPY: "Японская иена",
        CNY: "Китайский юань", TRY: "Турецкая лира", AED: "Дирхам ОАЭ", KGS: "Киргизский сом",
        TJS: "Таджикский сомони", TMT: "Туркменский манат", AZN: "Азербайджанский манат",
        GEL: "Грузинский лари", UAH: "Украинская гривна", BYN: "Белорусский рубль",
        SAR: "Саудовский риял", CAD: "Канадский доллар", AUD: "Австралийский доллар",
        CHF: "Швейцарский франк", INR: "Индийская рупия", KRW: "Южнокорейская вона",
        SEK: "Шведская крона", NOK: "Норвежская крона", DKK: "Датская крона",
        PLN: "Польский злотый", CZK: "Чешская крона", HUF: "Венгерский форинт", RON: "Румынский лей",
      },
    },
    general: {
      saved: "Сохранено",
      error: "Ошибка",
      soonBadge: "(скоро)",
      businessTitle: "Тип бизнеса",
      businessSubtitle: "Выберите, какие модули нужны вашей организации — боковое меню очистится соответственно",
      businessNote: "Режим влияет только на интерфейс — данные всегда сохраняются. Чтобы снова показать модуль, выберите \"Всё\".",
      skladTitle: "Склад", paymentsTitle: "Платежи", paymentsSubtitle: "Настройки документов прихода/расхода.", paymentStatusesTitle: "Статусы платежей", paymentStatusesHint: "Если включено, в приходе и расходе появляется поле статуса — можно добавлять/удалять статусы. Если выключено, поле статуса скрыто.", purchasesTitle: "Закупки", purchasesSubtitle: "Настройки документов закупок.", purchaseReturnsTitle: "Возврат закупок", salesTitle: "Разделы продаж", salesSubtitle: "Выберите, какие подразделы видны в меню Продажи.", salesOrders: "Заказы", salesInvoices: "Продажи (счета)", salesReturns: "Возвраты", salesSectionsHint: "Выключенный раздел скрывается из меню. Если выключить все — группа Продажи не показывается.", salesProductFolder: "Папка товаров", salesProductFolderHint: "В форме продажи показываются только товары из этой папки (и вложенных). Пусто = все.", purchaseReturnsHint: "Если включено, в разделе Закупки виден «Возврат». Если выключено — скрыт.", discountFieldTitle: "Поле скидки", discountFieldHint: "Если включено, в приходе и счетах продаж появляется столбец скидки (%). По умолчанию скрыт.", purchaseDefaultWarehouse: "Склад по умолчанию", purchaseDefaultWarehouseHint: "Склад, выбираемый автоматически при создании документов прихода. Пусто = не выбран.", productionDefaultWarehouses: "Склады по умолчанию", productionDefaultWarehousesHint: "Склады, выбираемые автоматически при создании документов производства.", productionDefaultRawWarehouse: "Склад сырья", productionDefaultFinishedWarehouse: "Склад готовой продукции", jobProcLaborTitle: "Оплата труда в процессе", jobProcLaborHint: "Показывает поле оплаты труда в процессах заказа. Если выключено — скрыто.", jobProcAllocatedTitle: "Выделенная сумма процесса", jobProcAllocatedHint: "Показывает поле выделенной суммы в процессах заказа. Если выключено — скрыто.", sketchRequiredTitle: "Эскиз обязателен", sketchRequiredHint: "Если включено, при создании заказа загрузка эскиза (изображение/PDF) обязательна. Если выключено (по умолчанию) — необязательно.", sketchInListTitle: "Эскиз в списке заказов", sketchInListHint: "Если включено, в списке заказов (после #) показывается 1-е изображение (эскиз) — по клику на лупу открывается полностью. Если изображения нет — пустой квадрат. По умолчанию выключено.", costWarnTitle: "Процент предупреждения о себестоимости", costWarnHint: "Если себестоимость заказа превышает этот процент от согласованной цены, в списке появляется красное предупреждение (для заказов в работе и завершённых). Например 50% — себестоимость больше половины цены. По умолчанию 50%.", ndsTitle: "Налог (НДС)", ndsSubtitle: "Включите, если организация является плательщиком НДС — в счетах продаж появятся колонки НДС.", hasNdsTitle: "Организация — плательщик НДС", hasNdsHint: "При включении в счетах продаж появятся колонки: код МКИX, ставка НДС, сумма НДС и Итого.", negCashboxTitle: "Касса может уходить в минус", negCashboxHint: "Если включено, расход может превысить остаток и баланс уйдёт в минус. Если выключено (по умолчанию) — расход больше остатка запрещён.", cashierTitle: "Кассир", cashierSubtitle: "Какие кассы видны сотрудникам типа Кассир.", cashierNoCashboxes: "Касс нет.", cashierHint: "Кассиру видны только отмеченные кассы. Если не отмечено ничего — ни одной.", cashierCpTitle: "Кассир — папки контрагентов", cashierCpSubtitle: "Из каких папок контрагенты доступны кассиру при приходе.", cashierNoFolders: "Папок нет.", cashierCpHint: "Кассиру видны только контрагенты из отмеченных папок. Если не отмечено ничего — ни одного.", snabjenistCpTitle: "Снабженист — папки поставщиков", snabjenistCpSubtitle: "Из каких папок поставщики видны снабженисту.", snabjenistCpHint: "Снабженисту видны только контрагенты из отмеченных папок. Если не отмечено ничего — видны все.", catCpTitle: "Категория \u2014 папка контрагентов", catCpSubtitle: "При выборе категории в платеже список контрагентов фильтруется по этой папке.", catCpEmpty: "Категорий нет.", catCpHint: "Для категории с \"Без контрагента\" (например Продукты) контрагент не запрашивается.", catCpAll: "Все контрагенты", catCpNone: "Без контрагента", catCpIncoming: "приход", catCpOutgoing: "расход",
      skladSubtitle: "Настройки продаж и остатков",
      jobFoldersTitle: "Показывать папки",
      negStockTitle: "Разрешить отрицательный остаток",
      negStockHint: "Если включено, можно продавать товар, которого нет на складе (остаток уйдёт в минус). Если выключено, при нехватке товара счёт продажи блокируется.",
      servSellTitle: "Продажа услуг",
      servSellHint: "Если включено, в инвентаре появятся кнопка \"+ Услуга\" и фильтр \"Услуга\" — можно добавлять и продавать позиции-услуги. Если выключено, работа только с товарами.",
      purchasesNote: "Режим влияет только на интерфейс — существующие данные сохраняются.",
      costingTitle: "Учёт себестоимости (COGS)",
      costingSubtitle: "Каким методом рассчитываются прибыль и стоимость склада",
      costingNote: "Примечание: при продаже себестоимость \"замораживается\" — при смене метода прибыль старых документов не меняется.",
      cpSectionTitle: "Контрагенты", cpStatusTitle: "Статус контрагента", cpStatusHint: "Включает поле статуса для контрагентов. Если выключено — колонка/фильтр/поле статуса скрыты.", cpFolderTitle: "Фильтр контрагентов", cpFolderSubtitle: "Фильтрация контрагентов по папке в формах",
      cpFolderAll: "Все (без фильтра)",
      cpSupplierFolder: "Папка для закупок / снабжения", cpSupplierFolderHint: "В формах закупок и снабжения показываются только поставщики из этой папки",
      cpCustomerFolder: "Папка для продаж / заказов", cpCustomerFolderHint: "В формах продаж и заказов показываются только клиенты из этой папки",
      cpFolderNone: "Без папки",
      cpJobOrderNewCustomerFolder: "Папка для новых клиентов в заказах", cpJobOrderNewCustomerFolderHint: "Новый клиент, добавленный из формы заказа, попадёт в эту папку", prodFolderTitle: "Производство — папки товаров", prodFolderSubtitle: "В форме производства выбор сырья и готовой продукции фильтруется по этим папкам (включая вложенные).", prodRawFolder: "Папка сырья", prodRawFolderHint: "В составе производства (сырьё) показываются только товары из этой папки. Пусто = все.", prodFinishedFolder: "Папка готовой продукции", prodFinishedFolderHint: "В выходе производства (готовая продукция) показываются только товары из этой папки. Пусто = все.", prodOutputBatchTitle: "Партия и срок годности готовой продукции", prodOutputBatchHint: "Если включено — в производстве появляются поля партии (№) и срока годности для готовой продукции. По умолчанию выключено.", navOrderTitle: "Порядок разделов", navOrderSubtitle: "Настройте порядок отображения разделов в боковой панели.", navOrderReset: "Сбросить",
      costing: {
        average: { label: "Средневзвешенная (AVCO)", hint: "Средняя себестоимость рассчитывается автоматически из приходов" },
        manual:  { label: "Вручную (себестоимость товара)", hint: "Используется себестоимость, введённая вручную" },
        fifo:    { label: "FIFO (первый пришёл — первый ушёл)", hint: "Послойная себестоимость: самая старая партия продаётся первой" },
        batch:   { label: "По партии (лоту)", hint: "При продаже выбирается партия, со сроком" },
      },
      business: {
        "job-order": { label: "Сборка (заказы)", hint: "Работает по заказу клиента — готовый товар не хранится на складе, передаётся клиенту напрямую. Модули Продажи и Производство скрыты." },
        production:  { label: "Производство", hint: "Производит готовую продукцию из сырья и продаёт её. Раздел Производство виден, модуль Заказы скрыт." },
      
    retail: { label: "Магазин (продажи)", 
    hint: "Розничный магазин — хранит товар на складе и продаёт клиентам. Модули «Заказы» и «Производство» скрыты.",
  },
  
    all: { label: "Всё (смешанный)", 
    hint: "Продажи, Заказы и Производство — всё отображается. Самый гибкий вариант.",
  },
  },
      procurement: {
        orders:      { label: "Заявки", hint: "Прямой заказ поставщику (PO) — простая модель работы." },
        procurement: { label: "Снабжение", hint: "Внутренний процесс снабжения: запрос снабженца → приход на склад. Для компаний с большой командой." },
        both:        { label: "Оба", hint: "Заявки и Снабжение — оба подменю видны." },
        none:        { label: "Только приходы", hint: "Заявки и Снабжение скрыты — только Приходы (и Возвраты)." },
      },
    
    jobFoldersSectionTitle: "Заказы — папки",
  
    jobFoldersHint: "Включает возможность организации папок (дерево папок) в разделе «Заказы». По умолчанию выключено.",
  },
  },

  // Settings → UOM & Company tabs
  settingsExtra: {
    uom: {
      customTitle: "Мои единицы измерения",
      customSubtitle: "Добавленные вами, можно удалять",
      add: "Добавить",
      customEmpty: "У вас пока нет своих единиц",
      thShort: "Краткое",
      thFull: "Полное название",
      deleteTitle: "Удалить",
      systemTitle: "Системные единицы измерения",
      systemSubtitle: "Общие для всех организаций, удалить нельзя",
      systemBadge: "Система", thVisible: "Видно", visibleHint: "Если отмечено — отображается в системе (формах и списках)", addDisabled: "Пока отключено",
      newUnit: "Новая единица измерения",
      shortName: "Краткое название",
      shortNamePlaceholder: "Например: кг, шт, м²",
      shortNameHint: "Краткое обозначение в карточке товара",
      fullName: "Полное название",
      fullNamePlaceholder: "Например: Килограмм, Штука, Квадратный метр",
      cancel: "Отмена",
      saving: "Сохранение...",
      addBtn: "Добавить",
      added: "Единица измерения добавлена",
      deleted: "Единица измерения удалена",
      loadError: "Не удалось загрузить единицы измерения",
      error: "Произошла ошибка",
      groups: {
        count: "Количество",
        weight: "Вес",
        length: "Длина",
        areaVol: "Площадь и объём",
        liquid: "Жидкость",
        packaging: "Упаковка и тара",
        time: "Время",
        service: "Услуги",
        other: "Другое",
      },
    },
    trash: {
      retentionLabel: "Срок хранения",
      never: "Никогда не удалять",
      neverMark: "Не удаляется",
      retentionSaved: "Срок сохранён",
      subtitleNever: "записи никогда не удаляются автоматически. При восстановлении возвращаются и связанные данные (заметки, привязки).",
      title: "Корзина",
      subtitlePrefix: "Удалённые записи",
      subtitleSuffix: "навсегда удаляются через указанное число дней. При восстановлении возвращаются и связанные данные (заметки, привязки).",
      searchPlaceholder: "Название, телефон...",
      empty: "Корзина пуста",
      thType: "Тип",
      thDetails: "Детали",
      thName: "Название",
      thDeletedBy: "Кто удалил", allTypes: "Все типы", allUsers: "Все пользователи",
      kinds: { Contact: "Контакт", Deal: "Сделка", Task: "Задача", Funnel: "Воронка" },
      thDate: "Дата",
      thLeft: "Осталось",
      daysSuffix: "дн.",
      restoreTitle: "Восстановить",
      permDeleteTitle: "Удалить навсегда",
      modalTitle: "Удалить навсегда",
      confirmSuffix: "— удалить навсегда? Это действие нельзя отменить — запись и прикреплённые файлы будут удалены. Если это воронка, её сделки тоже удалятся.",
      cancel: "Отмена",
      deleting: "Удаление...",
      permDeleteBtn: "Удалить навсегда",
      restored: "Восстановлено",
      restoreError: "Ошибка восстановления",
      permDeleted: "Удалено навсегда",
      deleteError: "Ошибка удаления",
      loadError: "Ошибка загрузки",
    },
    audit: {
      title: "Журнал аудита",
      subtitle: "Кто, когда и что сделал",
      thTime: "Время",
      thUser: "Пользователь",
      thAction: "Действие",
      thBranch: "Отдел",
      thObject: "Объект",
      thIp: "IP",
      view: "Просмотр",
      detailTitle: "Детали записи",
      fResource: "Отдел / ресурс",
      fId: "ID объекта",
      fMethod: "Метод",
      fPath: "Адрес",
      fStatus: "Статус",
      allUsers: "Все пользователи",
      dateFrom: "С даты",
      dateTo: "По дату",
      thModule: "Модуль",
      modules: { trash: "Корзина", organization: "Настройки", uom: "Единицы измерения", inventory: "Товары", counterparty: "Контрагенты", warehouse: "Склады", purchases: "Закупки", sales: "Продажи", payments: "Платежи", "payment-requests": "Запросы на оплату", integrations: "Интеграции", cashbox: "Кассы", conversions: "Конвертация", transfers: "Перемещения", reports: "Отчёты", upload: "Файлы", trash: "Корзина", export: "Экспорт", production: "Производство", departments: "Отделы", branches: "Филиалы", "job-orders": "Заказы", proposals: "Предложения", "job-order-folders": "Папки заказов", contracts: "Договоры", "akt-sverka": "Акт сверки", procurement: "Снабжение",
        contacts: "Контакты", funnels: "Воронки", tasks: "Задачи", "lead-forms": "Лид-формы", inbox: "Входящие", instagram: "Instagram", facebook: "Facebook", whatsapp: "WhatsApp", atc: "IP-телефония", "lead-journey": "Путь лида", email: "Email", push: "Push-уведомления", reviews: "Отзывы", yandex: "Яндекс",
        "organization-users": "Пользователи", "organization-roles": "Роли", "organization-currencies": "Настройки валют", "organization-settings": "Общие настройки", "organization-contact-fields": "Поля контакта", "organization-deal-fields": "Поля сделки", "organization-task-stages": "Этапы задач", "organization-deal-sources": "Источники сделок", "organization-close-reasons": "Причины закрытия", "organization-goals": "Цели", "organization-sticker-packs": "Наборы стикеров", "organization-telegram-bot": "Telegram-бот", "organization-telegram-accounts": "Telegram-аккаунт",
        "funnels-deals": "Сделки", "funnels-deal-activities": "Комментарии к сделке", "funnels-deal-files": "Файлы сделки", "call-analysis": "AI-анализ звонков", "contacts-activities": "Комментарии к контакту" },
      actions: { create: "Создал", update: "Изменил", delete: "Удалил", login: "Вход", logout: "Выход", register: "Регистрация", password_change: "Сменил пароль", profile_update: "Обновил профиль", view: "Просмотрел" },
      loadError: "Ошибка загрузки",
    
    empty: "Записей нет",
  },
    company: {
      subBranches: "Филиалы",
      subDepartments: "Отделы",
      branches: {
        title: "Филиалы",
        subtitle: "Филиалы организации — отделы можно привязывать к этим филиалам",
        add: "Добавить",
        empty: "Филиалов нет",
        thName: "Название",
        thActions: "Действия",
        newBranch: "Новый филиал",
        editBranch: "Редактировать филиал",
        name: "Название",
        namePlaceholder: "Главный офис, филиал Чиланзар...",
        nameRequired: "Название обязательно",
        cancel: "Отмена",
        save: "Сохранить",
        deleteTitle: "Удалить филиал",
        deleteSuffix: "— удалить этот филиал? У отделов этого филиала привязка к филиалу будет снята (сами отделы сохранятся).",
        deleteBtn: "Удалить",
        added: "Добавлено",
        updated: "Обновлено",
        deleted: "Удалено",
        loadError: "Ошибка загрузки",
        error: "Ошибка",
      },
      departments: {
        title: "Отделы (производственные процессы)",
        subtitle: "Процессы внутри заказа выбираются из этих отделов (резка, склейка, покраска...)",
        add: "Добавить",
        empty: "Отделов нет",
        thName: "Название",
        thBranch: "Филиал",
        thActions: "Действия",
        newDept: "Новый отдел",
        editDept: "Редактировать отдел",
        name: "Название",
        namePlaceholder: "Резка, Покраска...",
        branch: "Филиал",
        branchNone: "— Не выбрано —",
        thType: "Тип",
        type: "Тип отдела",
        typeProcess: "Рабочий процесс",
        typeManagement: "Управление",
        typeHint: "При добавлении процесса заказа показываются только отделы \"рабочего процесса\" (не управленческие).",
        cancel: "Отмена",
        save: "Сохранить",
        deleteTitle: "Удалить отдел",
        deleteSuffix: "— удалить этот отдел? Соответствующая привязка у пользователей будет снята (но сами пользователи сохранятся).",
        deleteBtn: "Удалить",
        added: "Отдел добавлен",
        updated: "Обновлено",
        deleted: "Удалено",
        loadError: "Ошибка загрузки",
        error: "Ошибка",
      },
    },
  },

  // Top navbar
  units: {
    billion: "млрд",
    million: "млн",
    thousand: "тыс",
  },

  analytics: {
    title: "Аналитика",
    subtitle: "Вся статистика по продажам, звонкам, контактам и каналам в одном месте",
    tabs: {
      director: "Руководитель",
      sales: "Продажи",
      calls: "Звонки",
      funnels: "Воронки",
      journey: "Путь лидов",
      quality: "Качество звонков",
      contacts: "Контакты",
      inbox: "Входящие",
      reviews: "Отзывы",
    },
    period: {
      "7d": "7 дней",
      "30d": "30 дней",
      "90d": "90 дней",
      month: "Этот месяц",
      custom: "Период",
    },
    director: {
      reportFor: "Отчёт по",
      allStaff: "Все сотрудники",
      staffN: "Сотрудников: {n}",
      period: {
        today: "За сегодня",
        yesterday: "За вчера",
        thisWeek: "За эту неделю",
        lastWeek: "За прошлую неделю",
        thisMonth: "За этот месяц",
        lastMonth: "За прошлый месяц",
        quarter: "За квартал",
        year: "За этот год",
        custom: "Свой период",
      },
      sum: {
        dealsInWork: "Сделок в работе",
        notes: "Добавлено примечаний",
        tasksInWork: "Задач в работе",
        purchases: "Успешных сделок (сумма покупок)",
      },
      deals: {
        title: "Сделки",
        inWork: "В работе",
        new: "Новые",
        lost: "Потерянные",
        won: "Успешные",
        note: "«В работе» — сделки, открытые сейчас. «Новые» — созданные за период. «Потерянные» и «Успешные» — закрытые за период. Процент — доля успешных среди всех сделок.",
      },
      contacts: {
        title: "Контакты",
        total: "Всего",
        new: "Новых за период",
      },
      events: {
        title: "События",
        dealsCreated: "Создано сделок",
        contactsCreated: "Создано контактов",
        stageChanges: "Смена этапов",
        tasksCompleted: "Завершённые задачи",
        withResult: "с результатом: {n}",
        notes: "Добавлено примечаний",
        files: "Прикреплено файлов",
        callsIn: "Входящих звонков",
        callsOut: "Исходящих звонков",
      },
      tasks: {
        title: "Задачи",
        type: {
          call: "Связаться",
          meeting: "Встреча",
          other: "Другое",
        },
        new: "Новых",
        overdue: "Просроченных",
        done: "Выполненных",
        completion: "Доля выполнения",
        avgTime: "Среднее время выполнения",
        hours: "ч",
        days: "дн.",
        dueToday: "На сегодня",
        unassigned: "Без ответственного",
      },
      staff: {
        title: "Сотрудники: общая картина",
        employee: "Сотрудник",
        dealsCreated: "Сделок",
        contactsCreated: "Контактов",
        stageChanges: "Смен этапов",
        notes: "Примечаний",
        tasksCompleted: "Задач выполнено",
        tasksOpen: "Задач в работе",
        tasksOverdue: "Просрочено",
        callsIn: "Входящих",
        callsOut: "Исходящих",
      },
    },
    loadError: "Не удалось загрузить данные",
    empty: "За выбранный период данных нет",
    sales: {
      created: "Новые сделки",
      won: "Выиграно",
      lost: "Проиграно",
      conversion: "Конверсия",
      cycle: "Цикл сделки",
      days: "дн.",
      avgDeal: "Средний чек {v}",
      activeNow: "В работе сейчас: {n}",
      dynamics: "Динамика сделок",
      lostReasons: "Причины отказов",
      noReason: "Причина не указана",
      byManager: "По менеджерам",
      thManager: "Менеджер",
      thSum: "Сумма продаж",
      noManager: "Без ответственного",
      ownership: "Закреплено за сотрудниками",
      ownLeads: "Лиды в работе",
      ownLeadsShared: "из них совместных",
      ownContacts: "Контакты",
      ownContactsShared: "из них совместных",
      ownershipNote: "Если у лида или контакта несколько ответственных, он учитывается у каждого из них.",
      bySource: "Источники: пришло → выиграно",
      noSource: "Источник не указан",
      allFunnels: "Все воронки",
      allManagers: "Все менеджеры",
      pipeline: "Воронка сейчас",
    },
    funnels: {
      view_intake: "Поступление лидов",
      view_staff: "По сотрудникам",
      noFunnels: "Воронок пока нет",
      total: "Всего лидов",
      assigned: "Назначено менеджеру",
      notAssigned: "Не назначено",
      assignRate: "Доля назначенных",
      noLeads: "За этот период лидов не было",
      staffHint: "Сколько лидов завёл каждый сотрудник из этой воронки и их текущее состояние (учитываются и переданные в другие воронки).",
      thEmployee: "Сотрудник",
      thTotal: "Всего",
      thActive: "Активные",
      thWon: "Выиграно",
      thLost: "Проиграно",
    },
    reviews: {
      scans: "Сканирования QR",
      clicks: "Переходы на отзыв",
      conversion: "Конверсия",
      pending: "Новые жалобы",
      newReviews: "Новые отзывы с карт",
    },
  },

  ui: {
    filters: "Фильтры",
    reset: "Сбросить",
    done: "Готово",
    more: "Ещё",
    clearAll: "Очистить всё",
    search: "Поиск",
    sort: "Сортировка",
    assignee: "Ответственный",
    source: "Источник",
    created: "Дата создания",
    dateFrom: "С",
    dateTo: "По",
    all: "Все",
    none: "Не указано",
    back: "Назад",
    cancel: "Отмена",
    save: "Сохранить",
    delete: "Удалить",
    selected: "Выбрано: {n}",
  },

  // Автоматически вынесенные тексты интерфейса (loc.<файл>.<ключ>)
  loc: {
    registerPage: {
      thisSlugIsTakenChoose: "Этот slug занят. Выберите другой",
      takeYourBusiness: "Переведите свой бизнес",
      digital: "в цифровой формат",
      warehouseSalesCustomersAndFinance: "Склад, продажи, клиенты и финансы — всё в одной системе.",
      whatIsASlug: "Что такое slug?",
      aSlugIsYourOrganization: "Slug — уникальный идентификатор вашей организации в системе. Например:",
      youWillUseThisSlug: ". Этот slug используется при входе.",
      "2025CrmLineAllRights": "© 2025 CRM Line. Все права защищены.",
      createAnOrganization: "Создание организации",
      createAnAccountAndGet: "Создайте аккаунт и начните работу сразу",
      organization: "Организация",
      organizationName: "Название организации",
      eGBarakaSavdo: "Например: Baraka Savdo",
      organizationSlug: "Slug организации",
      uniqueIdInTheSystem: "(уникальный ID в системе)",
      thisSlugIsTakenChoose2: "Этот slug занят. Выберите другое имя",
      thisSlugIsAvailable: "✓ Этот slug свободен",
      forSignIn: "Для входа:",
      organizationType: "Тип организации",
      adminAccount: "Аккаунт администратора",
      yourName: "Ваше имя",
      firstLastName: "Имя Фамилия",
      phone: "Телефон",
      forSignIn2: "(для входа)",
      email: "Email",
      forPasswordRecovery: "(для восстановления пароля)",
      password: "Пароль",
      confirm: "Подтверждение",
      loading: "Загрузка...",
      alreadyHaveAnAccount: "Уже есть аккаунт?",
      signIn: "Войти",
    },
    callButton: {
      startingCall: "Начинаем звонок...",
      noExtensionIsAssignedTo: "Вам не назначен внутренний номер. Обратитесь к администратору.",
      pbx: "{title} (АТС)",
      viaPbx: "Через АТС",
      fromPersonalPhone: "С личного телефона",
    },
    callRecordingPlayer: {
      download: "Скачать запись",
      downloadFailed: "Не удалось скачать запись",
      couldNotLoadTheCall: "Не удалось загрузить запись звонка",
      couldNotLoadTheRecording: "Не удалось загрузить запись",
      speed: "Скорость",
    },
    categoryProductPicker: {
      selected: "Выбрано: {size}",
      nothingSelected: "Ничего не выбрано",
      done: "Готово",
    },
    incomingCallModal: {
      incomingCall: "Входящий звонок",
      outgoingCall: "Исходящий звонок",
      crmContact: "Контакт CRM",
      assignee: "Ответственный:",
      openContact: "Открыть контакт",
      unknownNumber: "Неизвестный номер",
      notFoundInCrm: "Не найден в CRM",
      extension: "Добавочный:",
      close: "Закрыть",
      contact: "Контакт",
    },
    lockScreen: {
      opened: "Открыто",
      wrongPassword: "Неверный пароль",
      signOutOfTheAccount: "Полностью выйти из аккаунта?",
      user: "Пользователь",
      passwordToUnlockTheScreen: "Пароль для разблокировки экрана",
      password: "Пароль",
      unlock: "Открыть",
      signInWithAnotherAccount: "Войти под другим аккаунтом",
    },
    accountPage: {
      saved: "Сохранено",
      somethingWentWrong: "Произошла ошибка",
      extension: "Внутренний номер",
      notAssigned: "Не назначен",
      yourPbxExtensionSipuniIbrat: "Ваш внутренний номер АТС (Sipuni/ibrat.sip.uz) — назначает и меняет только администратор в Настройки → Сотрудники.",
      thisNumberIsAlsoUsed: "Этот номер также используется для входа в систему — менять его может только администратор в Настройки → Сотрудники.",
      email: "Email",
      atLeast4Characters: "минимум 4 символа",
    },
    callsPage: {
      error: "Ошибка",
      linkCall: "Привязать звонок",
      number: "Номер:",
      contact: "Контакт",
      searchForAContact: "Найдите контакт...",
      remove: "Убрать",
      deal: "Сделка",
      enterDealTitle: "Введите название сделки...",
      cancel: "Отмена",
      save: "Сохранить",
      failedToLoad: "Не удалось загрузить",
      selected: "Выбрано: {size}",
      changeTheFilterOrSearch: "Измените фильтр или поиск",
      link: "Привязать",
      callBack: "Перезвонить",
      delete: "Удалить",
      previous: "Назад",
      next: "Далее",
    },
    contactAnalyticsPage: {
      text: "{count} шт. · {date}",
      newContactsInPeriod: "Новые контакты за период",
      totalContacts: "Всего контактов",
      allTime: "За всё время",
      newContactsPerDay: "Новые контакты по дням ({from} — {to})",
      byChannelViaInbox: "По каналам (через «Входящие»)",
      noData: "Нет данных",
      byOperator: "По оператору",
      noPhoneNumbers: "Нет номеров телефонов",
    },
    contactFormPage: {
      select: "— Выберите",
      notSaved: "Не сохранено",
      chooseFile: "Выбрать файл",
      call: "звонок",
      outgoing: "Исходящий",
      incoming: "Входящий",
      ext: "· Доб.: {ext}",
      contactNotFound: "Контакт не найден",
      nameIsRequired: "Введите имя",
      contactAdded: "Контакт добавлен",
      saved: "Сохранено",
      somethingWentWrong: "Произошла ошибка",
      fileUploaded: "Файл загружен",
      uploadFailed: "Ошибка загрузки",
      deleteTheFile: "Удалить файл?",
      fileDeleted: "Файл удалён",
      deleteFailed: "Ошибка удаления",
      blockRemoved: "Блокировка снята",
      contactBlocked: "Контакт заблокирован",
      contactDeleted: "Контакт удалён",
      phone: "Телефон",
      format998xxxxxxxxx: "Формат: +998XXXXXXXXX",
      email: "Email",
      assignee: "Ответственный",
      notAssigned: "Не назначен",
      loading: "Загрузка...",
      uploadFile: "+ Загрузить файл",
      saveTheContactFirstTo: "Чтобы загрузить файл, сначала сохраните контакт",
      noFilesYet: "Файлов пока нет",
      download: "Скачать",
      sections: "Разделы",
      main: "Основной",
      phoneEmailResponsiblePerson: "Телефон · Email · Ответственное лицо",
      fields: "Полей: {length}",
      sectionName: "Название раздела...",
      addNewSection: "Добавить новый раздел",
      fields2: "Поля",
      noFieldsYet: "Полей пока нет",
      fieldName: "Название поля...",
      options: "Варианты",
      atLeast1: "(минимум 1)",
      optionName: "Название варианта...",
      save: "Сохранить",
      cancel: "Отмена",
      add: "Добавить",
      addField: "Добавить поле",
      shiftEnterNewLine: "Shift+Enter — новая строка",
    },
    contactsPage: {
      deleteContact: "Удалить контакт",
      thisActionCannotBeUndone: "Это действие нельзя отменить.",
      contactsWillBeDeleted: "контактов будет удалено.",
      text: "{count} шт.",
      willBeDeleted: "будет удалён.",
      cancel: "Отмена",
      delete: "Удалить",
      onlyCsvFilesAreAccepted: "Принимаются только CSV-файлы",
      importError: "Ошибка импорта",
      csvImport: "Импорт CSV",
      importComplete: "Импорт завершён!",
      contactsAdded: "контактов добавлено,",
      skippedExistingOrEmpty: "пропущено (уже есть или пустые).",
      text2: "{created} шт.",
      text3: "{skipped} шт.",
      close: "Закрыть",
      csvFileFormat: "Формат CSV-файла:",
      theFirstRowMustContain: "Первая строка должна содержать названия столбцов.",
      dropTheCsvFileHere: "Перетащите CSV-файл сюда",
      orClickToChoose: "или нажмите и выберите",
      rows: "{v} — строк: {length}",
      clear: "Очистить",
      more: "… ещё",
      rows2: "строк",
      import: "Импортировать (",
      text4: ")",
      failedToLoad: "Не удалось загрузить",
      merged: "Объединено",
      error: "Ошибка",
      duplicateContacts: "Дубликаты контактов",
      noDuplicates: "Дубликатов нет",
      allGood: "Всё в порядке!",
      duplicateNumbers: "Повторяющихся номеров: {count}",
      merge: "Объединить",
      created: "Создан: {toLocaleDateString}",
      willBeSaved: "Будет сохранено",
      failedToLoadContacts: "Не удалось загрузить контакты",
      convertAllContactPhoneNumbers: "Привести все телефоны контактов к формату +998XXXXXXXXX?",
      numbersNormalized: "Нормализовано номеров: {updated}",
      somethingWentWrong: "Произошла ошибка",
      csvDownloaded: "CSV скачан",
    },
    dealDetailPage: {
      call: "звонок",
      outgoing: "Исходящий",
      incoming: "Входящий",
      ext: "· Доб.: {ext}",
      select: "— Выберите",
      noOptions: "Нет вариантов",
      failedToLoad: "Не удалось загрузить",
      titleIsRequired: "Введите название",
      saved: "Сохранено",
      assignedToYou: "Вы взяли себе",
      error: "Ошибка",
      deleted: "Удалено",
      archived: "Архивировано",
      restoredFromArchive: "Возвращено из архива",
      closedAsWon: "Закрыто как «Выиграно»",
      closedAsLost: "Закрыто как «Проиграно»",
      reopened: "Открыто заново",
      fileUploaded: "Файл загружен",
      uploadFailed: "Ошибка загрузки",
      newRequest: "Новая сделка",
      newDeal: "Новая сделка",
      request: "Лид",
      won: "Выиграно",
      lost: "Проиграно",
      reopen: "Открыть заново",
      closeAsWon: "Закрыть как «Выиграно»",
      closeAsLost: "Закрыть как «Проиграно»",
      restoreFromArchive: "Вернуть из архива",
      archive: "В архив",
      reasonOptional: "Причина (необязательно)",
      whyWasItLost: "— почему проиграна?",
      noReasonSelected: "— Причина не выбрана —",
      eGTheClientSigned: "Например: клиент подписал договор",
      eGThePriceDid: "Например: не устроила цена",
      close: "Закрыть",
      reasonComment: "Причина (комментарий) *",
      whyIsItBeingArchived: "Почему архивируется?",
      clientName: "Имя клиента...",
      dealTitle: "Название сделки...",
      source: "Источник",
      notSelected: "— Не выбрано —",
      note: "Комментарий",
      noNotes: "Нет комментариев",
      notFound: "Не найдено",
      loading: "Загрузка...",
      contact: "Контакт",
      blocked: "Заблокирован",
      phone: "Телефон",
      email: "Email",
      reminder: "Напоминание",
      overdue: "Просрочено",
      openContact: "Открыть контакт",
      notSelected2: "— Не выбрано",
      takeIt: "Взять себе",
      created: "Создано",
      days: "дн.",
      call2: "Звонок",
      inOut: "Вх./Исх.",
      missedCalls: "Пропущенные звонки",
      activityOverTheLast14: "Активность за последние 14 дней",
      callHistory: "История звонков",
      noCallsYet: "Звонков пока нет",
      uploadFile: "+ Загрузить файл",
      saveFirstToUploadFiles: "Чтобы загрузить файл, сначала сохраните",
      noFilesYet: "Файлов пока нет",
      download: "Скачать",
      sections: "Разделы",
      main: "Основной",
      stageAmountSourceContactAssignee: "Этап · Сумма · Источник · Контакт · Ответственный",
      fields: "Полей: {length}",
      sectionName: "Название раздела...",
      addNewSection: "Добавить новый раздел",
      fields2: "Поля",
      noFieldsYet: "Полей пока нет",
      fieldName: "Название поля...",
      options: "Варианты",
      atLeast1: "(минимум 1)",
      optionName: "Название варианта...",
      save: "Сохранить",
      cancel: "Отмена",
      add: "Добавить",
      addField: "Добавить поле",
      shiftEnterNewLine: "Shift+Enter — новая строка",
    },
    forgotPasswordPage: {
      serverAndPhoneAreRequired: "Введите сервер и телефон",
      error: "Ошибка",
      check: "Проверьте",
      ifSuchAUserExists: "Если такой пользователь существует, ссылка для сброса пароля отправлена на email. Ссылка действует 1 час.",
      backToSignIn: "Вернуться ко входу",
      resetPassword: "Сброс пароля",
      enterYourServerAndPhone: "Введите сервер и номер телефона — ссылка для сброса придёт на email.",
      server: "Код компании",
      phone: "Телефон",
      sendLink: "Отправить ссылку",
      sending: "Отправка...",
    },
    funnelPage: {
      age: "Создана {days} дн. назад",
      dealsLabel: "Сделок:",
      archive: "В архив",
      request: "Лид",
      d: "{days} дн.",
      takeIt: "Взять себе",
      reactivate: "Активировать заново",
      deal: "сделка",
      empty: "Пусто",
      selectEverythingInThisStage: "Выбрать все на этом этапе",
      quickAdd: "Быстро добавить",
      request2: "Лиды:",
      source: "Источник",
      notSelected: "— Не выбрано —",
      titleStageContactPhoneSource: "Название, Этап, Контакт, Телефон, Источник, Значение, Статус, Комментарий",
      failedToLoad: "Ошибка загрузки",
      restoredFromArchive: "Возвращено из архива",
      error: "Ошибка",
      deleted: "Удалено",
      archive2: "Архив",
      theArchiveIsEmpty: "Архив пуст",
      openDeal: "Открыть сделку",
      restore: "Вернуть",
      closedAsWon: "Закрыто как «Выиграно»",
      closedAsLost: "Закрыто как «Проиграно»",
      assignedToYou: "Вы взяли себе",
      reactivated: "Активировано заново",
      leadAdded: "Лид добавлен",
      selected: "Выбрано: {size}",
      moveToStage: "Перенести на этап...",
      toAnotherFunnel: "В другую воронку",
      assign: "Назначить...",
      unassign: "— Снять назначение —",
      deletePermanently: "Удалить без возможности восстановления?",
      no: "Нет",
      yesDelete: "Да, удалить",
      delete: "Удалить",
      close: "Закрыть",
      thisFunnelHasNoStages: "В этой воронке нет этапов",
      addStagesInSettingsFunnels: "Добавьте этапы в Настройки → Воронки",
      won: "Выиграно",
      lost: "Проиграно",
      chooseAnAssignee: "Выберите ответственного",
      dealsSelected: "Выбрано сделок: {size}",
      chooseAnEmployee: "Выберите сотрудника...",
      cancel: "Отмена",
      confirm: "Подтвердить",
      closeAsWon: "Закрыть как «Выиграно»",
      closeAsLost: "Закрыть как «Проиграно»",
      reasonOptional: "Причина (необязательно)",
      whyWasItLost: "— почему проиграна?",
      noReasonSelected: "— Причина не выбрана —",
      eGTheClientSigned: "Например: клиент подписал договор",
      eGThePriceDid: "Например: не устроила цена",
      responsibleEmployee: "Ответственный сотрудник",
      moveToAnotherFunnel: "Перенести в другую воронку",
      selected2: "выбрано",
      leads: "Лидов: {size}",
      willBeArchived: "будет архивировано",
      leads2: "Лидов: {length}",
      reasonComment: "Причина (комментарий) *",
      whyIsItBeingArchived: "Почему архивируется?",
    },
    inboxAnalyticsPage: {
      previousPeriod: "{pct}% (прошлый период: {prevValue})",
      conversationsPerDay: "Диалоги по дням",
      days: "{length} дн.",
      text: "{count} шт. · {date}",
      inbox: "Входящие",
      totalConversations: "Всего диалогов",
      unanswered: "Без ответа",
      closed: "Закрыто",
      avgResponseTime: "Ср. время ответа",
      comparePeriods: "Сравнение периодов",
      total: "Всего",
      resolved: "Решено, %",
      conversationsPerDay2: "Диалоги по дням ({from} — {to})",
      byChannel: "По каналам",
      noData: "Нет данных",
      agents: "Агенты",
      labels: "Метки",
      noLabels: "Меток нет",
      reportByEmployee: "Отчёт по сотрудникам",
      downloadCsv: "Скачать CSV",
      employee: "Сотрудник",
      conversations: "Диалоги",
      closed2: "Закрыто, %",
      avgReply: "Ср. ответ",
      call: "Звонок",
    },
    inboxPage: {
      anonymous: "Аноним",
      comment: "Комментарий",
      loading: "Загрузка...",
      file: "Файл",
      openFile: "Открыть файл",
      post: "Пост",
      instagramPost: "Пост в Instagram",
      internalNote: "Внутренняя заметка",
      replyToThisComment: "Ответить на этот комментарий",
      failedToLoad: "Ошибка загрузки",
      error: "Ошибка",
      chatClosed: "Чат закрыт",
      chatReopened: "Чат открыт заново",
      failedToLoadData: "Не удалось загрузить данные",
      thisContactAlreadyExists: "Такой контакт уже существует",
      contactCreated: "Контакт создан",
      agentAssigned: "Агент назначен",
      agentRemoved: "Агент снят",
      deleteThisChatAllMessages: "Удалить этот чат? Все сообщения тоже будут удалены.",
      deleteFailed: "Ошибка удаления",
      inbox: "Входящие",
      search: "Поиск...",
      conversations: "Диалогов: {convTotal}",
      previous: "← Назад",
      next: "Далее →",
      back: "Назад",
      searchMessages: "Поиск сообщений",
      changeAgent: "Сменить агента",
      chooseAnAgent: "Выберите агента",
      remove: "Убрать",
      labels: "Метки",
      availableLabels: "Доступные метки",
      newLabel: "Новая метка...",
      reopenChat: "Открыть чат заново",
      contactInfo: "Данные контакта",
      commentsUnderThePostClick: "Комментарии под постом · нажмите на комментарий, на который хотите ответить",
      pressTheButton: "нажмите кнопку",
      searchInMessages: "Поиск в сообщениях...",
      results: "Результатов: {length}",
      replyToTheSelectedComment: "Ответ на выбранный комментарий",
      replyToTheLatestComment: "Ответ на последний комментарий",
      cancel: "Отмена",
      addAStickerPackIn: "Добавьте стикер-пак в настройках",
      sticker: "Стикер",
      sendFile: "Отправить файл",
      status: "Статус",
      call: "Позвонить",
      phone: "Телефон",
      email: "Email",
      noPacks: "Паков нет",
      noStickersFound: "Стикеры не найдены",
      selectAConversation: "Выберите диалог",
      openAConversationFromThe: "Откройте диалог из списка слева",
    },
    resetPasswordPage: {
      passwordMustBeAtLeast: "Пароль должен содержать не менее 6 символов",
      passwordsDoNotMatch: "Пароли не совпадают",
      passwordChangedYouCanSign: "Пароль изменён. Теперь войдите.",
      error: "Ошибка",
      newPassword: "Новый пароль",
      theLinkIsInvalidPlease: "Ссылка недействительна. Пожалуйста, начните сброс пароля заново.",
      tryAgain: "Повторить",
      enterYourNewPassword: "Введите новый пароль.",
      confirmPassword: "Подтвердите пароль",
      changePassword: "Изменить пароль",
      saving: "Сохранение...",
    },
    reviewsPage: {
      uploadFailed: "Ошибка загрузки",
      failedToLoadReviews: "Ошибка загрузки отзывов",
      deleteThisPage: "Удалить эту страницу?",
      error: "Ошибка",
      newReviewsCollected: "Собрано новых отзывов: {added}",
      noNewReviews: "Новых отзывов нет",
      collectionFailed: "Ошибка сбора",
      reviews: "Отзывы",
      collectCustomerReviewsViaQr: "Собирайте отзывы клиентов через QR",
      newPage: "Новая страница",
      scans: "Сканирования",
      reviewClicks: "Клики на отзыв",
      conversion: "Конверсия",
      newComplaints: "Новые жалобы",
      googleReviews: "Отзывы Google",
      edit: "Править",
      delete: "Удалить",
      totalReviews: "Всего: отзывов — {collectedTotal}",
      collectNow: "Собрать сейчас",
      noMapReviewsCollectedYet: "Отзывы с карт пока не собраны. Если на странице подключены Google/Yandex, отзывы собираются автоматически (каждые несколько часов).",
      anonymous: "Аноним",
      loadMore: "Загрузить ещё ({length}/{collectedTotal})",
      noInternalFeedbackYet: "Внутренних отзывов пока нет",
      contact: "Контакт",
      complaint: "Жалоба",
      reviewed: "Рассмотрено",
      saved: "Сохранено",
      saveFailed: "Ошибка сохранения",
      testMessageSent: "Тестовое сообщение отправлено ✅",
      testWasNotSent: "Тест не отправлен",
      telegramNotifications: "Уведомления в Telegram",
      newGoogleYandexReviewsAre: "Новые отзывы Google/Yandex автоматически отправляются в вашу группу/канал Telegram.",
      notificationsEnabled: "Уведомления включены",
      botToken: "Токен бота",
      savedEnterANewOne: "•••••• (сохранён — введите новый, чтобы изменить)",
      createABotInBotfather: "Создайте бота в @BotFather и введите токен.",
      chatId: "Chat ID",
      "1001234567890OrChannelName": "-1001234567890 или @имя_канала",
      addTheBotToThe: "Добавьте бота в группу. chat_id группы можно узнать через @getidsbot.",
      saving: "Сохранение...",
      save: "Сохранить",
      test: "Тест",
      noPagesYet: "Страниц пока нет",
      createYourFirstReviewPage: "Создайте свою первую страницу отзывов",
      failedToDownloadQr: "Ошибка скачивания QR",
      downloadQr: "Скачать QR",
      printItAndPlaceIt: "Распечатайте и поставьте на стол",
      googlePlaceLinkedTheReview: "Место Google привязано — ссылка на отзыв заполнена автоматически",
      linkingFailed: "Ошибка привязки",
      updated: "Обновлено",
      updateFailed: "Ошибка обновления",
      unlinkGoogle: "Отвязать Google?",
      unlinked: "Отвязано",
      googleReviews2: "Отзывы Google — {name}",
      findYourBusinessOnGoogle: "Найдите свой бизнес в Google Maps и привяжите — рейтинг и отзывы будут отображаться здесь.",
      eGCaffeBahorChilanzar: "Например: Caffe Bahor, Чиланзар Ташкент",
      nothingFoundRefineTheName: "Ничего не найдено — уточните название",
      reviews2: "{toFixed} · отзывов: {total}",
      onTheMap: "На карте",
      reviews3: "отзывов",
      updated2: "Обновлено: {syncedLabel}",
      inMin: "через {cooldownMin} мин.",
      refresh: "Обновить",
      unlink: "Отвязать",
      reviewTextNotFound: "Текст отзывов не найден",
      user: "Пользователь",
      googlePlacesApiReturnsOnly: "Google Places API возвращает только последние ~5 отзывов.",
      googleApiKeyIsNot: "Ключ Google API не настроен",
      searchError: "Ошибка поиска",
      yandexApiKeyIsNot: "Ключ Yandex API не настроен",
      "2gisConnectedReviewsCollected": "2GIS подключён — отзывы собраны",
      "2gisConnectionError": "Ошибка подключения 2GIS",
      "2gisDisconnected": "2GIS отключён",
      enterAName: "Введите название",
      editing: "Редактирование",
      newReviewPage: "Новая страница отзывов",
      nameBranch: "Название (филиал)",
      chilanzarBranch: "Филиал на Чиланзаре",
      titleVisibleToTheCustomer: "Заголовок (видит клиент)",
      reviews4: "{toFixed}★ · отзывов: {total}",
      change: "Изменить",
      googleReviewLinkFilledIn: "Ссылка на отзыв Google заполнена автоматически",
      linkAGoogleMapsPlace: "Привязать место Google Maps (URL заполнится автоматически)",
      enterTheBusinessName: "Введите название бизнеса...",
      notFoundRefineYourQuery: "Не найдено — уточните запрос",
      yandexReviewLinkFilledIn: "Ссылка на отзыв Yandex заполнена автоматически",
      linkAYandexMapsPlace: "Привязать место Yandex Maps (URL заполнится автоматически)",
      "2gisBranch": "Филиал 2GIS",
      review: "отзыв",
      toLink2gisSaveThe: "Чтобы подключить 2GIS, сначала сохраните страницу, затем откройте заново.",
      "2gisLink2gisUzTashkent": "Ссылка 2GIS: 2gis.uz/tashkent/firm/70000...",
      link: "Привязать",
      platformsAndLinks: "Платформы и ссылки",
      filledInAutomaticallyWhenA: "Заполнится автоматически при привязке места Google",
      reviewLinkUrl: "Ссылка на отзыв (URL)",
      smartRoutingGating: "Умная маршрутизация (gating)",
      highRatingMapLowRating: "Высокая оценка → на карту; низкая → внутренний отзыв",
      publishingThreshold: "Порог публикации:",
      "4AndAbove": "4★ и выше",
      "5Only": "только 5★",
      "3AndAbove": "3★ и выше",
      googleProhibitsReviewGatingTurn: "⚠️ Google запрещает «review gating» — отключите, если не нужно.",
      cancel: "Отмена",
    },
    settingsPage: {
      main: "Основной",
      contactDetails: "Контактные данные",
      appearance: "Отображение",
      baseCurrency: "Основная валюта",
      allDealsAndLeadsAre: "Все сделки и лиды отображаются в этой валюте.",
      directorSFullName: "ФИО директора",
      eGAliyevJasurAkhmadovich: "Например: Алиев Жасур Ахмадович",
      officeNumber: "Номер офиса",
      address: "Адрес",
      eGTashkentChilanzarDistrict: "Например: г. Ташкент, Чиланзарский р-н, д. 12",
      website: "Веб-сайт",
      usernameOrFullLink: "@username или полная ссылка",
      usernameOr998: "@username или +998...",
      funnelNameIsRequired: "Введите название воронки",
      saved: "Сохранено",
      funnelCreated: "Воронка создана",
      error: "Ошибка",
      deleted: "Удалено",
      funnels: "Воронки",
      configureDealAndLeadStages: "Настройте этапы сделок и лидов",
      newFunnel: "Новая воронка",
      noFunnelsYet: "Воронок пока нет",
      createANewFunnelAnd: "Создайте новую воронку и добавьте в неё этапы",
      noStages: "Этапов нет",
      editFunnel: "Редактировать воронку",
      funnelName: "Название воронки",
      eGMainSalesB2b: "Например: Основные продажи, B2B, Premium...",
      stages: "Этапы",
      add: "Добавить",
      color: "Цвет",
      aDealReachingThisStage: "При попадании на этот этап сделка автоматически помечается «Выиграно» (продажа)",
      won: "Выиграно",
      aDealReachingThisStage2: "При попадании на этот этап сделка автоматически помечается «Проиграно»",
      lost: "Проиграно",
      choosingAnAssigneeIsRequired: "При переносе на этот этап обязательно нужно выбрать ответственного (например, передача из приёма менеджеру)",
      assigneeRequired: "Обязателен ответственный",
      staysInThisFunnel: "Остаётся в этой воронке",
      moveTo: "Перенести в «{name}»",
      chooseAStage: "Выберите этап",
      whichRolesCanSeeIt: "Каким ролям показывать",
      ifNoneIsSelectedVisible: "Если никто не выбран — видна всем (по умолчанию).",
      noCustomRolesCreated: "Пользовательские роли не созданы",
      cancel: "Отмена",
      save: "Сохранить",
      create: "Создать",
      failedToLoad: "Ошибка загрузки",
      taskStages: "Этапы задач",
      configureTheKanbanColumnsTasks: "Настройте колонки канбана. Задачи на этапе с отметкой «Выполнено» считаются завершёнными.",
      done: "Выполнено:",
      notCompleted: "Не завершено:",
      doneStage: "Этап «Выполнено»",
      done2: "Выполнено",
      addStage: "Добавить этап",
      salesSources: "Источники продаж",
      sourcesThatCanBeChosen: "Источники, которые можно выбрать при добавлении продажи",
      addSource: "Добавить источник",
      addReason: "Добавить причину",
      closingReasons: "Причины закрытия",
      whenADealIsClosed: "Когда сделка закрывается как «Выиграно» или «Проиграно», сотрудник выбирает причину из этого списка — вместо свободного текста, чтобы в статистике были единые значения.",
      whenWon: "При выигрыше",
      whenLost: "При проигрыше",
      formNameIsRequired: "Введите название формы",
      selectAFunnel: "Выберите воронку",
      selectAStage: "Выберите этап",
      formUpdated: "Форма обновлена",
      formCreated: "Форма создана",
      somethingWentWrong: "Произошла ошибка",
      editForm: "Редактировать форму",
      newForm: "Новая форма",
      formName: "Название формы",
      eGWebsiteContactForm: "Например: Форма обратной связи на сайте",
      funnel: "Воронка",
      stage: "Этап",
      titleOnTheFormPage: "Заголовок (на странице формы)",
      additionalDescription: "Дополнительное описание",
      optional: "Необязательно...",
      formColor: "Цвет формы",
      organizationBrandColor: "Фирменный цвет организации",
      customColor: "Свой цвет",
      everyFormAlways: "В каждой форме",
      and: "и",
      fieldsRequired: "всегда присутствуют (обязательные).",
      name: "Имя",
      phone: "Телефон",
      extraQuestions: "Дополнительные вопросы",
      required: "Обязательно",
      noExtraQuestionsYet: "Дополнительных вопросов пока нет",
      questionText: "Текст вопроса...",
      options: "Варианты",
      atLeast1: "(минимум 1)",
      optionName: "Название варианта...",
      addQuestion: "Добавить вопрос",
      uploadFailed: "Ошибка загрузки",
      linkCopied: "Ссылка скопирована",
      couldNotCopy: "Не удалось скопировать",
      formDeleted: "Форма удалена",
      leadForms: "Лид-формы",
      placeOnYourWebsiteOr: "Разместите на сайте или в соцсетях — заполненные заявки попадают в выбранную воронку.",
      firstCreateAFunnelIn: "Сначала создайте воронку в разделе «Воронки».",
      inactive: "Неактивна",
      requests: "заявок",
      delete: "Удалить",
      enable: "Включить",
      noFormsYet: "Форм пока нет",
      deleteForm: "Удалить форму",
      willBeDeletedTheLink: "Форма будет удалена. Ссылка перестанет работать.",
      moduleVisibility: "Видимость модулей",
      whichModulesToShowOr: "Какие модули показывать или скрывать в верхней панели и меню — относится ко всем пользователям.",
      hidden: "Скрыто",
      visible: "Отображается",
      goals: "Цели",
      setSalesGoalsOverallAnd: "Задайте цели по продажам — общие и по сотрудникам",
      overallGoal: "Общая цель",
      amountUzs: "Сумма (UZS)",
      numberOfSales: "Количество продаж",
      byEmployee: "По сотрудникам",
      amountGoal: "Цель по сумме",
      countGoal: "Цель по количеству",
      pushNotificationsEnabled: "Push-уведомления включены!",
      permissionDeniedOrTheBrowser: "Нет разрешения или браузер не поддерживает",
      anErrorOccurred: "Произошла ошибка",
      pushNotificationsDisabled: "Push-уведомления отключены",
      instagramConnectedSuccessfully: "Instagram успешно подключён!",
      connectionError: "Ошибка подключения",
      facebookConnectedSuccessfully: "Facebook успешно подключён!",
      facebookConnectionError: "Ошибка подключения Facebook",
      failedToStartOauth: "Ошибка запуска OAuth",
      disconnectInstagram: "Отключить Instagram?",
      instagramDisconnected: "Instagram отключён",
      facebookDisconnected: "Facebook отключён",
      enterThePhoneNumberId: "Введите Phone Number ID и Access Token",
      whatsappConnected: "WhatsApp подключён!",
      connectionError2: "Ошибка подключения",
      disconnectWhatsapp: "Отключить WhatsApp?",
      whatsappDisconnected: "WhatsApp отключён",
      thisPackHasAlreadyBeen: "Этот пак уже добавлен",
      stickerPacksSaved: "Стикер-паки сохранены",
      botTokenIsRequired: "Введите токен бота",
      connected: "@{botUsername} подключён",
      connectionCancelled: "Подключение отменено",
      disconnectTheBot: "Отключить бота?",
      botDisconnected: "Бот отключён",
      enterAPhoneNumber: "Введите номер телефона",
      theCodeWasSentTo: "Код отправлен в ваше приложение Telegram",
      couldNotSendTheCode: "Не удалось отправить код",
      enterTheCode: "Введите код",
      enterThePassword: "Введите пароль",
      telegramAccountConnected: "Аккаунт Telegram подключён",
      signInFailed: "Не удалось войти",
      disconnectTheAccountConversationsWill: "Отключить аккаунт {label}? Диалоги будут закрыты.",
      accountDisconnected: "Аккаунт отключён",
      emailSettingsSaved: "Настройки email сохранены",
      testFailed: "Тест не пройден",
      socialNetworks: "Социальные сети",
      email: "Email",
      notifications: "Уведомления",
      integrations: "Интеграции",
      connectExternalChannelsToThe: "Подключите внешние каналы к CRM",
      telegramBot: "Telegram-бот",
      superchatAllMessagesArriveIn: "Superchat — все сообщения приходят во «Входящие»",
      connected2: "Подключено",
      active: "активен",
      notConfigured: "не настроен",
      theBotWorksViaWebhook: "Бот работает через webhook. Если пользователи пишут боту, сообщения приходят на страницу «Входящие».",
      disconnect: "Отключить",
      botToken: "Токен бота",
      createANewBotAnd: "создайте нового бота и введите его токен",
      connect: "Подключить",
      telegramAccounts: "Аккаунты Telegram",
      personalProfileTheCustomerWrites: "Личный профиль — клиент пишет живому человеку, а не боту",
      text: "{length} шт.",
      anEmployeeSPersonalTelegram: "Подключается личный аккаунт Telegram сотрудника — его переписка отображается во «Входящих», а при ответе из CRM клиент получает сообщение с этого профиля.",
      addAccount: "Добавить аккаунт",
      automatingAPersonalAccountViolates: "Автоматизация личного аккаунта нарушает правила Telegram — при рассылке спама аккаунт могут заблокировать.",
      connectATelegramAccount: "Подключить аккаунт Telegram",
      phoneNumber: "Номер телефона",
      telegramWillSendAConfirmation: "Telegram отправит код подтверждения на этот номер (код придёт в самом приложении).",
      sendCode: "Отправить код",
      verificationCode: "Код подтверждения",
      codeSentTo: "Код, отправленный на номер {phone}",
      confirm: "Подтвердить",
      "2faPassword": "Пароль 2FA",
      cloudPassword: "Облачный пароль",
      twoStepVerificationIsEnabled: "В аккаунте включена двухэтапная проверка",
      signIn: "Войти",
      stickerPacks: "Стикер-паки",
      stickerSetsForInboxChat: "Наборы стикеров для чата «Входящие»",
      add2: "Добавить",
      view: "посмотреть",
      noStickerPacksAddedYet: "Стикер-паки пока не добавлены",
      instagramDm: "Instagram DM",
      connectDirectMessagesToInbox: "Подключите Direct-сообщения к разделу «Входящие»",
      instagramBusinessAccountConnected: "Аккаунт Instagram Business подключён",
      instagramDmMessagesArriveOn: "Сообщения Instagram DM автоматически поступают на страницу «Входящие».",
      connectYourInstagramBusinessOr: "Подключите аккаунт Instagram Business или Creator. Авторизация выполняется через OAuth на вашей странице Facebook.",
      connectViaFacebook: "Подключить через Facebook",
      metaDeveloperAppIdAnd: "Meta Developer App ID и Secret должны быть настроены в .env",
      emailImapSmtp: "Email (IMAP/SMTP)",
      receiveAndReplyToEmail: "Принимайте и отвечайте на email-сообщения в разделе «Входящие»",
      imapIncomingMessages: "IMAP — входящие сообщения",
      passwordAppPassword: "Пароль / пароль приложения",
      useTlsSslPort993: "Использовать TLS/SSL (порт 993)",
      smtpOutgoingMessages: "SMTP — исходящие сообщения",
      senderNameEmailFrom: "Имя/email отправителя (From)",
      useSslPort465: "Использовать SSL (порт 465)",
      imap: "IMAP:",
      success: "Успешно",
      smtp: "SMTP:",
      test: "Тест",
      forGmailEnableAppPasswords: "Для Gmail включите «Пароли приложений». IMAP-приложение автоматически получает новые сообщения и добавляет их во «Входящие».",
      pushNotifications: "Push-уведомления",
      aNotificationIsSentTo: "При новом сообщении на ваше устройство приходит уведомление",
      yourBrowserDoesNotSupport: "Ваш браузер не поддерживает push-уведомления",
      browserPermissionWasDeniedAllow: "Разрешение браузера отклонено. Разрешите уведомления в настройках браузера.",
      notificationsEnabled: "✓ Уведомления включены",
      notificationsDisabled: "Уведомления отключены",
      facebookMessenger: "Facebook Messenger",
      connectPageMessagesToInbox: "Подключите сообщения страницы к разделу «Входящие»",
      facebookPageConnected: "Страница Facebook подключена",
      reallyDisconnect: "Точно отключить?",
      cancel2: "Отмена",
      yesDisconnect: "Да, отключить",
      targetLeadAdsLeads: "Лиды Target (Lead Ads)",
      leadsFromInstagramFacebookAds: "Лиды из рекламы Instagram/Facebook (через форму Lead Ads) автоматически попадают в эту воронку и этап.",
      noFunnelSelected: "— Воронка не выбрана —",
      noStageSelected: "— Этап не выбран —",
      untilAFunnelIsSelected: "Пока воронка не выбрана, лиды из таргета в CRM не попадают.",
      connectYourFacebookBusinessPage: "Подключите бизнес-страницу Facebook. Сообщения Messenger, поступающие на страницу, попадают во «Входящие».",
      whatsappBusiness: "WhatsApp Business",
      connectViaCloudApi: "Подключение через Cloud API",
      whatsappCloudApiConnected: "WhatsApp Cloud API подключён",
      enterTheMetaCloudApi: "Введите данные Meta Cloud API (Meta dashboard → WhatsApp → API Setup).",
      whatsappBusinessAccountIdOptional: "WhatsApp Business Account ID (необязательно)",
      phoneNumberEG998: "Номер телефона (напр. +998...)",
      accessTokenPermanent: "Access Token (постоянный)",
      orders: "Заказы",
      salesPurchases: "Продажи и закупки",
      cashier: "Кассир",
      other: "Другое",
      employeeReportPhotoVideoLocation: "Отчёт сотрудника (фото/видео/геолокация)",
      employeeCreatesASupplyRequest: "Сотрудник создаёт запрос в снабжение",
      enterStartDate: "Ввод даты начала",
      createEstimatesInJobOrders: "Создавать смету в заказах",
      showEstimatesToEmployees: "Показывать смету сотрудникам",
      showPricesToEmployees: "Показывать цены сотрудникам",
      colourWarningAsTheDeadline: "Цветовое предупреждение при приближении срока",
      colourRules: "Правила цвета",
      ifTheDeadlineIsToday: "Если срок истекает сегодня — всегда красный. Ниже: какой цвет, когда остаётся X дней.",
      addRule: "+ Добавить правило",
      noRulesYetClickAdd: "Правил пока нет. Нажмите «+ Добавить правило».",
      daysLeft: "Осталось дней: {daysLeft}",
      days: "Дней:",
      background: "Фон:",
      text2: "Текст:",
      overdue: "Просрочено",
      alwaysRedCannotBeChanged: "Всегда красный — изменить нельзя",
      tvModeButton: "Кнопка режима ТВ",
      freezePauseOption: "Возможность заморозки (пауза)",
      accountingTriggers: "Триггеры учёта",
      whenMovingToTheStatus: "При переходе в выбранный ниже статус автоматически выполняется соответствующее действие. Если оставить пустым — управляется старой кнопкой «Подтверждён».",
      stockTrigger: "Триггер остатка",
      inWhichStatusToDeduct: "— в каком статусе списывать из остатка товара",
      notSetLegacy: "— Не задано (старый способ) —",
      debtTrigger: "Триггер долга",
      inWhichStatusToRecord: "— в каком статусе формировать задолженность контрагента",
      noFolders: "— Папок нет —",
      noneSelectedAllFoldersAre: "Ничего не выбрано — видны все папки",
      hideWarehouseSelectionInThe: "Скрыть выбор склада в форме",
      whichModulesAndSubmodulesTo: "Какие модули и подмодули показывать или скрывать в боковом меню",
      extensionPbx: "Внутренний номер (АТС)",
      eG209: "Например: 209",
      pbxExtensionSipuniIbratSip: "Внутренний номер АТС (Sipuni/ibrat.sip.uz) — используется сотрудником при звонках через АТС.",
      nameIsRequired: "Введите название",
      error2: "Ошибка",
      confirmDeletion: "Подтвердить удаление?",
      failedToLoad2: "Не удалось загрузить",
      titleAndTextAreRequired: "Введите заголовок и текст",
      updated: "Обновлено",
      added: "Добавлено",
      quickReplies: "Быстрые ответы (Quick Replies)",
      whenTypingInAChat: "При вводе в чате",
      pressAndChooseAQuick: "нажмите и выберите быстрый ответ",
      editing: "Редактирование",
      addNew: "Добавить",
      title: "Заголовок *",
      eGHello: "например: привет",
      shortcut: "Шорткат",
      text3: "Текст *",
      replyText: "Текст ответа...",
      noQuickReplies: "Быстрых ответов нет",
    },
    tasksPage: {
      error: "Ошибка",
    },
    userProfilePage: {
      userNotFound: "Пользователь не найден",
      nameIsRequired: "Введите имя",
      phoneNumberIsRequired: "Введите номер телефона",
      saved: "Сохранено",
      error: "Ошибка",
      imageWasNotUploaded: "Изображение не загружено",
      filesUploaded: "Загружено файлов: {length}",
      uploadFailed: "Ошибка загрузки",
      passwordMustBeAtLeast: "Пароль не короче 4 символов",
      passwordChanged: "Пароль изменён",
      userProfile: "Профиль пользователя",
      user: "Пользователь",
      password: "Пароль",
      save: "Сохранить",
      you: "Вы",
      active: "Активен",
      inactive: "Неактивна",
      basicInformation: "Основные данные",
      name: "Имя *",
      phoneNumber: "Номер телефона *",
      signInIsDoneWith: "Вход в систему выполняется по этому номеру.",
      extensionPbx: "Внутренний номер (АТС)",
      eG209: "Например: 209",
      eMail: "E-mail",
      dateOfBirth: "Дата рождения",
      ddMmYyyy: "ДД/ММ/ГГГГ",
      homeAddress: "Адрес проживания",
      cityStreetHouse: "Город, улица, дом...",
      additionalPhoneNumbers: "Дополнительные номера телефонов",
      add: "Добавить",
      noAdditionalNumbers: "Дополнительных номеров нет",
      homeWork: "Дом / Работа",
      positionAndPermissions: "Должность и права",
      position: "Должность",
      organizationOwner: "Владелец организации",
      administrator: "Администратор",
      employee: "Сотрудник",
      department: "Отдел",
      noDepartment: "Без отдела",
      customRole: "Своя роль",
      noRoleDefault: "Нет роли (по умолчанию)",
      passportAndDocuments: "Паспорт и документы",
      uploadFile: "Загрузить файл",
      imagesAndPdfFilesAre: "Принимаются изображения и PDF. Макс. 15 МБ.",
      noDocumentsUploaded: "Документы не загружены",
      passportScanPhotoProofOf: "Скан/фото паспорта, документ о месте проживания и прочее",
      changePassword: "Изменить пароль",
      newPassword: "Новый пароль",
      atLeast4Characters: "Не менее 4 символов",
      cancel: "Отмена",
    },
  },

  shared: {
    fieldTypes: {
      text: "Текст",
      textarea: "Большой текст",
      number: "Число",
      phone: "Телефон",
      email: "Email",
      url: "URL",
      date: "Дата",
      boolean: "Да / Нет",
      dropdown: "Список (один)",
      multiselect: "Список (несколько)",
      file: "Файл",
    },
    callStatus: {
      ringing: "Звонит",
      active: "В разговоре",
      completed: "Состоялся",
      missed: "Пропущен",
      cancelled: "Отменён",
    },
    dateFilters: {
      all: "Все",
      today: "Сегодня",
      week: "Эта неделя",
      month: "Этот месяц",
    },
    profileTabs: {
      info: "Данные",
      docs: "Документы",
    },
    fileN: "Файл {n}",
    stageN: "Этап {n}",
    sourceN: "Источник {n}",
    reasonN: "Причина {n}",
  
    created: "Создано",
  
    user: "Пользователь",
  
    dealTabs: { main: "Основное", 
    stats: "Статистика",
  
    files: "Файлы",
  
    settings: "Настройки",
  },
  
    reviewTabs: { pages: "Страницы", 
    collected: "Отзывы с карт",
  
    feedback: "Внутренние отзывы ({n})",
  },
  
    noLinkedPages: "Нет страниц, подключённых к Google/Yandex",
  
    googleKeyMissing: "Ключ Google API ещё не настроен (GOOGLE_PLACES_API_KEY)",
  
    searchError: "Ошибка поиска",
  
    save2gisFirst: "Сначала сохраните страницу, затем подключите 2GIS",
  
    hoursN: "{n} ч",
  
    loadFailed: "Не удалось загрузить",
  
    resolvedN: "Решено: {n}%",
  
    firstReply: "Первый ответ",
  
    genericError: "Произошла ошибка",
  
    error: "Ошибка",
  
    justNow: "Сейчас",
  
    minShort: "{n} мин",
  
    regFeatures: { f1: "Учёт склада и товаров", 
    f2: "Процессы продаж и закупок",
  
    f3: "Клиенты и поставщики",
  
    f4: "Финансовая отчётность",
  },
  
    contactCreated: "Контакт создан",
  
    fileUploadFailed: "Не удалось загрузить файл: {name}",
  
    yes: "Да",
  
    no: "Нет",
  
    fileLabel: "📎 Файл",
  
    callAction: "Позвонить",
  
    roles: { owner: "Владелец", 
    admin: "Админ",
  
    user: "Пользователь",
  },
  
    sumSymbol: "сум",
  
    hourShort: "{n} ч",
  
    dayShort: "{n} д",
  },

  assignees: {
    none: "Не назначен",
    hint: "Можно выбрать нескольких. Первый — основной",
    clear: "Сбросить",
    primary: "основной",
  },

  contactHistory: {

    fromDeal: "Сделка",

    dealCreated: "Создана сделка «{deal}»",

    dealWon: "Сделка «{deal}» выиграна",

    dealLost: "Сделка «{deal}» проиграна",
    nobody: "никто",
    assigned: "{who}: ответственные {from} → {to}",
    assignedViaDeal: "{who}: ответственные по сделке «{deal}»: {from} → {to}",
    dealAssigned: "Ответственные: {from} → {to}",
    merged: "{who} объединил контакты: {names}",
  },

  merge: {
    title: "Объединение контактов",
    subtitle: "Проверьте, что будет перенесено. Пока вы не подтвердите, ничего не изменится.",
    mainContact: "Основной контакт (останется)",
    removedContacts: "Будут объединены и удалены",
    deals: "Сделки",
    tasks: "Задачи",
    calls: "Звонки",
    chats: "Переписки",
    history: "История",
    files: "Файлы",
    dealsHint: "Отмеченные сделки перейдут к основному контакту. У неотмеченных контакт будет снят (сами сделки не удаляются).",
    noDeals: "У объединяемых контактов нет сделок",
    possibleDup: "возможный дубль",
    selectAll: "Выбрать все",
    clearAll: "Снять все",
    fromContact: "из контакта {name}",
    alsoMove: "Перенести также",
    fillEmpty: "Заполнить пустые поля основного контакта данными из объединяемых",
    conflicts: "Данные отличаются (останутся значения основного контакта)",
    field: {
      name: "Имя",
      email: "Email",
    },
    owners: "Ответственные",
    ownersKeep: "Оставить ответственных основного контакта",
    ownersUnion: "Объединить всех ответственных",
    status: {
      active: "В работе",
      won: "Выиграна",
      lost: "Проиграна",
    },
    summary: "Сделок будет перенесено: {n}",
    confirm: "Объединить",
    cancel: "Отмена",
    success: "Контакты объединены",
    error: "Не удалось объединить",
    loadError: "Не удалось загрузить предпросмотр",
  },

  quickTask: {

    typeLabel: "Тип задачи",
    tab: "Задача",
    type: {
      call: "Связаться",
      meeting: "Встреча",
      other: "Другое",
    },
    on: "на",
    for: "для",
    today: "Сегодня",
    tomorrow: "Завтра",
    week: "Через неделю",
    placeholder: "Что нужно сделать…",
    place: "Поставить",
    cancel: "Отменить",
    created: "Задача поставлена",
    badDate: "Укажите дату и время",
  },

  callAI: {
    badge: {
      analyze: "AI-анализ",
      queued: "В очереди",
      processing: "Анализируется…",
      failed: "Ошибка анализа",
      problem: "Проблемный звонок",
      tooShort: "Слишком короткий",
    },
    modal: {
      title: "AI-разбор звонка",
      notAnalyzed: "Звонок ещё не анализировался",
      notAnalyzedHint: "Запустите анализ: система расшифрует запись и подготовит отчёт по чек-листу.",
      analyze: "Проанализировать",
      starting: "Запускаем…",
      disabled: "AI-анализ звонков выключен. Включите его: Настройки → Интеграции → AI-анализ звонков.",
      noEngine: "Расшифровка или анализ не подключены на сервере — звонок подождёт, пока их настроят.",
      tabReport: "Отчёт",
      tabTranscript: "Расшифровка",
      retry: "Повторить",
      reanalyze: "Пересчитать",
      delete: "Удалить",
      deleteConfirm: "Удалить расшифровку, оценки и копию записи?",
      close: "Закрыть",
      summary: "Резюме",
      intent: "Что хотел клиент",
      outcome: "Итог",
      checklist: "Оценка по чек-листу",
      redFlags: "Нарушения и риски",
      noRedFlags: "Нарушений не найдено",
      actions: "Что сделать после звонка",
      coaching: "Рекомендации оператору",
      metrics: "Показатели разговора",
      topics: "Темы",
      noTranscript: "Расшифровка пока недоступна",
      rolesInferred: "Роли оператора и клиента определены по смыслу",
      tooShortNote: "Разговор слишком короткий для оценки: посчитаны только показатели.",
      error: "Ошибка",
      agent: "Оператор",
      client: "Клиент",
      unknown: "Неизвестно",
      audioError: "Не удалось загрузить запись",
      score: "Оценка",
      clientSentiment: "Тон клиента",
      agentSentiment: "Тон оператора",
      notApplicable: "не применимо",
      createTask: "Создать задачу",
    },
    status: {
      queued: "В очереди",
      downloading: "Загружаем запись…",
      downloaded: "Запись сохранена, ждёт расшифровки",
      transcribing: "Расшифровываем…",
      transcribed: "Расшифровано, ждёт анализа",
      analyzing: "Анализируем…",
      done: "Готово",
      failed: "Ошибка",
      skipped: "Пропущен",
    },
    sentiment: {
      positive: "Позитивный",
      neutral: "Нейтральный",
      negative: "Негативный",
    },
    outcome: {
      sale: "Продажа",
      agreed_next_step: "Договорились о шаге",
      callback_requested: "Просит перезвонить",
      info_given: "Дана информация",
      no_interest: "Не заинтересован",
      complaint: "Жалоба",
      other: "Другое",
    },
    flag: {
      rude: "Грубость",
      no_next_step: "Нет следующего шага",
      false_promise: "Невыполнимое обещание",
      complaint: "Жалоба клиента",
      competitor: "Упоминание конкурента",
      price_unhandled: "Возражение по цене не отработано",
      data_leak: "Лишние данные",
      other: "Другое",
    },
    severity: {
      low: "Низкая",
      medium: "Средняя",
      high: "Высокая",
    },
    item: {
      greeting: "Приветствие и представление",
      needs: "Выявление потребности",
      presentation: "Информация о продукте/услуге",
      objections: "Работа с возражениями",
      next_step: "Договорённость о следующем шаге",
      politeness: "Вежливость и тон",
      closing: "Завершение разговора",
    },
    metric: {
      agentTalkPct: "Доля речи оператора",
      silencePct: "Тишина",
      interruptions: "Перебиваний",
      avgResponseGapSec: "Пауза между репликами, с",
      agentWpm: "Слов в минуту (оператор)",
      longestAgentMonologueSec: "Самый длинный монолог оператора, с",
      durationSec: "Длительность, с",
      words: "Слов всего",
    },
    lang: {
      auto: "Авто",
      uz: "Узбекский",
      ru: "Русский",
      tg: "Таджикский",
      en: "Английский",
    },
    analytics: {
      analyzed: "Проанализировано звонков",
      avgScore: "Средняя оценка",
      problem: "Проблемных звонков",
      talkMinutes: "Минут разговора",
      cost: "Расход, $",
      pending: "В обработке: {n}",
      failedN: "Ошибок: {n}",
      tooShortN: "Слишком коротких: {n}",
      byAgent: "Сотрудники",
      thAgent: "Сотрудник",
      thCalls: "Звонков",
      thScore: "Оценка",
      thProblem: "Проблемных",
      thFlags: "Нарушений",
      thTalk: "Доля речи",
      checklist: "Оценка по пунктам чек-листа",
      outcomes: "Итоги звонков",
      sentiment: "Тональность клиентов",
      trend: "Динамика оценки",
      topFlags: "Частые нарушения",
      topTopics: "Темы разговоров",
      worst: "Звонки с низкой оценкой",
      empty: "За период нет проанализированных звонков",
      disabledTitle: "AI-анализ звонков выключен",
      disabledText: "Включите его в настройках, и система начнёт расшифровывать и оценивать новые разговоры.",
      goSettings: "Открыть настройки",
      allAgents: "Все сотрудники",
      noAgent: "Не определён",
      open: "Открыть",
      allDirections: "Все звонки",
      incoming: "Входящие",
      outgoing: "Исходящие",
      truncated: "Показаны первые 5000 звонков периода",
    },
    settings: {
      title: "AI-анализ звонков",
      subtitle: "Система расшифровывает записи разговоров с клиентами и готовит отчёт: резюме, оценку по чек-листу, нарушения и рекомендации.",
      enable: "Включить AI-анализ",
      enableHint: "Анализируются только новые звонки — после включения. Старые записи не обрабатываются.",
      auto: "Анализировать автоматически",
      autoHint: "Если выключено — анализ запускается вручную кнопкой в звонке.",
      minTalk: "Минимальная длительность разговора, мин",
      minTalkHint: "Считается время разговора с момента ответа (гудки не учитываются). Для кого-то хватает 2 минут, для кого-то и 15 мало. 0 — без ограничения.",
      maxTalk: "Максимальная длительность, мин",
      maxTalkHint: "Слишком длинные разговоры можно не анализировать, чтобы не тратить деньги. 0 — без ограничения.",
      directions: "Какие звонки анализировать",
      in: "Входящие",
      out: "Исходящие",
      language: "Язык разговоров",
      languageHint: "«Авто» подходит для смеси узбекского, русского и таджикского.",
      vocabulary: "Словарь организации",
      vocabularyHint: "Бренды, модели, названия и имена сотрудников через запятую. ИИ при анализе исправит искажённые распознаванием слова (например, «lifis» → LI 9) и напишет их в отчёте правильно.",
      vocabularyPlaceholder: "Li Auto, LI 7, LI 9, Li Avto Buxoro, rassrochka, Rosa",
      reportLanguage: "Язык отчёта",
      retention: "Хранить записи, дней",
      retentionHint: "По истечении срока копия аудио удаляется, расшифровка и оценки остаются. 0 — хранить бессрочно.",
      managerOnly: "Отчёты видят только руководители",
      managerOnlyHint: "Сотрудник видит разборы только своих звонков.",
      checklist: "Чек-лист оценки",
      checklistHint: "По этим пунктам система оценивает каждый разговор. Вес — важность пункта для итоговой оценки.",
      usingDefault: "Используется стандартный чек-лист",
      customize: "Настроить свой",
      resetDefault: "Вернуть стандартный",
      addItem: "Добавить пункт",
      itemTitle: "Название",
      itemDescription: "Что считать выполнением",
      itemWeight: "Вес",
      save: "Сохранить",
      saved: "Настройки сохранены",
      saveError: "Не удалось сохранить",
      engine: "Подключение",
      engineStt: "Расшифровка речи",
      engineLlm: "Анализ текста",
      engineOn: "подключено",
      engineOff: "не подключено",
      onlyAdmin: "Менять настройки может только владелец или администратор.",
      consentTitle: "Важно: уведомление клиентов",
      consentText: "Сообщите клиентам, что разговоры записываются и могут анализироваться автоматически (например, голосовым приветствием АТС). Это требование закона о персональных данных.",
      consentCheck: "Я подтверждаю, что клиенты уведомлены о записи и автоматическом анализе разговоров",
      consentRequired: "Подтвердите уведомление клиентов, чтобы включить анализ",
      consentAt: "Подтверждено {date}",
      maskPii: "Скрывать персональные данные от внешней модели",
      maskPiiHint: "Телефоны, номера карт, паспорта и e-mail заменяются метками перед отправкой текста на анализ. В вашей базе расшифровка остаётся целой.",
      eraseTitle: "Удаление данных клиента",
      eraseHint: "По запросу клиента можно удалить все расшифровки, оценки и копии записей, связанные с его номером. Сами звонки в журнале останутся.",
      erasePhone: "Номер телефона клиента",
      eraseBtn: "Удалить данные",
      eraseConfirm: "Удалить все данные AI-анализа по номеру {phone}? Действие необратимо.",
      erased: "Удалено разборов: {n}",
      eraseBadPhone: "Введите номер телефона",
      minutesShort: "мин",
      unlimited: "без ограничения",
      queue: "Очередь",
    },
  },

  leadMap: {
    autoCreate: "Создавать поле автоматически для каждого нового вопроса",
    autoCreateHint: "Когда придёт лид с новым вопросом, CRM сама заведёт для него поле сделки (в разделе «Заявка (форма лида)») и положит туда ответ. Ничего сопоставлять вручную не нужно.",
    autoOn: "Автосоздание полей включено",
    autoOff: "Автосоздание полей выключено",
    title: "Поля лидов",
    subtitle: "Как ответы из форм Facebook/Instagram и лидов по API раскладываются по карточке сделки. Всё, что вы не сопоставили, как и раньше попадает в комментарий.",
    hintStandard: "Имя, телефон и e-mail из стандартных вопросов формы попадают в контакт автоматически. Здесь настраиваются остальные вопросы и данные рекламы.",
    question: "Вопрос формы",
    sample: "Пример ответа",
    count: "Лидов",
    target: "Куда сохранять",
    toNote: "В комментарий (по умолчанию)",
    createField: "Создать поле «{name}»",
    dealFields: "Поле сделки",
    contact: "Контакт",
    contactName: "Имя контакта",
    contactPhone: "Телефон контакта",
    contactEmail: "E-mail контакта",
    ignore: "Не сохранять",
    importMeta: "Загрузить вопросы из формы Meta",
    imported: "Добавлено вопросов: {n}",
    importFail: "Не удалось загрузить вопросы из Meta",
    empty: "Вопросы появятся здесь после первого лида. Или загрузите их из формы Meta кнопкой выше.",
    emptyNoFb: "Вопросы появятся здесь после первого лида из Facebook/Instagram или по API.",
    saved: "Сохранено",
    fieldCreated: "Поле создано: {name}",
    loadError: "Не удалось загрузить настройки",
  },

  apiKeys: {
    title: "API-ключи",
    subtitle: "Приём лидов из внешних систем: CRM Line, Zapier, Make, формы сайтов. Каждый ключ кладёт лиды в выбранную воронку и этап.",
    create: "Создать ключ",
    createTitle: "Новый API-ключ",
    editTitle: "Изменить ключ",
    name: "Название",
    namePh: "Например: CRM Line (li-buxoro)",
    funnel: "Воронка",
    stage: "Этап",
    source: "Источник",
    sourceHint: "Подпись источника у сделки. Можно переопределить в самом запросе.",
    save: "Сохранить",
    cancel: "Отмена",
    nameRequired: "Введите название",
    error: "Не удалось выполнить действие",
    saved: "Сохранено",
    empty: "Ключей пока нет",
    destination: "Лиды попадают в",
    lastUsed: "Последний запрос",
    neverUsed: "Ещё не использовался",
    leadsCount: "лидов: {n}",
    edit: "Изменить",
    revoke: "Отозвать ключ",
    revokeConfirm: "Отозвать ключ «{name}»? Он сразу перестанет работать, это нельзя отменить.",
    revoked: "Ключ отозван",
    createdTitle: "Ключ «{name}» создан",
    shownOnce: "Скопируйте ключ сейчас: он показывается только один раз. Если потеряете — отзовите его и создайте новый.",
    copy: "Копировать",
    copied: "Скопировано",
    done: "Готово",
    docsTitle: "Как отправлять лиды",
    endpoint: "Адрес",
    example: "Пример запроса",
    docAuth: "Ключ передаётся в заголовке Authorization: Bearer … (или X-API-Key).",
    docRequired: "Обязательно: телефон или email. Имя необязательно.",
    docExternal: "external_id (например, id лида в Meta) защищает от дублей: повторная отправка не создаст вторую сделку.",
    docOptional: "Необязательно: source, funnel_id, stage_id, notes, answers {поле: значение}, campaign, ad_name, form_name, page_name, platform.",
    docLimit: "Лимит: 120 запросов в минуту на ключ.",
  },

  callPanel: {
    initiatedSoftphone: "Открываем MicroSIP и набираем номер…",
    noStartSoftphone: "Звонок не начался. Проверьте, что MicroSIP запущен, зарегистрирован на номер {ext} и назначен программой для ссылок tel:.",
    initiated: "Команда отправлена в АТС…",
    ringing: "Ответьте на звонок АТС в MicroSIP (внутр. {ext}) — после этого АТС наберёт клиента",
    ringingDirect: "Набираем клиента…",
    active: "Идёт разговор",
    completed: "Звонок завершён",
    missed: "Не соединилось",
    noStart: "АТС пока не начала звонок. Проверьте, что MicroSIP запущен и зарегистрирован на номер {ext}.",
    retry: "Позвонить ещё",
    openCard: "Открыть карточку",
    close: "Закрыть",
    noExt: "Вам не назначен внутренний номер АТС. Обратитесь к администратору (Настройки → Сотрудники).",
    viaPbx: "Через АТС (внутр. {ext})",
    viaPbxNoExt: "Через АТС — нет внутреннего номера",
    menuHint: "Зазвонит ваш MicroSIP — ответьте, и АТС наберёт клиента",
    startFailed: "Не удалось отправить команду в АТС",
    duration: "Длительность {d}",
    reason: {
      no_answer: "Клиент не ответил",
      busy: "Занято",
      cancelled: "Отменён до ответа",
      failed: "Ошибка линии",
      unknown: "Причина не определена",
    },
    stats: {
      title: "Итоги исходящих звонков",
      connected: "Соединено",
      fromCrm: "Из кнопки CRM: {n}, соединено {c}",
      empty: "Исходящих за период нет",
    },
  },

  ownerBot: {
    title: "Telegram-бот руководителя",
    subtitle: "Личные отчёты и мгновенные сигналы только для руководителя бизнеса.",
    notConfigured: "Бот ещё не настроен на сервере. Обратитесь в службу Miko.",
    noPhone: "Номер руководителя не указан. Его вносит администратор Miko: обратитесь в поддержку.",
    phone: "Номер руководителя",
    phoneHint: "Подключиться сможет только владелец этого номера в Telegram.",
    connect: "Подключить Telegram",
    connecting: "Создаём ссылку…",
    linkReady: "Ссылка для подключения (действует 15 минут, одноразовая)",
    open: "Открыть в Telegram",
    copy: "Копировать",
    copied: "Скопировано",
    linkSteps: "Откройте ссылку на телефоне руководителя, нажмите «Старт» и отправьте свой номер кнопкой в боте.",
    devices: "Подключённые устройства",
    noDevices: "Пока никто не подключён.",
    linkedAt: "подключено",
    sendReport: "Отчёт сейчас",
    reportSent: "Отчёт отправлен",
    disconnect: "Отключить",
    disconnectConfirm: "Отключить это устройство от бота?",
    times: "Время отчётов",
    evening: "Вечерний отчёт за сегодня",
    morning: "Утренний отчёт за вчера",
    quiet: "Не присылать мгновенные сообщения",
    quietFrom: "с",
    quietTo: "до",
    save: "Сохранить",
    saved: "Сохранено",
    attempts: "Попытки подключения",
    rejected: "Отклонено: номер не совпал",
    linked: "Подключено",
    whatTitle: "Что присылает бот",
    what1: "Каждый вечер и утро: обращения, звонки (включая пропущенные), выигранные и проигранные сделки, задачи (выполнено и просрочено).",
    what2: "Кто что сделал в программе и во сколько: важные изменения (удаления, настройки, сотрудники, интеграции).",
    what3: "Сразу: пропущенный входящий звонок, выигранная сделка, важное изменение.",
    what4: "Команды в боте: «Сегодня», «Вчера», «Настройки».",
  },
  notifCenter: {
    title: "Уведомления",
    empty: "Пока ничего нового",
    message: "Новое сообщение",
    lead: "Новый лид",
    call: "Пропущенный звонок",
    media: "Вложение",
    missedCallText: "Перезвоните клиенту",
    now: "сейчас",
    min: "мин",
    hour: "ч",
    clear: "Очистить",
    soundOn: "Включить звук",
    soundOff: "Выключить звук",
    unreadInbox: "Непрочитанных во «Входящих»",
  },
  topbar: {
    hotkeysHint: "переход по разделам, N — новая сделка",
    cmdGo: "Перейти", cmdFunnel: "Воронка", cmdTheme: "Переключить тему", cmdGroup: "Команды", recent: "Недавние",
    appearance: "Оформление", themeLight: "Светлая", themeDark: "Тёмная", themeAuto: "Авто",
    liteMode: "Упрощённый вид", liteHint: "Без размытия и анимаций: быстрее на слабых устройствах",
    searchNavigate: "выбрать",
    searchOpen: "открыть",
    search: "Поиск",
    searchPlaceholder: "Клиент, сделка или команда…",
    searchContacts: "Контакты",
    searchDeals: "Сделки",
    searchEmpty: "Ничего не найдено",
    searchHint: "Введите минимум 2 символа",
    create: "Создать",
    createDeal: "Новая сделка",
    createContact: "Новый контакт",
    funnels: "Воронки",
    close: "Закрыть",
    accountSettings: "Настройки аккаунта",
    settings: "Настройки",
    refresh: "Обновить",
    fullscreen: "Полный экран",
    exitFullscreen: "Выйти из полного экрана",
    roles: {
      owner: "Владелец",
      admin: "Админ",
      manager: "Менеджер",
      cashier: "Кассир",
      warehouse: "Кладовщик",
      viewer: "Наблюдатель",
    },
    lockScreen: "Заблокировать экран",
    hidePanel: "Скрыть верхнюю панель",
    showPanel: "Показать верхнюю панель",
    language: "Язык",
  },
  assets: {
    pageTitle: "Активы предприятия", pageSubtitle: "Оборудование, мебель и другие материальные ценности",
    addBtn: "Добавить актив", searchPlaceholder: "Название или инв. ID...",
    statTotal: "Всего активов", statUnit: "шт", statCost: "Первоначальная стоимость",
    statAccDep: "Амортизация", statBookValue: "Остаточная стоимость", currency: "сум",
    catAll: "Все категории",
    cat_furniture: "Мебель", cat_electronics: "Электроника",
    cat_computer: "Компьютеры и техника", cat_vehicle: "Транспорт",
    cat_equipment: "Производственное оборудование", cat_office: "Офисное оборудование", cat_other: "Прочее",
    statusAll: "Все статусы", statusActive: "Активный", statusDisposed: "Списан",
    status_active: "Активный", status_disposed: "Списан",
    thInventoryId: "Инв. ID", thName: "Наименование", thCategory: "Категория",
    thCost: "Перв. стоимость", thAccDep: "Амортизация", thBookValue: "Остаточная стоимость",
    thStatus: "Статус", thActions: "Действия",
    noItems: "Активы отсутствуют",
    deleteConfirm: "Удалить актив?",
    deleteHint: "Все записи амортизации также будут удалены.",
    deleteBtn: "Удалить", cancel: "Отмена", deleted: "Актив удалён",
    saved: "Сохранено", created: "Актив добавлен",
    formTitleNew: "Новый актив", formTitleEdit: "Редактировать актив",
    saveBtn: "Сохранить", backBtn: "Назад",
    sectionMain: "Основные данные", sectionFinance: "Финансовые данные",
    sectionDepreciation: "Амортизация", sectionHistory: "История амортизации",
    nameLabel: "Наименование", namePlaceholder: "Напр.: HP EliteBook 840",
    categoryLabel: "Категория", statusLabel: "Статус",
    descriptionLabel: "Описание", descriptionPlaceholder: "Дополнительная информация...",
    locationLabel: "Расположение / Отдел", locationPlaceholder: "Напр.: Финансовый отдел",
    responsibleLabel: "Ответственный", responsiblePlaceholder: "Ф.И.О.",
    purchaseDateLabel: "Дата покупки", purchaseCostLabel: "Первоначальная стоимость (сум)",
    disposalDateLabel: "Дата списания",
    disposalNoteLabel: "Причина списания", disposalNotePlaceholder: "Устарело, продано...",
    depMethodLabel: "Метод амортизации",
    depMethodNone: "Без амортизации", depMethodStraightLine: "Линейный метод",
    usefulLifeLabel: "Срок полезного использования (мес.)",
    monthlyDepLabel: "Ежемесячная амортизация", annualDepLabel: "Годовая амортизация",
    accDepLabel: "Накопленная амортизация", bookValueLabel: "Остаточная (балансовая) стоимость",
    noteLabel: "Примечание", notePlaceholder: "Заметка...",
    addDepBtn: "Начислить амортизацию",
    depModalTitle: "Начисление амортизации",
    depDateLabel: "Дата", depAmountLabel: "Сумма",
    depNoteLabel: "Примечание", depNotePlaceholder: "Напр.: Амортизация июнь 2026",
    depSaveBtn: "Записать", depAdded: "Амортизация начислена", depDeleted: "Запись удалена",
    suggestedDep: "Рекомендуемая сумма",
    depAmountRequired: "Укажите сумму",
    noDepHistory: "Записей амортизации нет",
    nameRequired: "Укажите наименование", categoryRequired: "Выберите категорию",
    thDepDate: "Дата", thDepAmount: "Сумма", thDepNote: "Примечание",
    catNone: "Без категории", catEmpty: "Категорий нет — добавьте в Настройках",
    statusNone: "Без статуса", statusEmpty: "Статусов нет — добавьте в Настройках",
    statusAllFilter: "Все статусы",
    depMethodStraightLineHint: "Равномерное списание",
    monthsSuffix: "мес.",
  },
  settingsAssets: {
    tabLabel: "Активы",
    title: "Настройки активов",
    catTitle: "Категории",
    catSubtitle: "Категории для группировки активов",
    statusTitle: "Статусы",
    statusSubtitle: "Для обозначения текущего состояния актива",
    addCatBtn: "Добавить категорию",
    addStatusBtn: "Добавить статус",
    namePlaceholder: "Название...",
    colorLabel: "Цвет",
    saveBtn: "Сохранить",
    cancelBtn: "Отмена",
    noCats: "Категорий нет",
    noStatuses: "Статусов нет",
    deleted: "Удалено",
    saved: "Сохранено",
    created: "Добавлено",
    dupError: "Такое название уже существует",
  },

  // ── CRM-specific pages ─────────────────────────────────────────────────────

  crmDashboard: {
    greeting: "Добро пожаловать, {name}!",
    loadError: "Не удалось загрузить данные",
    reload: "Обновить",
    kpiCalls: "Звонки сегодня",
    kpiContacts: "Новые контакты",
    kpiDeals: "Открытые сделки",
    kpiUnanswered: "Ожидают ответа",
    kpiSubToday: "сегодня",
    kpiSubTodayAdded: "добавлено сегодня",
    kpiSubTotal: "всего",
    kpiSubUnanswered: "без ответа",
    missedTitle: "Пропущенные звонки",
    missedEmpty: "Пропущенных звонков нет",
    allCalls: "Все звонки →",
    allTasks: "Все задачи →",
    overdueTitle: "Просроченные задачи",
    dueDate: "Срок:",
    activityTitle: "Последняя активность",
    activityEmpty: "Активности нет",
    funnelTitle: "Статистика воронки",
    funnelEmpty: "Воронок нет",
    noDeal: "Сделок нет",
    quickLinks: "Быстрые ссылки",
    addContact: "Добавить контакт",
    callHistory: "История звонков",
    incoming: "Входящий",
    outgoing: "Исходящий",
  },

  tasks: {
    title: "Задачи",
    newTask: "Новая задача",
    editTask: "Редактировать задачу",
    viewTask: "Просмотр задачи",
    close: "Закрыть",
    noStagesTitle: "Задачи",
    noStages: "Этапы не настроены. Перейдите в Настройки → Задачи.",
    search: "Поиск...",
    filter: "Фильтр",
    clearFilters: "Сбросить",
    allPriorities: "Все",
    allAssignees: "Все сотрудники",
    assignedToMe: "Назначено мне",
    createdByMe: "Созданные мной",
    overdue: "просрочено",
    totalNote: "Всего {total} — показаны первые {shown}",
    deleteConfirm: "Удалить задачу?",
    prioLow: "Низкий",
    prioMedium: "Средний",
    prioHigh: "Высокий",
    modalTitle: "Заголовок *",
    titlePlaceholder: "Что нужно сделать...",
    titleRequired: "Заголовок обязателен",
    description: "Описание / заметка",
    descPlaceholder: "Подробное описание...",
    priority: "Приоритет",
    stage: "Этап",
    assignee: "Ответственный",
    additionalAssignees: "Дополнительные ответственные",
    unassigned: "Не назначен",
    dueDate: "Срок",
    contact: "Контакт",
    contactSearch: "Поиск контакта...",
    contactNotFound: "Контакт не найден",
    contactCreate: "Создать контакт «{q}»",
    contactNew: "Новый контакт",
    contactName: "Имя",
    contactPhone: "Телефон",
    contactSave: "Создать",
    contactCreated: "Контакт создан и привязан",
    contactExisting: "Контакт с таким телефоном уже есть: {name}. Привязан",
    contactCreateError: "Не удалось создать контакт",
    linked: "Привязан",
    files: "Файлы",
    uploadFile: "+ Загрузить файл",
    uploading: "Загрузка...",
    tags: "Теги",
    tagsPlaceholder: "Добавить тег, нажмите Enter...",
    createdByPrefix: "Добавил:",
    historyTitle: "История изменений",
    histUnknownUser: "Неизвестно",
    histCreated: "создал задачу",
    histStageChanged: "изменил этап",
    histAssigned: "назначил ответственного",
    histUnassigned: "снял ответственного",
    histArchived: "архивировал",
    histUnarchived: "вернул из архива",
    histCompleted: "отметил как выполненную",
    archive: "Архив", archived: "Задача заархивирована", archiveEmpty: "В архиве нет задач",
    restore: "Восстановить", restored: "Задача восстановлена",
    assignedToPrefix: "Назначено:",
    cancel: "Отмена",
    save: "Сохранить",
    create: "Создать",
    saved: "Сохранено",
    created: "Создано",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    error: "Ошибка",
    viewKanban: "Канбан",
    viewDue: "По сроку",
    viewCalendar: "Календарь",
    viewDay: "День",
    viewWeek: "Неделя",
    viewMonth: "Месяц",
    noDateBucket: "Без даты",
    colOverdue: "Просроченные",
    colToday: "На сегодня",
    colTomorrow: "На завтра",
    colThisWeek: "На эту неделю",
    colNextWeek: "На след. неделю",
    completeTitle: "Завершить задачу",
    outcomeNotePlaceholder: "Результат: о чём договорились...",
    logToDeal: "Записать в историю сделки",
    createFollowUp: "Создать следующую задачу",
    followUpTitle: "Заголовок следующей задачи",
    followUpDue: "Срок следующей задачи",
    followUpAssignee: "Ответственный (необязательно)",
    completeConfirm: "Завершить",
    completeSuccess: "Задача завершена",
    markDone: "Я выполнил",
    noDoneStage: "Этап «Выполнено» не настроен",
    doneBadge: "Выполнено",
    archiveAction: "В архив",
    callTitle: "Позвонить",
    noDealAccess: "Нет доступа к этой сделке",
    authorTitle: "Автор: {name}",
    assigneeTitle: "Ответственный: {name}",
    viewAction: "Открыть",
    editAction: "Изменить",
    deleteAction: "Удалить",
  
    scopeMine: "Мои",
  },

  calls: {
    fPeriod: "Период",
    fStatus: "Статус",
    fDirection: "Направление",
    resetFilters: "Сбросить фильтры",
    title: "Звонки",
    all: "Все",
    incoming: "Входящие",
    outgoing: "Исходящие",
    missed: "Пропущенные",
    completed: "Выполненные",
    ringing: "Звонит",
    busy: "Занято",
    search: "Телефон или контакт...",
    dateFrom: "От",
    dateTo: "До",
    noResults: "Звонки не найдены",
    emptyHint: "Первые звонки появятся здесь",
    deleteSelected: "Удалить выбранные",
    selectAll: "Выбрать все",
    deselectAll: "Снять выбор",
    deleteConfirm: "Удалить {n} выбранных звонка?",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    thDate: "Дата / время",
    thDirection: "Направление",
    thPhone: "Телефон",
    thContact: "Контакт",
    thDuration: "Длительность",
    thStatus: "Статус",
    thRecord: "Запись",
    thExt: "Номер",
    statsTotal: "Всего",
    statsMissed: "Пропущено",
    statsDuration: "Общее время",
    linkContact: "Привязать",
    linked: "Привязан",
    viewContact: "Перейти к контакту",
    analytics: "Аналитика",
    noContact: "Без контакта",
    unknown: "Неизвестно",
  
    colExt: "Внутр. номер",
  
    secShort: "{n} с",
  },

  contacts: {
    thAssignee: "Ответственный",
    colAssignee: "Ответственный",
    colCreated: "Дата добавления",
    sortBy: "Сортировать",
    title: "Контакты",
    reminderOverdue: "Напоминание просрочено",
    newContact: "Новый контакт",
    search: "Имя, телефон, email...",
    noContacts: "Контакты не найдены",
    emptyHint: "Добавьте первый контакт",
    import: "Импорт",
    export: "Экспорт",
    columns: "Столбцы",
    deleteSelected: "Удалить ({n})",
    deleteConfirm: "Удалить {n} выбранных контактов?",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    importTitle: "Импорт CSV",
    importHint: "Загрузите CSV файл. Первая строка — названия столбцов.",
    importBtn: "Загрузить",
    importPreview: "Предпросмотр",
    importSave: "Сохранить",
    importCancel: "Отмена",
    importSuccess: "Добавлено {n} контактов",
    importError: "Ошибка импорта",
    exportSuccess: "Экспорт начат",
    selectFile: "Выберите CSV файл",
    mapping: "Сопоставление столбцов",
    analytics: "Аналитика",
    thName: "Имя",
    thPhone: "Телефон",
    thEmail: "Email",
    thSource: "Источник",
    thCreated: "Дата",
    thActions: "Действия",
    filterSource: "По источнику",
    allSources: "Все источники",
    yes: "Да",
    no: "Нет",
    fileAttached: "📎 Файл",
    columnsTitle: "Выбор столбцов",
    blocked: "Заблокирован",
    noResults: "Ничего не найдено",
    addFirst: "Добавьте первый контакт",
    add: "Добавить",
    duplicates: "Дубликаты",
    duplicatesTitle: "Найти повторяющиеся номера",
    normalizeAll: "Привести номера к формату +998",
    normalizeTitle: "Преобразовать все номера в формат +998",
    selectedN: "Выбрано: {n}",
    colContact: "Контакт",
    colPhone: "Телефон",
    colEmail: "Email",
    extraFields: "Дополнительные поля",
    exportError: "Ошибка экспорта",
    searchPlaceholder: "Имя, телефон, email...",
  },

  contactForm: {
    phoneInvalid: "Проверьте номер: например, +998 90 123 45 67",
    phoneHint: "Например: +998 90 123 45 67",
    newTitle: "Новый контакт",
    editTitle: "Редактировать контакт",
    back: "Назад",
    save: "Сохранить",
    saving: "Сохраняется...",
    delete: "Удалить",
    deleteConfirm: "Удалить контакт?",
    deleted: "Удалено",
    saved: "Сохранено",
    created: "Создано",
    loadError: "Ошибка загрузки",
    tabGeneral: "Основное",
    tabActivity: "История активности",
    tabDeals: "Сделки",
    name: "Имя *",
    namePlaceholder: "Полное имя...",
    nameRequired: "Имя обязательно",
    phone: "Телефон",
    phonePlaceholder: "+998 XX XXX XX XX",
    email: "Email",
    emailPlaceholder: "example@mail.com",
    source: "Источник",
    sourcePlaceholder: "Telegram, сайт...",
    notes: "Заметки",
    notesPlaceholder: "Заметки...",
    activityEmpty: "Активности нет",
    activityCall: "Звонок",
    activityNote: "Заметка",
    dealsEmpty: "Сделок нет",
    dealAdd: "Добавить сделку",
    error: "Произошла ошибка",
    cancel: "Отмена",
    blocked: "Заблокирован",
    reminder: "Напоминание",
    reminderOverdue: "Напоминание просрочено",
    block: "Заблокировать",
    unblock: "Разблокировать",
    tabFiles: "Файлы",
    tabSettings: "Настройки",
    activitySub: "Заметки, звонки и изменения",
    activityHint: "Сохраните контакт, чтобы добавлять записи",
    activityEmptyHint: "Напишите первую заметку",
  },

  inbox: {
    title: "Входящие",
    search: "Поиск...",
    tabUnanswered: "Без ответа",
    tabAccepted: "Принятые",
    tabClosed: "Закрытые",
    noUnanswered: "Неотвеченных сообщений нет",
    noUnansweredHint: "Новые сообщения появятся здесь",
    noClosed: "Закрытых чатов нет",
    noClosedHint: "Закрытые диалоги появятся здесь",
    noAccepted: "Принятых чатов нет",
    noConvsTotal: "Диалогов нет",
    selectConv: "Выберите диалог",
    selectConvHint: "Выберите диалог из списка слева",
    convCount: "{n} диалогов",
    sendPlaceholder: "Написать сообщение...",
    emailPlaceholder: "Написать email ответ...",
    notePlaceholder: "Написать внутреннюю заметку...",
    noteMode: "Режим внутренней заметки — видно только команде",
    deleteConv: "Удалить диалог",
    deleteMsg: "Удалить сообщение",
    markAnswered: "Отметить как отвеченное",
    markUnanswered: "Отметить как неотвеченное",
    closeConv: "Закрыть диалог",
    openConv: "Переоткрыть диалог",
    reassign: "Назначить",
    reassignTitle: "Назначить сотруднику",
    reassignNone: "Без назначения",
    labelTitle: "Метка",
    addLabel: "Добавить метку...",
    convInfo: "Информация",
    goToContact: "Перейти к контакту",
    createContact: "Создать контакт",
    loadError: "Ошибка загрузки",
    sendError: "Ошибка отправки",
    deleteError: "Ошибка удаления",
    analytics: "Аналитика",
    back: "Назад",
    noSubject: "(Без темы)",
    from: "От:",
    to: "Кому:",
    noAcceptedHint: "Принятые чаты появятся здесь",
    delete: "Удалить",
    msgNotFound: "Сообщение не найдено",
    noMsgs: "Нет сообщений",
    captionPlaceholder: "Добавить подпись (необязательно)...",
    allConvs: "Все разговоры",
    assignedAgent: "Ответственный",
    linkedContact: "Связанный контакт",
    contactName: "Имя *",
    cancel: "Отмена",
    save: "Сохранить",
    noData: "Нет данных",
  },

  dashboardHome: {
    showPeriod: "Показать: {p}",
    secOverview: "Сейчас в бизнесе",
    kpiOpenDeals: "Открытые сделки",
    kpiNewContacts: "Новые контакты сегодня",
    kpiUnanswered: "Без ответа",
    kpiUnansweredSub: "Сообщения во «Входящих»",
    kpiCalls: "Звонки сегодня",
    kpiNewContactsSub: "Добавлено сегодня",
    kpiCallsSub: "Входящие и исходящие",
    dateLocale: "ru-RU",
    loadError: "Не удалось загрузить данные", retry: "Повторить",
    overdueLabel: "Просроченные", overdueSubAlert: "Требует немедленного внимания", overdueSubOk: "Всё в срок",
    completedLabel: "Выполнено", completedSub: "На последнем этапе",
    activeLabel: "Активные задачи", activeSub: "Требуют выполнения",
    unassignedLabel: "Без ответственного", unassignedSubNoLeads: "Неразмеченные лиды",
    goalsTitle: "Цели", gaugeSum: "Сумма", gaugeDealCount: "Кол-во сделок",
    byEmployee: "По сотрудникам", donutSum: "Сумма", donutCount: "Кол-во",
    byManager: "По менеджерам", dealsCountLabel: "Сделки", sumLabel: "Сумма",
    dealSources: "Источники сделок", other: "Другое", total: "Всего", unit: "шт",
    secCalls: "Звонки",
    secCallsSub: "Входящие и исходящие, принятые и пропущенные",
    secTasks: "Задачи",
    secSales: "Продажи",
    pToday: "Сегодня",
    pWeek: "Неделя",
    pMonth: "Месяц",
    allEmployees: "Все сотрудники",
    noEmployee: "Без сотрудника",
    cTotal: "Всего звонков",
    cIn: "Входящие",
    cOut: "Исходящие",
    cMissed: "Пропущенные",
    cAvg: "Средняя длительность",
    cAnswered: "Принято {n}",
    cMissedN: "Пропущено {n}",
    cMissedPct: "{n}% от всех звонков",
    cTalk: "Общее время разговора: {t}",
    chartTitle: "Динамика звонков",
    legIn: "Входящие",
    legOut: "Исходящие",
    legMissed: "Пропущенные",
    empTitle: "По сотрудникам",
    thEmployee: "Сотрудник",
    thTotal: "Всего",
    thIn: "Вход.",
    thOut: "Исх.",
    thMissed: "Пропущ.",
    thTalk: "Разговор",
    noCalls: "За выбранный период звонков нет",
    callsLoadError: "Не удалось загрузить статистику звонков",
    openCalls: "Все звонки",
  
    cNoAnswerN: "Без ответа {n}",
  },

  funnel: {
    journeyAnalytics: "Путь лидов",
    newDeal: "Новая сделка",
    addQuick: "Быстро добавить",
    dealSearch: "Сделка, контакт или номер...",
    sortLabel: 'Сортировка',
    sortManual: 'Обычный (порядок вручную)',
    sortCreatedAsc: 'Старые - новые (по дате создания)',
    sortCreatedDesc: 'Новые - старые (по дате создания)',
    sortUpdatedAsc: 'Старые - новые (по изменению статуса)',
    sortUpdatedDesc: 'Новые - старые (по изменению статуса)',
    sortTitleAsc: 'А - Я',
    sortTitleDesc: 'Я - А',
    dateFrom: 'Дата создания — от',
    dateTo: 'Дата создания — до',
    showClosed: 'Закрытые',
    bulkSelectTitle: 'Массовый выбор',
    select: 'Выбрать',
    selectCancel: 'Отменить',
    archiveBtn: 'Архив',
    statsBtn: 'Статистика',
    noDeals: "Сделок нет",
    totalDeals: "сделок",
    totalValue: "общая сумма",
    loadError: "Ошибка загрузки",
    deleteConfirm: "Удалить сделку?",
    deleted: "Удалено",
    edit: "Редактировать",
    newLead: "Новая сделка",
    leadNameLabel: "Имя клиента *",
    contactOpt: "Контакт (необязательно)",
    noContact: "— Без контакта",
    createContact: "+ Создать контакт",
    contactNamePh: "Имя *",
    contactPhonePh: "Телефон",
    contactEmailPh: "Email",
    contactCreated: "Контакт создан",
    contactExists: "Такой контакт уже существует",
    responsibleLabel: "Ответственный",
    unassigned: "— Не назначен",
    notesPlaceholder: "Дополнительная информация...",
    addBtn: "Добавить",
    titleRequired: "Название обязательно",
    searchPlaceholder: "Поиск...",
    noFunnel: "Воронка не найдена",
    stagePlaceholder: "Название этапа...",
    moveTitle: "Сумма сделки",
    moveHint: "Введите сумму (необязательно)",
    moveSave: "Переместить",
    moveCancel: "Отмена",
    export: "Экспорт",
    import: "Импорт",
    exportDone: "Excel загружен",
    exportError: "Ошибка экспорта",
    importTitle: "Импорт Excel",
    importDone: "Импорт завершён!",
    importCreated: "лидов добавлено",
    importSkipped: "пропущено",
    importFormat: "Столбцы Excel (.xlsx):",
    importHint: "Первая строка — названия столбцов. Обязателен только столбец «Sarlavha».",
    downloadTemplate: "Скачать шаблон",
    templateError: "Не удалось скачать шаблон",
    importBtn: "Импортировать",
    importError: "Ошибка импорта",
    onlyXlsx: "Принимается только файл .xlsx",
    dropXlsx: "Перетащите файл Excel (.xlsx) сюда",
    orClick: "или нажмите и выберите",
    clear: "Очистить",
    cancel: "Отмена",
    close: "Закрыть",
    dealsCount: "{n} сделок",
    dealsCountFiltered: "{shown} из {total}",
    viewActive: "Активные",
    viewClosed: "Закрытые",
    allSources: "Все источники",
    noSource: "Без источника",
    cfAll: "{name}: все",
    cfNone: "Без: {name}",
    chipSearch: "«{q}»",
    chipDates: "{from} — {to}",
    bulkMoved: "Лидов перенесено: {n}",
    bulkTransferred: "Лидов передано: {n}",
    bulkDeleted: "Лидов удалено: {n}",
    bulkArchived: "Лидов архивировано: {n}",
    bulkAssigned: "Назначено лидов: {n}",
    bulkSkipped: ", пропущено: {n}",
  },

  deals: {
    moveStage: "Этап", moveStageTitle: "Перенести в этап", showMore: "Показать ещё: {count}",
    nextStep: "Следующий шаг",
    noNextStep: "Нет следующего шага: поставьте задачу, чтобы сделка не потерялась",
    setNextStep: "Поставить задачу",
    back: "Назад",
    newDeal: "Новая сделка",
    editDeal: "Редактировать сделку",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    deleteConfirm: "Удалить сделку?",
    deleted: "Удалено",
    saved: "Сохранено",
    created: "Создано",
    loadError: "Ошибка загрузки",
    titleLabel: "Заголовок *",
    titlePlaceholder: "Название сделки...",
    titleRequired: "Заголовок обязателен",
    contact: "Контакт",
    value: "Сумма",
    currency: "Валюта",
    stage: "Этап",
    moveToFunnel: "Перенести в другую воронку",
    moveFunnelLabel: "Воронка",
    moveFunnelPlaceholder: "Выберите воронку...",
    moveStagePlaceholder: "Выберите этап...",
    moveReasonLabel: "Причина (необязательно)",
    moveReasonPlaceholder: "Почему лид переносится в другую воронку...",
    moveSubmit: "Перенести",
    moveSuccess: "Перенесено в другую воронку",
    assignee: "Ответственный",
    dueDate: "Срок",
    notes: "Заметка",
    notesPlaceholder: "Заметка...",
    wonTitle: "Сделка выиграна",
    lostTitle: "Сделка проиграна",
    wonReason: "Причина или комментарий (необязательно)",
    lostReason: "Причина проигрыша (необязательно)",
    reasonPlaceholder: "Причина...",
    confirm: "Подтвердить",
    activitySub: "Заметки и изменения",
    notePlaceholder: "Напишите заметку...",
    activityEmpty: "Нет активности",
    activityHint: "Напишите первую заметку",
    noteTab: "Заметка",
    communicationTab: "Контакт",
    contactTypeCall: "Звонок",
    contactTypeMessage: "Сообщение",
    contactTypeMeeting: "Встреча",
    durationLabel: "мин",
    outcomeInterested: "Заинтересован",
    outcomeThinking: "Думает",
    outcomeDeclined: "Отказ",
    outcomeNoAnswer: "Недозвон",
    outcomeOther: "Другое",
  },

  inboxAnalytics: {
    title: "Аналитика входящих",
    back: "Входящие",
    tabGeneral: "Общее",
    tabAgents: "Сотрудники",
    preset7d: "7 дней",
    presetMonth: "Этот месяц",
    presetPrevMonth: "Прошлый месяц",
    presetQuarter: "Этот квартал",
    presetCustom: "Произвольный",
    apply: "Применить",
    compare: "Сравнить с прошлым периодом",
    totalConvs: "Всего диалогов",
    unanswered: "Без ответа",
    closed: "Закрыто",
    avgResponse: "Ср. время ответа",
    firstResponse: "Первый ответ",
    resolutionRate: "Решено:",
    prevPeriod: "прошлый период:",
    dailyChart: "Диалоги по дням",
    dayCount: "дней",
    comparison: "Сравнение периодов",
    total: "Всего",
    closedPct: "Закрыто %",
    byChannel: "По каналам",
    agentStats: "Агенты",
    labelStats: "Метки",
    noData: "Данных нет",
    noLabels: "Меток нет",
    agentReport: "Отчёт по сотрудникам",
    exportCsv: "Скачать CSV",
    thAgent: "Сотрудник",
    thTotal: "Диалоги",
    thClosed: "Закрыто",
    thClosedPct: "Закрыто %",
    thAvgResp: "Ср. ответ",
    thCalls: "Звонки",
    loadError: "Не удалось загрузить",
  },

  contactAnalytics: {
    title: "Аналитика контактов",
    back: "Контакты",
    preset30d: "30 дней",
    presetMonth: "Этот месяц",
    preset90d: "90 дней",
    presetCustom: "Произвольный",
    apply: "Применить",
    periodNew: "Новые контакты за период",
    totalAll: "Всего контактов",
    allTime: "За всё время",
    dailyChart: "Новые контакты по дням",
    byChannel: "По каналам (через «Входящие»)",
    byOperator: "По операторам",
    noPhone: "Телефонов нет",
    noData: "Данных нет",
    loadError: "Не удалось загрузить",
  },

  leadJourney: {
    title: "Путь лидов",
    back: "Воронки",
    preset30d: "30 дней",
    presetMonth: "Этот месяц",
    preset90d: "90 дней",
    presetCustom: "Свой период",
    apply: "Применить",
    contactsWidgetTitle: "Контакты за период",
    uniqueLeadsContacted: "уникальных лидов с контактом",
    byType: "По типу",
    interactedTitle: "Клиенты, с которыми был контакт",
    calledTitle: "Клиенты, с которыми поговорили",
    calledHint: "Дозвонились и пообщались",
    sourceFunnelChange: "Перевод между воронками",
    sourceStageChange: "Перевод между этапами",
    sourceComment: "Комментарий",
    sourceInbox: "Сообщение (Telegram и др.)",
    transitionsWidgetTitle: "Переходы между воронками",
    transitionsEmpty: "За этот период переходов не было",
    snapshotWidgetTitle: "Текущий срез — по воронкам/этапам",
    loadError: "Не удалось загрузить",
  },

  sheets: {
    title: "Google Таблицы",
    subtitle: "Лиды из таблицы (например, куда Meta Lead Ads складывает заявки) сами попадают в CRM: каждая новая строка становится сделкой.",
    add: "Подключить таблицу",
    empty: "Таблицы не подключены",
    paused: "на паузе",
    destination: "Куда попадают лиды",
    lastSync: "Проверено",
    neverSynced: "Ещё не проверялась",
    totalImported: "создано сделок: {n}",
    rows: "строк в таблице: {n}",
    syncNow: "Проверить сейчас",
    pause: "Поставить на паузу",
    resume: "Возобновить",
    edit: "Изменить",
    remove: "Отключить",
    removeConfirm: "Отключить «{name}»? Уже созданные сделки останутся.",
    removed: "Таблица отключена",
    imported: "Новых сделок: {n}",
    nothingNew: "Новых строк нет",
    error: "Что-то пошло не так",
    connected: "Таблица подключена. Новые строки будут появляться в CRM сами",
    connectedImported: "Таблица подключена, загружено сделок: {n}",
    saved: "Сохранено",
    howTitle: "Как это работает",
    "how1": "CRM заглядывает в таблицу раз в 2 минуты и берёт только новые строки.",
    "how2": "Одна строка превращается в контакт и сделку в выбранной воронке и этапе. Повторов не будет: каждая строка читается один раз.",
    "how3": "Строки без телефона и без почты пропускаются.",
    "how4": "Ответы на вопросы формы попадают в комментарий сделки, их можно разложить по полям в разделе «Поля лидов».",
    addTitle: "Подключить Google Таблицу",
    editTitle: "Настройки таблицы",
    accessTitle: "Сначала откройте доступ к таблице",
    accessHint: "В таблице нажмите «Настройки доступа» → «Все, у кого есть ссылка» → роль «Читатель». CRM только читает таблицу и ничего в ней не меняет.",
    link: "Ссылка на таблицу",
    check: "Проверить",
    tabHint: "Скопируйте ссылку из адресной строки, когда открыта нужная вкладка таблицы: CRM читает именно её.",
    found: "Таблица доступна. Строк с данными: {n}",
    name: "Название источника",
    namePh: "Например, Meta: ноябрь",
    defaultName: "Google Таблица",
    funnel: "Воронка",
    stage: "Этап",
    source: "Источник сделки",
    sourceHint: "Подпись источника у сделки (например, Facebook или Instagram).",
    columns: "Какие колонки что значат",
    none: "— нет —",
    colIdHint: "Уникальный номер строки: по нему CRM не создаст дубль",
    restHint: "Остальные колонки (ответы на вопросы формы, реклама, платформа) попадут в комментарий сделки.",
    needContact: "Выберите колонку с телефоном или почтой",
    col: {
      name: "Имя",
      phone: "Телефон",
      email: "Почта",
      id: "Номер строки (id)",
      createdAt: "Время заявки",
    },
    importExisting: "Загрузить и строки, которые уже есть в таблице ({n})",
    importExistingHint: "Если не отмечать, в CRM попадут только строки, добавленные после подключения.",
    cancel: "Отмена",
    connect: "Подключить",
    save: "Сохранить",
    meta: {
      enable: "Сообщать Meta об итогах: «Выиграно» и «Проиграно»",
      enableHint: "Реклама научится находить людей, похожих на тех, кто покупает (Conversions API for CRM). Берётся id лида Meta из колонки id.",
      dataset: "ID набора данных (dataset)",
      token: "Токен доступа",
      tokenSaved: "•••• сохранён (введите новый, чтобы заменить)",
      tokenHint: "Оба значения создаёт администратор рекламного кабинета в «Менеджере событий» Meta: набор данных → Настройки → Conversions API → «Создать токен». Токен хранится только на сервере и не показывается.",
      wonEvent: "Событие для «Выиграно»",
      lostEvent: "Событие для «Проиграно»",
      testCode: "Код тестового события (необязательно)",
      testCodeHint: "Пока код указан, события идут во вкладку «Тестовые события» и не попадают в статистику рекламы. Для рабочей отправки оставьте поле пустым.",
      check: "Проверить соединение",
      ok: "Соединение есть: {name}",
      checkLater: "Проверить соединение можно после сохранения: откройте источник кнопкой «Изменить».",
      badge: "Meta: итоги",
    },
    err: {
      bad_url: "Это не ссылка на Google Таблицу",
      private: "Нет доступа к таблице. Включите «Все, у кого есть ссылка» с ролью «Читатель» и нажмите «Проверить» ещё раз.",
      bad_tab: "Такой вкладки в таблице нет. Откройте нужную вкладку и скопируйте ссылку заново.",
      not_found: "Таблица не найдена. Проверьте ссылку.",
      empty: "Таблица пустая",
      network: "Не удалось связаться с Google. Попробуйте позже.",
      failed: "Не удалось проверить таблицу",
    },
  },
  edu: {
    io: {
      import: "Импорт",
      export: "Экспорт",
      title: "Импорт учеников из Excel",
      step1: "Скачайте шаблон",
      step1Hint: "Сотрудники заполняют его: один ученик — одна строка. На листе «Инструкция» всё объяснено, группы выбираются из списка.",
      template: "Скачать шаблон",
      step2: "Загрузите заполненный файл",
      pick: "Выбрать файл",
      change: "Выбрать другой",
      drop: "Перетащите .xlsx сюда или выберите файл",
      check: "Проверить",
      importN: "Загрузить: {n}",
      cancel: "Отмена",
      close: "Закрыть",
      checked: "Можно загрузить: {ok}. Нужно исправить или пропустить: {bad}. Ничего ещё не сохранено.",
      empty: "В файле нет заполненных строк",
      doneTitle: "Импорт завершён",
      created: "добавлено",
      skipped: "пропущено",
      problems: "Строки с проблемами: {n}",
      row: "стр. {n}",
      onlyXlsx: "Нужен файл .xlsx",
      templateError: "Не удалось скачать шаблон",
      importError: "Не удалось загрузить файл",
      exportError: "Не удалось выгрузить файл",
      err: { no_name: "не указано ФИО", no_group: "не указана группа", group_unknown: "нет такой группы", group_archived: "группа в архиве", bad_date: "неверная дата", bad_number: "неверное число", bad_lang: "язык должен быть uz или ru", duplicate: "такой ученик уже есть в группе", group_full: "группа заполнена", bad_package: "не указано число занятий в пакете", too_many_rows: "слишком много строк (до 1000)", failed: "не удалось сохранить" },
    },
    deal: {
      enroll: "Записать в группу",
      enrollAnother: "Записать в ещё одну группу",
      enrolled: "{group}: осталось {n}",
      openStudents: "Открыть учеников",
      noGroups: "Групп ещё нет. Сначала создайте группу в разделе «Обучение».",
      toGroups: "К группам",
      linkHint: "Имя, телефон и контакт взяты из сделки, ничего вводить заново не нужно. Оплату вносите в карточке ученика.",
      openDeal: "Сделка",
      openContact: "Контакт",
    },
    title: "Обучение",
    add: "Добавить",
    all: "Все",
    archive: "В архив",
    restore: "Вернуть",
    cancel: "Отмена",
    close: "Закрыть",
    copied: "Скопировано",
    copy: "Копировать",
    date: "Дата",
    delete: "Удалить",
    edit: "Изменить",
    end: "Конец",
    start: "Начало",
    group: "Группа",
    loading: "Загрузка…",
    note: "Заметка",
    save: "Сохранить",
    saved: "Сохранено",
    d1: "Пн",
    d2: "Вт",
    d3: "Ср",
    d4: "Чт",
    d5: "Пт",
    d6: "Сб",
    d7: "Вс",
    dl1: "Понедельник",
    dl2: "Вторник",
    dl3: "Среда",
    dl4: "Четверг",
    dl5: "Пятница",
    dl6: "Суббота",
    dl7: "Воскресенье",
    status: {
      present: "Пришёл",
      late: "Опоздал",
      absent: "Не пришёл",
      excused: "Уважительная причина",
    },
    st: {
      active: "Учится",
      frozen: "Заморожен",
      left: "Выбыл",
      completed: "Закончил",
    },
    method: {
      cash: "Наличные",
      card: "Карта",
      transfer: "Перевод",
      other: "Другое",
    },
    tabs: {
      today: "Сегодня",
      groups: "Группы",
      students: "Ученики",
      debts: "Долги",
      report: "Посещаемость",
      settings: "Настройки",
    },
    sum: {
      students: "учеников учится",
      lessonsToday: "занятий сегодня отмечено",
      debt: "долг ({n} уч.)",
      low: "заканчивается пакет",
    },
    today: {
      prev: "Предыдущий день",
      next: "Следующий день",
      goToday: "К сегодняшнему дню",
      noLessons: "На этот день занятий нет",
      markAll: "Все пришли",
      save: "Сохранить",
      saved: "Посещаемость сохранена",
      progress: "Отмечено {m} из {n}",
      notMarked: "Не отмечено",
      held: "Проведено",
      cancelled: "Отменено",
      cancel: "Отменить занятие",
      reopen: "Вернуть",
      cancelPrompt: "Причина отмены (необязательно):",
      readonly: "Правка закрыта: отметки можно менять только за последние {n} дн.",
      extra: "доп. занятие",
      addLesson: "Доп. занятие",
      left: "осталось {n}",
      debt: "долг",
      noStudents: "В группе нет учеников",
    },
    groups: {
      new: "Новая группа",
      edit: "Изменить группу",
      name: "Название",
      course: "Курс",
      teacher: "Преподаватель",
      room: "Кабинет",
      color: "Цвет",
      schedule: "Расписание",
      day: "День",
      addSlot: "Добавить день",
      startDate: "Начало курса",
      endDate: "Конец курса",
      capacity: "Мест в группе",
      capacityHint: "0 — без ограничения",
      packageLessons: "Занятий в пакете",
      packagePrice: "Цена пакета",
      showArchived: "Показать архивные",
      archiveConfirm: "Отправить группу «{name}» в архив? Занятия по ней перестанут создаваться.",
      none: "Групп пока нет",
      studentsCount: "{n} уч.",
      frozenCount: "{n} заморожено",
      packageShort: "пакет {n} занятий · {price}",
    },
    students: {
      new: "Новый ученик",
      name: "Имя",
      phone: "Телефон",
      parent: "Родитель",
      parentName: "Имя родителя",
      parentPhone: "Телефон родителя",
      parentLang: "Язык сообщений родителю",
      langDefault: "По умолчанию",
      joined: "Дата записи",
      withPackage: "Записать с пакетом занятий",
      lessons: "Занятий",
      price: "Цена",
      paid: "Оплачено",
      contactHint: "Если указан телефон, в CRM автоматически создаётся карточка контакта.",
      search: "Имя или телефон",
      allGroups: "Все группы",
      activeFrozen: "Учатся и в заморозке",
      anyBalance: "Любой баланс",
      onlyDebt: "Только с долгом",
      onlyLow: "Пакет заканчивается",
      needGroup: "Сначала создайте группу на вкладке «Группы».",
      none: "Учеников нет",
      leftLessons: "занятий осталось",
      debt: "долг",
      credit: "переплата",
      leftAt: "Выбыл",
      balanceHint: "Куплено {bought}, списано {used}, корректировка {adjust}",
      packages: "Пакеты и оплаты",
      addPackage: "Новый пакет",
      addPayment: "Оплата",
      noPackages: "Пакетов нет",
      packageLine: "Пакет на {n} занятий",
      amount: "Сумма",
      method: "Способ",
      deletePaymentConfirm: "Удалить этот платёж?",
      deletePackageConfirm: "Удалить пакет вместе с его оплатами?",
      telegram: "Telegram родителя",
      noBot: "Бот не подключён: Настройки → Обучение.",
      tgLinked: "Родитель подключён",
      tgMuted: "уведомления отключены родителем",
      tgNotLinked: "Родитель ещё не подключился: отправьте ему ссылку",
      remindDebt: "Напомнить о долге",
      remindLow: "Напомнить об оплате",
      reminded: "Напоминание отправлено",
      history: "История посещений",
      noHistory: "Занятий ещё не было",
      status: "Статус",
      transfer: "Группа",
      transferConfirm: "Перевести ученика в другую группу?",
      adjust: "Корректировка занятий",
      adjustHint: "+N или −N: компенсация, перенос и т. п.",
      leftReasonPrompt: "Причина (необязательно):",
      delete: "Удалить ученика",
      deleteConfirm: "Удалить ученика? Это возможно, только если по нему нет отметок посещаемости.",
    },
    debts: {
      total: "Общий долг",
      count: "Учеников: {n}",
      none: "Долгов и заканчивающихся пакетов нет",
      remind: "Напомнить",
    },
    report: {
      from: "С",
      to: "По",
      rate: "Посещаемость",
      lessons: "проведено занятий: {n}",
      none: "За этот период отметок нет",
    },
    settings: {
      open: "Настройки",
      charge: "Что списывает занятие из пакета",
      chargeHint: "Отмеченные статусы уменьшают остаток занятий у ученика. Остаток считается заново, поэтому изменение правила пересчитает все балансы.",
      rules: "Правила и пороги",
      lowBalance: "Предупреждать, когда осталось занятий",
      lowBalanceHint: "0 — не предупреждать",
      absentStreak: "Пропусков подряд для задачи менеджеру",
      absentStreakHint: "0 — не создавать задачу",
      assignee: "Кому ставить задачу",
      assigneeAuto: "Создателю группы",
      editDays: "Сколько дней назад ресепшн может править отметки",
      editDaysHint: "Владелец и администратор могут править любой день.",
      defaultPackage: "Пакет по умолчанию",
      defaultPackageHint: "Подставляется, если в группе пакет не задан.",
      regional: "Время и язык",
      timezone: "Часовой пояс",
      parentLang: "Язык сообщений родителям",
      bot: "Telegram-бот для родителей",
      botHint: "У каждого учебного центра свой бот: родители видят его название и аватар.",
      botStep1: "В Telegram откройте @BotFather и отправьте /newbot.",
      botStep2: "Придумайте название и имя бота (например, «Rustamov Academy» и rustamov_academy_bot).",
      botStep3: "Скопируйте полученный токен и вставьте сюда.",
      botConnect: "Подключить",
      botConnected: "Бот подключён",
      botDisconnect: "Отключить",
      botDisconnectConfirm: "Отключить бота? Родители перестанут получать сообщения.",
      notify: "Уведомления родителям",
      notifyHint: "Сообщения уходят только тем родителям, кто подключился по ссылке из карточки ученика.",
      notifyEnabled: "Отправлять уведомления",
      notifyNeedBot: "Сначала подключите бота.",
      onAbsent: "Когда ученик не пришёл",
      onLate: "Когда ученик опоздал",
      onLow: "Когда пакет заканчивается",
      templates: "Тексты сообщений",
      templatesHint: "Оставьте пустым, чтобы использовать стандартный текст. Можно использовать: {vars}",
    },
    tpl: {
      absent: "Не пришёл",
      late: "Опоздал",
      low: "Заканчивается пакет",
      debt: "Долг",
    },
  },

  bottomNav: {
    more: "Ещё", label: "Основная навигация",
    education: "Обучение",
    dashboard: "Главная",
    contacts: "Контакты",
    tasks: "Задачи",
    inbox: "Входящие",
    calls: "Звонки",
    reviews: "Отзывы",
    funnels: "Воронки",
    analytics: "Аналитика",
  },

    forgotPassword: "Забыли пароль?",
  
    loading: "Загрузка...",
  
    serverText: { unknownPhone: "Неизвестный ({phone})", 
    unknown: "Неизвестный",
  
    assignedTo: "Назначено: {name}",
  
    bulk: " (массово)",
  
    archived: "Архивировано",
  
    unarchived: "Возвращено из архива",
  
    unassigned: "Назначение снято",
  
    claimed: "Взял(а) на себя",
  },
  };
